// This file is auto-generated by @hey-api/openapi-ts

import { type DefaultError, type InfiniteData, infiniteQueryOptions, queryOptions, type UseMutationOptions } from '@tanstack/react-query';

import { client } from '../client.gen';
import { acceptAll, acceptProposal, addAgentPin, addAgentTeamMember, addAgentUserMember, addBrandTeamMember, addBrandUserMember, addConnectorTeamMember, addConnectorUserMember, addDataSourceTeamMember, addDataSourceUserMember, addFlowTeamMember, addFlowUserMember, addMicroAppTeamMember, addMicroAppUserMember, addNote, addPin, addSkillTeamMember, addSkillUserMember, addSpaceConnector, addSpaceResource, addSpaceTeamMember, addSpaceUserMember, addWebsiteUrl, adminConnectorAudit, adminCreateModel, adminCreateUser, adminDeleteModel, adminDeleteUser, adminDisableConnector, adminEnableConnector, adminGetConnectorPolicy, adminGetModel, adminGetUsage, adminListConnectors, adminListModelReferences, adminListModels, adminListTierDefaults, adminListUsers, adminReassignModel, adminSuggestModel, adminUpdateConnectorPolicy, adminUpdateModel, adminUpdateTierDefault, adminUpdateUser, agentDeleteImpact, analyzeImport, attachmentStatus, attachSkillsToAgent, authorize, authorizeFlow, cancelFlowRun, cancelOperation, chatAccessShareLink, chatCreateSession, chatCreateShareLink, chatDeactivateShareLink, chatDeleteSession, chatGetSession, chatGetSessionSharing, chatListSessions, chatListSharedWithMe, chatRemoveShare, chatShareWithUser, chatStreamMessage, chatUpdateSession, chatUploadAttachments, clearAgentMemory, clearAllAgentMemory, clearConnectorSecret, clearCredential, clearExtensionPreference, clearMyConnectorCredential, correlateContentFilterEvent, createAgent, createApiKey, createBrand, createBudgetConfig, createConnector, createConnectorFromTemplate, createConnectorInstance, createDataSource, createFlow, createFlowTrigger, createImport, createSidebarSection, createSkill, createSpace, deleteAgent, deleteAgentMemory, deleteBrand, deleteBrandTemplate, deleteBudgetConfig, deleteConnector, deleteDataSource, deleteFile, deleteFlow, deleteFlowTrigger, deleteImport, deleteMicroApp, deleteSidebarSection, deleteSkill, deleteSpace, deleteSpaceFile, deleteWikiFile, detachSkillFromAgent, disconnect, dismissAll, dismissDuplicate, downloadBrandTemplate, downloadScreenshot, editWithAi, extractBrand, forkSession, getAgent, getAgentMembers, getAttachmentBindings, getAttachmentLimits, getBrand, getBrandMembers, getBrandTemplateThumbnail, getCompanyProfile, getConnectorDetail, getConnectorMembers, getConnectorPolicy, getContentFilterAnalytics, getCurrentUserInfo, getDataSource, getDataSourceMembers, getExportCapabilities, getExtension, getFeedback, getFileDownloadUrl, getFileMarkdown, getFlow, getFlowAuthorization, getFlowMembers, getFlowRun, getGovernanceOverview, getImport, getLicenseDetail, getLicenseStatus, getLogo, getMicroApp, getMicroAppContent, getMicroAppInfo, getMicroAppMembers, getMyOnedrive, getMySpend, getPersonalSpace, getPlatformCosts, getPreferences, getSkill, getSkillMembers, getSpace, getSpaceHub, getSpaceMembers, getSpaceSidebar, getUnreadCount, getUsageByUser, getWikiFile, giveSpaceAccess, googleDriveDownloadDocument, importSkills, listActiveOperations, listAgentConnectors, listAgentMemories, listAgentPins, listAgents, listAgentSkills, listAllAuthorizations, listAllFeedback, listApiKeys, listAvailable, listBrands, listBrandTemplates, listBudgetConfigs, listConnectorIntegrations, listConnectors, listConnectorTemplates, listConnectorTools, listContentFilterEvents, listDataSources, listDriveItems, listDuplicates, listExtensionConsent, listExtensions, listFiles, listFlowRuns, listFlows, listFlowTriggers, listImports, listInbox, listMerges, listMessageAttachments, listMessages, listMicroApps, listMyAuthorizations, listMyConnectorConnections, listMyJobs, listNotifications, listPins, listQuickActions, listRecentActivities, listSessionDocuments, listSiteDrives, listSkillCategories, listSkills, listSpaceActivities, listSpaceConnectors, listSpaceDocuments, listSpaceKnowledge, listSpaceResources, listSpaces, listSpaceSharedChats, listTeams, listTools, listUserFacingTierDefaults, listWikiFiles, listWorkers, markAllRead, markDraftApplied, markNotificationRead, mergePages, modelsListModels, moveSidebarSpace, type Options, platformCreateOauthClient, platformDeleteOauthClient, platformListOauthClients, platformUpdateOauthClient, previewCompanyContext, previewMerge, publishMicroApp, refreshConnectorTools, regenerateWebhookSecret, rejectProposal, removeAgentPin, removeAgentTeamMember, removeAgentUserMember, removeBrandTeamMember, removeBrandUserMember, removeConnectorTeamMember, removeConnectorUserMember, removeDataSourceTeamMember, removeDataSourceUserMember, removeFlowTeamMember, removeFlowUserMember, removeMicroAppTeamMember, removeMicroAppUserMember, removePin, removeSkillTeamMember, removeSkillUserMember, removeSpaceAccess, removeSpaceConnector, removeSpaceDocument, removeSpaceResource, removeSpaceTeamMember, removeSpaceUserMember, reorderPins, reorderSidebarSections, reorderSpaceResources, republishMicroApp, resolveSharepointUrl, resumeFlowRun, resumePlatform, revokeApiKey, revokeMyAuthorization, saveWikiFile, searchDriveItems, searchFiles, searchSites, searchUsers, setAgentConnectors, setConnectorSecret, setExtensionPreference, setMyConnectorCredential, setSessionSpaceShare, setSpaceConnectorSkills, sharepointCountFolderItems, sharepointDownloadDocument, shareSpaceDocument, skillDeleteImpact, spaceAccessImpact, spacesCreateQuickAction, spacesDeleteQuickAction, spacesUpdateQuickAction, startConnectorOauth, streamAgent, streamFlowRun, submitFeedback, suspendPlatform, syncDataSource, toggleExtension, undoMerge, updateAgent, updateAgentSkill, updateAgentTeamMember, updateAgentUserMember, updateBrand, updateBrandTeamMember, updateBrandUserMember, updateBudgetConfig, updateConnector, updateConnectorTeamMember, updateConnectorTool, updateConnectorUserMember, updateCredential, updateDataSource, updateDataSourceTeamMember, updateDataSourceUserMember, updateExtension, updateFeedbackStatus, updateFlow, updateFlowTeamMember, updateFlowTrigger, updateFlowUserMember, updateLicense, updateMicroApp, updateMicroAppTeamMember, updateMicroAppUserMember, updateNote, updatePreferences, updateSidebarSection, updateSkill, updateSkillTeamMember, updateSkillUserMember, updateSpace, updateSpaceConnector, updateSpaceResource, updateSpaceTeamMember, updateSpaceUserMember, updateTeamAccess, updateUserSettings, uploadBrandLogo, uploadBrandTemplate, uploadFiles, uploadFlowFiles, uploadImport, uploadLogo, uploadSpaceFiles, upsertCompanyProfile } from '../sdk.gen';
import type { AcceptAllData, AcceptAllError, AcceptAllResponse, AcceptProposalData, AcceptProposalError, AcceptProposalResponse, AddAgentPinData, AddAgentPinError, AddAgentPinResponse, AddAgentTeamMemberData, AddAgentTeamMemberError, AddAgentTeamMemberResponse, AddAgentUserMemberData, AddAgentUserMemberError, AddAgentUserMemberResponse, AddBrandTeamMemberData, AddBrandTeamMemberError, AddBrandTeamMemberResponse, AddBrandUserMemberData, AddBrandUserMemberError, AddBrandUserMemberResponse, AddConnectorTeamMemberData, AddConnectorTeamMemberError, AddConnectorTeamMemberResponse, AddConnectorUserMemberData, AddConnectorUserMemberError, AddConnectorUserMemberResponse, AddDataSourceTeamMemberData, AddDataSourceTeamMemberError, AddDataSourceTeamMemberResponse, AddDataSourceUserMemberData, AddDataSourceUserMemberError, AddDataSourceUserMemberResponse, AddFlowTeamMemberData, AddFlowTeamMemberError, AddFlowTeamMemberResponse, AddFlowUserMemberData, AddFlowUserMemberError, AddFlowUserMemberResponse, AddMicroAppTeamMemberData, AddMicroAppTeamMemberError, AddMicroAppTeamMemberResponse, AddMicroAppUserMemberData, AddMicroAppUserMemberError, AddMicroAppUserMemberResponse, AddNoteData, AddNoteError, AddNoteResponse, AddPinData, AddPinError, AddPinResponse, AddSkillTeamMemberData, AddSkillTeamMemberError, AddSkillTeamMemberResponse, AddSkillUserMemberData, AddSkillUserMemberError, AddSkillUserMemberResponse, AddSpaceConnectorData, AddSpaceConnectorError, AddSpaceConnectorResponse, AddSpaceResourceData, AddSpaceResourceError, AddSpaceResourceResponse, AddSpaceTeamMemberData, AddSpaceTeamMemberError, AddSpaceTeamMemberResponse, AddSpaceUserMemberData, AddSpaceUserMemberError, AddSpaceUserMemberResponse, AddWebsiteUrlData, AddWebsiteUrlError, AddWebsiteUrlResponse, AdminConnectorAuditData, AdminConnectorAuditError, AdminConnectorAuditResponse, AdminCreateModelData, AdminCreateModelError, AdminCreateModelResponse, AdminCreateUserData, AdminCreateUserError, AdminCreateUserResponse, AdminDeleteModelData, AdminDeleteModelError, AdminDeleteModelResponse, AdminDeleteUserData, AdminDeleteUserError, AdminDeleteUserResponse, AdminDisableConnectorData, AdminDisableConnectorError, AdminDisableConnectorResponse, AdminEnableConnectorData, AdminEnableConnectorError, AdminEnableConnectorResponse, AdminGetConnectorPolicyData, AdminGetConnectorPolicyResponse, AdminGetModelData, AdminGetModelError, AdminGetModelResponse, AdminGetUsageData, AdminGetUsageError, AdminGetUsageResponse, AdminListConnectorsData, AdminListConnectorsResponse, AdminListModelReferencesData, AdminListModelReferencesError, AdminListModelReferencesResponse, AdminListModelsData, AdminListModelsError, AdminListModelsResponse, AdminListTierDefaultsData, AdminListTierDefaultsResponse, AdminListUsersData, AdminListUsersError, AdminListUsersResponse, AdminReassignModelData, AdminReassignModelError, AdminReassignModelResponse, AdminSuggestModelData, AdminSuggestModelError, AdminSuggestModelResponse, AdminUpdateConnectorPolicyData, AdminUpdateConnectorPolicyError, AdminUpdateConnectorPolicyResponse, AdminUpdateModelData, AdminUpdateModelError, AdminUpdateModelResponse, AdminUpdateTierDefaultData, AdminUpdateTierDefaultError, AdminUpdateTierDefaultResponse, AdminUpdateUserData, AdminUpdateUserError, AdminUpdateUserResponse, AgentDeleteImpactData, AgentDeleteImpactError, AgentDeleteImpactResponse2, AnalyzeImportData, AnalyzeImportError, AnalyzeImportResponse, AttachmentStatusData, AttachmentStatusResponse2, AttachSkillsToAgentData, AttachSkillsToAgentError, AttachSkillsToAgentResponse, AuthorizeData, AuthorizeError, AuthorizeFlowData, AuthorizeFlowError, AuthorizeFlowResponse, AuthorizeResponse2, CancelFlowRunData, CancelFlowRunError, CancelFlowRunResponse, CancelOperationData, CancelOperationError, CancelOperationResponse, ChatAccessShareLinkData, ChatAccessShareLinkError, ChatAccessShareLinkResponse, ChatCreateSessionData, ChatCreateSessionError, ChatCreateSessionResponse, ChatCreateShareLinkData, ChatCreateShareLinkError, ChatCreateShareLinkResponse, ChatDeactivateShareLinkData, ChatDeactivateShareLinkError, ChatDeactivateShareLinkResponse, ChatDeleteSessionData, ChatDeleteSessionError, ChatDeleteSessionResponse, ChatGetSessionData, ChatGetSessionError, ChatGetSessionResponse, ChatGetSessionSharingData, ChatGetSessionSharingError, ChatGetSessionSharingResponse, ChatListSessionsData, ChatListSessionsError, ChatListSessionsResponse, ChatListSharedWithMeData, ChatListSharedWithMeResponse, ChatRemoveShareData, ChatRemoveShareError, ChatRemoveShareResponse, ChatShareWithUserData, ChatShareWithUserError, ChatShareWithUserResponse, ChatStreamMessageData, ChatStreamMessageError, ChatStreamMessageResponse, ChatUpdateSessionData, ChatUpdateSessionError, ChatUpdateSessionResponse, ChatUploadAttachmentsData, ChatUploadAttachmentsError, ChatUploadAttachmentsResponse, ClearAgentMemoryData, ClearAgentMemoryError, ClearAgentMemoryResponse, ClearAllAgentMemoryData, ClearAllAgentMemoryResponse, ClearConnectorSecretData, ClearConnectorSecretError, ClearConnectorSecretResponse, ClearCredentialData, ClearCredentialError, ClearCredentialResponse, ClearExtensionPreferenceData, ClearExtensionPreferenceError, ClearExtensionPreferenceResponse, ClearMyConnectorCredentialData, ClearMyConnectorCredentialError, ClearMyConnectorCredentialResponse, CorrelateContentFilterEventData, CorrelateContentFilterEventError, CorrelateContentFilterEventResponse, CreateAgentData, CreateAgentError, CreateAgentResponse, CreateApiKeyData, CreateApiKeyError, CreateApiKeyResponse, CreateBrandData, CreateBrandError, CreateBrandResponse, CreateBudgetConfigData, CreateBudgetConfigError, CreateBudgetConfigResponse, CreateConnectorData, CreateConnectorError, CreateConnectorFromTemplateData, CreateConnectorFromTemplateError, CreateConnectorFromTemplateResponse, CreateConnectorInstanceData, CreateConnectorInstanceError, CreateConnectorInstanceResponse, CreateConnectorResponse, CreateDataSourceData, CreateDataSourceError, CreateDataSourceResponse, CreateFlowData, CreateFlowError, CreateFlowResponse, CreateFlowTriggerData, CreateFlowTriggerError, CreateImportData, CreateImportError, CreateImportResponse, CreateSidebarSectionData, CreateSidebarSectionError, CreateSidebarSectionResponse, CreateSkillData, CreateSkillError, CreateSkillResponse, CreateSpaceData, CreateSpaceError, CreateSpaceResponse, DeleteAgentData, DeleteAgentError, DeleteAgentMemoryData, DeleteAgentMemoryError, DeleteAgentMemoryResponse, DeleteAgentResponse, DeleteBrandData, DeleteBrandError, DeleteBrandResponse, DeleteBrandTemplateData, DeleteBrandTemplateError, DeleteBrandTemplateResponse, DeleteBudgetConfigData, DeleteBudgetConfigError, DeleteBudgetConfigResponse, DeleteConnectorData, DeleteConnectorError, DeleteConnectorResponse, DeleteDataSourceData, DeleteDataSourceError, DeleteDataSourceResponse, DeleteFileData, DeleteFileError, DeleteFileResponse, DeleteFlowData, DeleteFlowError, DeleteFlowResponse, DeleteFlowTriggerData, DeleteFlowTriggerError, DeleteFlowTriggerResponse, DeleteImportData, DeleteImportError, DeleteImportResponse, DeleteMicroAppData, DeleteMicroAppError, DeleteMicroAppResponse, DeleteSidebarSectionData, DeleteSidebarSectionError, DeleteSidebarSectionResponse, DeleteSkillData, DeleteSkillError, DeleteSkillResponse, DeleteSpaceData, DeleteSpaceError, DeleteSpaceFileData, DeleteSpaceFileError, DeleteSpaceFileResponse, DeleteSpaceResponse, DeleteWikiFileData, DeleteWikiFileError, DeleteWikiFileResponse, DetachSkillFromAgentData, DetachSkillFromAgentError, DetachSkillFromAgentResponse, DisconnectData, DisconnectError, DisconnectResponse, DismissAllData, DismissAllError, DismissAllResponse, DismissDuplicateData, DismissDuplicateError, DismissDuplicateResponse, DownloadBrandTemplateData, DownloadBrandTemplateError, DownloadScreenshotData, DownloadScreenshotError, EditWithAiData, EditWithAiError, EditWithAiResponse, ExtractBrandData, ExtractBrandError, ExtractBrandResponse, ForkSessionData, ForkSessionError, ForkSessionResponse, GetAgentData, GetAgentError, GetAgentMembersData, GetAgentMembersError, GetAgentMembersResponse, GetAgentResponse, GetAttachmentBindingsData, GetAttachmentBindingsError, GetAttachmentBindingsResponse, GetAttachmentLimitsData, GetAttachmentLimitsResponse, GetBrandData, GetBrandError, GetBrandMembersData, GetBrandMembersError, GetBrandMembersResponse, GetBrandResponse, GetBrandTemplateThumbnailData, GetBrandTemplateThumbnailError, GetCompanyProfileData, GetCompanyProfileResponse, GetConnectorDetailData, GetConnectorDetailError, GetConnectorDetailResponse, GetConnectorMembersData, GetConnectorMembersError, GetConnectorMembersResponse, GetConnectorPolicyData, GetConnectorPolicyResponse, GetContentFilterAnalyticsData, GetContentFilterAnalyticsError, GetContentFilterAnalyticsResponse, GetCurrentUserInfoData, GetCurrentUserInfoResponse, GetDataSourceData, GetDataSourceError, GetDataSourceMembersData, GetDataSourceMembersError, GetDataSourceMembersResponse, GetDataSourceResponse, GetExportCapabilitiesData, GetExportCapabilitiesResponse, GetExtensionData, GetExtensionError, GetExtensionResponse, GetFeedbackData, GetFeedbackError, GetFeedbackResponse, GetFileDownloadUrlData, GetFileDownloadUrlError, GetFileDownloadUrlResponse, GetFileMarkdownData, GetFileMarkdownError, GetFlowAuthorizationData, GetFlowAuthorizationError, GetFlowAuthorizationResponse, GetFlowData, GetFlowError, GetFlowMembersData, GetFlowMembersError, GetFlowMembersResponse, GetFlowResponse, GetFlowRunData, GetFlowRunError, GetFlowRunResponse, GetGovernanceOverviewData, GetGovernanceOverviewResponse, GetImportData, GetImportError, GetImportResponse, GetLicenseDetailData, GetLicenseDetailResponse, GetLicenseStatusData, GetLicenseStatusResponse, GetLogoData, GetMicroAppContentData, GetMicroAppContentError, GetMicroAppData, GetMicroAppError, GetMicroAppInfoData, GetMicroAppInfoError, GetMicroAppInfoResponse, GetMicroAppMembersData, GetMicroAppMembersError, GetMicroAppMembersResponse, GetMicroAppResponse, GetMyOnedriveData, GetMyOnedriveResponse, GetMySpendData, GetMySpendError, GetMySpendResponse, GetPersonalSpaceData, GetPersonalSpaceResponse, GetPlatformCostsData, GetPlatformCostsError, GetPlatformCostsResponse, GetPreferencesData, GetPreferencesResponse, GetSkillData, GetSkillError, GetSkillMembersData, GetSkillMembersError, GetSkillMembersResponse, GetSkillResponse, GetSpaceData, GetSpaceError, GetSpaceHubData, GetSpaceHubError, GetSpaceHubResponse, GetSpaceMembersData, GetSpaceMembersError, GetSpaceMembersResponse, GetSpaceResponse, GetSpaceSidebarData, GetSpaceSidebarResponse, GetUnreadCountData, GetUnreadCountResponse, GetUsageByUserData, GetUsageByUserError, GetUsageByUserResponse, GetWikiFileData, GetWikiFileError, GetWikiFileResponse, GiveSpaceAccessData, GiveSpaceAccessError, GiveSpaceAccessResponse, GoogleDriveDownloadDocumentData, GoogleDriveDownloadDocumentError, GoogleDriveDownloadDocumentResponse, ImportSkillsData, ImportSkillsError, ImportSkillsResponse, ListActiveOperationsData, ListActiveOperationsResponse, ListAgentConnectorsData, ListAgentConnectorsError, ListAgentConnectorsResponse, ListAgentMemoriesData, ListAgentMemoriesResponse, ListAgentPinsData, ListAgentPinsResponse, ListAgentsData, ListAgentsError, ListAgentSkillsData, ListAgentSkillsError, ListAgentSkillsResponse, ListAgentsResponse, ListAllAuthorizationsData, ListAllAuthorizationsResponse, ListAllFeedbackData, ListAllFeedbackError, ListAllFeedbackResponse, ListApiKeysData, ListApiKeysResponse, ListAvailableData, ListAvailableResponse, ListBrandsData, ListBrandsError, ListBrandsResponse, ListBrandTemplatesData, ListBrandTemplatesError, ListBrandTemplatesResponse, ListBudgetConfigsData, ListBudgetConfigsResponse, ListConnectorIntegrationsData, ListConnectorIntegrationsResponse, ListConnectorsData, ListConnectorsError, ListConnectorsResponse, ListConnectorTemplatesData, ListConnectorTemplatesResponse, ListConnectorToolsData, ListConnectorToolsError, ListConnectorToolsResponse, ListContentFilterEventsData, ListContentFilterEventsError, ListContentFilterEventsResponse, ListDataSourcesData, ListDataSourcesError, ListDataSourcesResponse, ListDriveItemsData, ListDriveItemsError, ListDriveItemsResponse, ListDuplicatesData, ListDuplicatesError, ListDuplicatesResponse, ListExtensionConsentData, ListExtensionConsentResponse, ListExtensionsData, ListExtensionsResponse, ListFilesData, ListFilesError, ListFilesResponse, ListFlowRunsData, ListFlowRunsError, ListFlowRunsResponse, ListFlowsData, ListFlowsError, ListFlowsResponse, ListFlowTriggersData, ListFlowTriggersError, ListFlowTriggersResponse, ListImportsData, ListImportsError, ListImportsResponse, ListInboxData, ListInboxResponse, ListMergesData, ListMergesError, ListMergesResponse, ListMessageAttachmentsData, ListMessageAttachmentsError, ListMessageAttachmentsResponse, ListMessagesData, ListMessagesError, ListMessagesResponse, ListMicroAppsData, ListMicroAppsError, ListMicroAppsResponse, ListMyAuthorizationsData, ListMyAuthorizationsResponse, ListMyConnectorConnectionsData, ListMyConnectorConnectionsResponse, ListMyJobsData, ListMyJobsError, ListMyJobsResponse, ListNotificationsData, ListNotificationsError, ListNotificationsResponse, ListPinsData, ListPinsResponse, ListQuickActionsData, ListQuickActionsError, ListQuickActionsResponse, ListRecentActivitiesData, ListRecentActivitiesError, ListRecentActivitiesResponse, ListSessionDocumentsData, ListSessionDocumentsError, ListSessionDocumentsResponse, ListSiteDrivesData, ListSiteDrivesError, ListSiteDrivesResponse, ListSkillCategoriesData, ListSkillCategoriesResponse, ListSkillsData, ListSkillsError, ListSkillsResponse, ListSpaceActivitiesData, ListSpaceActivitiesError, ListSpaceActivitiesResponse, ListSpaceConnectorsData, ListSpaceConnectorsError, ListSpaceConnectorsResponse, ListSpaceDocumentsData, ListSpaceDocumentsError, ListSpaceDocumentsResponse, ListSpaceKnowledgeData, ListSpaceKnowledgeError, ListSpaceKnowledgeResponse, ListSpaceResourcesData, ListSpaceResourcesError, ListSpaceResourcesResponse, ListSpacesData, ListSpacesError, ListSpaceSharedChatsData, ListSpaceSharedChatsError, ListSpaceSharedChatsResponse, ListSpacesResponse, ListTeamsData, ListTeamsError, ListTeamsResponse, ListToolsData, ListToolsError, ListToolsResponse, ListUserFacingTierDefaultsData, ListUserFacingTierDefaultsResponse, ListWikiFilesData, ListWikiFilesError, ListWikiFilesResponse, ListWorkersData, ListWorkersResponse, MarkAllReadData, MarkAllReadResponse, MarkDraftAppliedData, MarkDraftAppliedError, MarkDraftAppliedResponse, MarkNotificationReadData, MarkNotificationReadError, MarkNotificationReadResponse, MergePagesData, MergePagesError, MergePagesResponse, ModelsListModelsData, ModelsListModelsError, ModelsListModelsResponse, MoveSidebarSpaceData, MoveSidebarSpaceError, MoveSidebarSpaceResponse, PlatformCreateOauthClientData, PlatformCreateOauthClientError, PlatformCreateOauthClientResponse, PlatformDeleteOauthClientData, PlatformDeleteOauthClientError, PlatformDeleteOauthClientResponse, PlatformListOauthClientsData, PlatformListOauthClientsResponse, PlatformUpdateOauthClientData, PlatformUpdateOauthClientError, PlatformUpdateOauthClientResponse, PreviewCompanyContextData, PreviewCompanyContextResponse, PreviewMergeData, PreviewMergeError, PreviewMergeResponse, PublishMicroAppData, PublishMicroAppError, PublishMicroAppResponse, RefreshConnectorToolsData, RefreshConnectorToolsError, RefreshConnectorToolsResponse, RegenerateWebhookSecretData, RegenerateWebhookSecretError, RegenerateWebhookSecretResponse, RejectProposalData, RejectProposalError, RejectProposalResponse, RemoveAgentPinData, RemoveAgentPinError, RemoveAgentPinResponse, RemoveAgentTeamMemberData, RemoveAgentTeamMemberError, RemoveAgentTeamMemberResponse, RemoveAgentUserMemberData, RemoveAgentUserMemberError, RemoveAgentUserMemberResponse, RemoveBrandTeamMemberData, RemoveBrandTeamMemberError, RemoveBrandTeamMemberResponse, RemoveBrandUserMemberData, RemoveBrandUserMemberError, RemoveBrandUserMemberResponse, RemoveConnectorTeamMemberData, RemoveConnectorTeamMemberError, RemoveConnectorTeamMemberResponse, RemoveConnectorUserMemberData, RemoveConnectorUserMemberError, RemoveConnectorUserMemberResponse, RemoveDataSourceTeamMemberData, RemoveDataSourceTeamMemberError, RemoveDataSourceTeamMemberResponse, RemoveDataSourceUserMemberData, RemoveDataSourceUserMemberError, RemoveDataSourceUserMemberResponse, RemoveFlowTeamMemberData, RemoveFlowTeamMemberError, RemoveFlowTeamMemberResponse, RemoveFlowUserMemberData, RemoveFlowUserMemberError, RemoveFlowUserMemberResponse, RemoveMicroAppTeamMemberData, RemoveMicroAppTeamMemberError, RemoveMicroAppTeamMemberResponse, RemoveMicroAppUserMemberData, RemoveMicroAppUserMemberError, RemoveMicroAppUserMemberResponse, RemovePinData, RemovePinError, RemovePinResponse, RemoveSkillTeamMemberData, RemoveSkillTeamMemberError, RemoveSkillTeamMemberResponse, RemoveSkillUserMemberData, RemoveSkillUserMemberError, RemoveSkillUserMemberResponse, RemoveSpaceAccessData, RemoveSpaceAccessError, RemoveSpaceAccessResponse, RemoveSpaceConnectorData, RemoveSpaceConnectorError, RemoveSpaceConnectorResponse, RemoveSpaceDocumentData, RemoveSpaceDocumentError, RemoveSpaceDocumentResponse, RemoveSpaceResourceData, RemoveSpaceResourceError, RemoveSpaceResourceResponse, RemoveSpaceTeamMemberData, RemoveSpaceTeamMemberError, RemoveSpaceTeamMemberResponse, RemoveSpaceUserMemberData, RemoveSpaceUserMemberError, RemoveSpaceUserMemberResponse, ReorderPinsData, ReorderPinsError, ReorderPinsResponse, ReorderSidebarSectionsData, ReorderSidebarSectionsError, ReorderSidebarSectionsResponse, ReorderSpaceResourcesData, ReorderSpaceResourcesError, ReorderSpaceResourcesResponse, RepublishMicroAppData, RepublishMicroAppError, RepublishMicroAppResponse, ResolveSharepointUrlData, ResolveSharepointUrlError, ResolveSharepointUrlResponse, ResumeFlowRunData, ResumeFlowRunError, ResumeFlowRunResponse, ResumePlatformData, ResumePlatformError, ResumePlatformResponse, RevokeApiKeyData, RevokeApiKeyError, RevokeApiKeyResponse, RevokeMyAuthorizationData, RevokeMyAuthorizationError, RevokeMyAuthorizationResponse, SaveWikiFileData, SaveWikiFileError, SaveWikiFileResponse, SearchDriveItemsData, SearchDriveItemsError, SearchDriveItemsResponse, SearchFilesData, SearchFilesError, SearchFilesResponse, SearchSitesData, SearchSitesError, SearchSitesResponse, SearchUsersData, SearchUsersError, SearchUsersResponse, SetAgentConnectorsData, SetAgentConnectorsError, SetAgentConnectorsResponse, SetConnectorSecretData, SetConnectorSecretError, SetConnectorSecretResponse, SetExtensionPreferenceData, SetExtensionPreferenceError, SetExtensionPreferenceResponse, SetMyConnectorCredentialData, SetMyConnectorCredentialError, SetMyConnectorCredentialResponse, SetSessionSpaceShareData, SetSessionSpaceShareError, SetSessionSpaceShareResponse, SetSpaceConnectorSkillsData, SetSpaceConnectorSkillsError, SetSpaceConnectorSkillsResponse, SharepointCountFolderItemsData, SharepointCountFolderItemsError, SharepointCountFolderItemsResponse, SharepointDownloadDocumentData, SharepointDownloadDocumentError, SharepointDownloadDocumentResponse, ShareSpaceDocumentData, ShareSpaceDocumentError, ShareSpaceDocumentResponse, SkillDeleteImpactData, SkillDeleteImpactError, SkillDeleteImpactResponse2, SpaceAccessImpactData, SpaceAccessImpactError, SpaceAccessImpactResponse2, SpacesCreateQuickActionData, SpacesCreateQuickActionError, SpacesCreateQuickActionResponse, SpacesDeleteQuickActionData, SpacesDeleteQuickActionError, SpacesDeleteQuickActionResponse, SpacesUpdateQuickActionData, SpacesUpdateQuickActionError, SpacesUpdateQuickActionResponse, StartConnectorOauthData, StartConnectorOauthError, StartConnectorOauthResponse, StreamAgentData, StreamAgentError, StreamAgentResponse, StreamFlowRunData, StreamFlowRunError, StreamFlowRunResponse, SubmitFeedbackData, SubmitFeedbackError, SubmitFeedbackResponse, SuspendPlatformData, SuspendPlatformError, SuspendPlatformResponse, SyncDataSourceData, SyncDataSourceError, SyncDataSourceResponse, ToggleExtensionData, ToggleExtensionError, ToggleExtensionResponse, UndoMergeData, UndoMergeError, UndoMergeResponse, UpdateAgentData, UpdateAgentError, UpdateAgentResponse, UpdateAgentSkillData, UpdateAgentSkillError, UpdateAgentSkillResponse, UpdateAgentTeamMemberData, UpdateAgentTeamMemberError, UpdateAgentTeamMemberResponse, UpdateAgentUserMemberData, UpdateAgentUserMemberError, UpdateAgentUserMemberResponse, UpdateBrandData, UpdateBrandError, UpdateBrandResponse, UpdateBrandTeamMemberData, UpdateBrandTeamMemberError, UpdateBrandTeamMemberResponse, UpdateBrandUserMemberData, UpdateBrandUserMemberError, UpdateBrandUserMemberResponse, UpdateBudgetConfigData, UpdateBudgetConfigError, UpdateBudgetConfigResponse, UpdateConnectorData, UpdateConnectorError, UpdateConnectorResponse, UpdateConnectorTeamMemberData, UpdateConnectorTeamMemberError, UpdateConnectorTeamMemberResponse, UpdateConnectorToolData, UpdateConnectorToolError, UpdateConnectorToolResponse, UpdateConnectorUserMemberData, UpdateConnectorUserMemberError, UpdateConnectorUserMemberResponse, UpdateCredentialData, UpdateCredentialError, UpdateCredentialResponse, UpdateDataSourceData, UpdateDataSourceError, UpdateDataSourceResponse, UpdateDataSourceTeamMemberData, UpdateDataSourceTeamMemberError, UpdateDataSourceTeamMemberResponse, UpdateDataSourceUserMemberData, UpdateDataSourceUserMemberError, UpdateDataSourceUserMemberResponse, UpdateExtensionData, UpdateExtensionError, UpdateExtensionResponse, UpdateFeedbackStatusData, UpdateFeedbackStatusError, UpdateFeedbackStatusResponse, UpdateFlowData, UpdateFlowError, UpdateFlowResponse, UpdateFlowTeamMemberData, UpdateFlowTeamMemberError, UpdateFlowTeamMemberResponse, UpdateFlowTriggerData, UpdateFlowTriggerError, UpdateFlowTriggerResponse, UpdateFlowUserMemberData, UpdateFlowUserMemberError, UpdateFlowUserMemberResponse, UpdateLicenseData, UpdateLicenseError, UpdateLicenseResponse, UpdateMicroAppData, UpdateMicroAppError, UpdateMicroAppResponse, UpdateMicroAppTeamMemberData, UpdateMicroAppTeamMemberError, UpdateMicroAppTeamMemberResponse, UpdateMicroAppUserMemberData, UpdateMicroAppUserMemberError, UpdateMicroAppUserMemberResponse, UpdateNoteData, UpdateNoteError, UpdateNoteResponse, UpdatePreferencesData, UpdatePreferencesError, UpdatePreferencesResponse, UpdateSidebarSectionData, UpdateSidebarSectionError, UpdateSidebarSectionResponse, UpdateSkillData, UpdateSkillError, UpdateSkillResponse, UpdateSkillTeamMemberData, UpdateSkillTeamMemberError, UpdateSkillTeamMemberResponse, UpdateSkillUserMemberData, UpdateSkillUserMemberError, UpdateSkillUserMemberResponse, UpdateSpaceConnectorData, UpdateSpaceConnectorError, UpdateSpaceConnectorResponse, UpdateSpaceData, UpdateSpaceError, UpdateSpaceResourceData, UpdateSpaceResourceError, UpdateSpaceResourceResponse, UpdateSpaceResponse, UpdateSpaceTeamMemberData, UpdateSpaceTeamMemberError, UpdateSpaceTeamMemberResponse, UpdateSpaceUserMemberData, UpdateSpaceUserMemberError, UpdateSpaceUserMemberResponse, UpdateTeamAccessData, UpdateTeamAccessError, UpdateTeamAccessResponse, UpdateUserSettingsData, UpdateUserSettingsError, UpdateUserSettingsResponse, UploadBrandLogoData, UploadBrandLogoError, UploadBrandLogoResponse, UploadBrandTemplateData, UploadBrandTemplateError, UploadBrandTemplateResponse, UploadFilesData, UploadFilesError, UploadFilesResponse, UploadFlowFilesData, UploadFlowFilesError, UploadFlowFilesResponse, UploadImportData, UploadImportError, UploadImportResponse, UploadLogoData, UploadLogoError, UploadLogoResponse, UploadSpaceFilesData, UploadSpaceFilesError, UploadSpaceFilesResponse, UpsertCompanyProfileData, UpsertCompanyProfileError, UpsertCompanyProfileResponse } from '../types.gen';

export type QueryKey<TOptions extends Options> = [
    Pick<TOptions, 'baseUrl' | 'body' | 'headers' | 'path' | 'query'> & {
        _id: string;
        _infinite?: boolean;
        tags?: ReadonlyArray<string>;
    }
];

const createQueryKey = <TOptions extends Options>(id: string, options?: TOptions, infinite?: boolean, tags?: ReadonlyArray<string>): [
    QueryKey<TOptions>[0]
] => {
    const params: QueryKey<TOptions>[0] = { _id: id, baseUrl: options?.baseUrl || (options?.client ?? client).getConfig().baseUrl } as QueryKey<TOptions>[0];
    if (infinite) {
        params._infinite = infinite;
    }
    if (tags) {
        params.tags = tags;
    }
    if (options?.body) {
        params.body = options.body;
    }
    if (options?.headers) {
        params.headers = options.headers;
    }
    if (options?.path) {
        params.path = options.path;
    }
    if (options?.query) {
        params.query = options.query;
    }
    return [params];
};

export const listBudgetConfigsQueryKey = (options?: Options<ListBudgetConfigsData>) => createQueryKey('listBudgetConfigs', options);

/**
 * List Budget Configs
 *
 * List all budget configurations.
 */
export const listBudgetConfigsOptions = (options?: Options<ListBudgetConfigsData>) => queryOptions<ListBudgetConfigsResponse, DefaultError, ListBudgetConfigsResponse, ReturnType<typeof listBudgetConfigsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await listBudgetConfigs({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listBudgetConfigsQueryKey(options)
});

/**
 * Create Budget Config
 *
 * Create a budget configuration.
 */
export const createBudgetConfigMutation = (options?: Partial<Options<CreateBudgetConfigData>>): UseMutationOptions<CreateBudgetConfigResponse, CreateBudgetConfigError, Options<CreateBudgetConfigData>> => {
    const mutationOptions: UseMutationOptions<CreateBudgetConfigResponse, CreateBudgetConfigError, Options<CreateBudgetConfigData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await createBudgetConfig({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Delete Budget Config
 *
 * Delete a budget configuration.
 */
export const deleteBudgetConfigMutation = (options?: Partial<Options<DeleteBudgetConfigData>>): UseMutationOptions<DeleteBudgetConfigResponse, DeleteBudgetConfigError, Options<DeleteBudgetConfigData>> => {
    const mutationOptions: UseMutationOptions<DeleteBudgetConfigResponse, DeleteBudgetConfigError, Options<DeleteBudgetConfigData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await deleteBudgetConfig({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Update Budget Config
 *
 * Update a budget configuration's monthly limit.
 */
export const updateBudgetConfigMutation = (options?: Partial<Options<UpdateBudgetConfigData>>): UseMutationOptions<UpdateBudgetConfigResponse, UpdateBudgetConfigError, Options<UpdateBudgetConfigData>> => {
    const mutationOptions: UseMutationOptions<UpdateBudgetConfigResponse, UpdateBudgetConfigError, Options<UpdateBudgetConfigData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await updateBudgetConfig({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getCompanyProfileQueryKey = (options?: Options<GetCompanyProfileData>) => createQueryKey('getCompanyProfile', options);

/**
 * Get Company Profile
 *
 * Get the company profile (returns null data if not yet configured).
 */
export const getCompanyProfileOptions = (options?: Options<GetCompanyProfileData>) => queryOptions<GetCompanyProfileResponse, DefaultError, GetCompanyProfileResponse, ReturnType<typeof getCompanyProfileQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getCompanyProfile({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getCompanyProfileQueryKey(options)
});

/**
 * Upsert Company Profile
 *
 * Create or update the company profile (upsert on the singleton row).
 */
export const upsertCompanyProfileMutation = (options?: Partial<Options<UpsertCompanyProfileData>>): UseMutationOptions<UpsertCompanyProfileResponse, UpsertCompanyProfileError, Options<UpsertCompanyProfileData>> => {
    const mutationOptions: UseMutationOptions<UpsertCompanyProfileResponse, UpsertCompanyProfileError, Options<UpsertCompanyProfileData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await upsertCompanyProfile({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const previewCompanyContextQueryKey = (options?: Options<PreviewCompanyContextData>) => createQueryKey('previewCompanyContext', options);

/**
 * Preview Company Context
 *
 * Preview the auto-generated system prompt context from the current profile.
 */
export const previewCompanyContextOptions = (options?: Options<PreviewCompanyContextData>) => queryOptions<PreviewCompanyContextResponse, DefaultError, PreviewCompanyContextResponse, ReturnType<typeof previewCompanyContextQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await previewCompanyContext({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: previewCompanyContextQueryKey(options)
});

export const getLogoQueryKey = (options?: Options<GetLogoData>) => createQueryKey('getLogo', options);

/**
 * Get Logo
 *
 * Serve the company logo from blob storage.
 */
export const getLogoOptions = (options?: Options<GetLogoData>) => queryOptions<unknown, DefaultError, unknown, ReturnType<typeof getLogoQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getLogo({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getLogoQueryKey(options)
});

/**
 * Upload Logo
 *
 * Upload a company logo image.
 *
 * Stores the file in blob storage and updates the company profile's
 * logo_blob_path field. Replaces any existing logo.
 */
export const uploadLogoMutation = (options?: Partial<Options<UploadLogoData>>): UseMutationOptions<UploadLogoResponse, UploadLogoError, Options<UploadLogoData>> => {
    const mutationOptions: UseMutationOptions<UploadLogoResponse, UploadLogoError, Options<UploadLogoData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await uploadLogo({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const adminListConnectorsQueryKey = (options?: Options<AdminListConnectorsData>) => createQueryKey('adminListConnectors', options);

/**
 * Admin List Connectors
 *
 * Every connector people have added, with whether its host passes the policy.
 */
export const adminListConnectorsOptions = (options?: Options<AdminListConnectorsData>) => queryOptions<AdminListConnectorsResponse, DefaultError, AdminListConnectorsResponse, ReturnType<typeof adminListConnectorsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await adminListConnectors({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: adminListConnectorsQueryKey(options)
});

export const adminConnectorAuditQueryKey = (options?: Options<AdminConnectorAuditData>) => createQueryKey('adminConnectorAudit', options);

/**
 * Admin Connector Audit
 *
 * Recent connector activity, newest first (optionally for one connector). Page with ``beforeId``.
 */
export const adminConnectorAuditOptions = (options?: Options<AdminConnectorAuditData>) => queryOptions<AdminConnectorAuditResponse, AdminConnectorAuditError, AdminConnectorAuditResponse, ReturnType<typeof adminConnectorAuditQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await adminConnectorAudit({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: adminConnectorAuditQueryKey(options)
});

export const adminGetConnectorPolicyQueryKey = (options?: Options<AdminGetConnectorPolicyData>) => createQueryKey('adminGetConnectorPolicy', options);

/**
 * Admin Get Connector Policy
 *
 * The connector policy.
 */
export const adminGetConnectorPolicyOptions = (options?: Options<AdminGetConnectorPolicyData>) => queryOptions<AdminGetConnectorPolicyResponse, DefaultError, AdminGetConnectorPolicyResponse, ReturnType<typeof adminGetConnectorPolicyQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await adminGetConnectorPolicy({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: adminGetConnectorPolicyQueryKey(options)
});

/**
 * Admin Update Connector Policy
 *
 * Change who may add connectors and which hosts they may reach.
 */
export const adminUpdateConnectorPolicyMutation = (options?: Partial<Options<AdminUpdateConnectorPolicyData>>): UseMutationOptions<AdminUpdateConnectorPolicyResponse, AdminUpdateConnectorPolicyError, Options<AdminUpdateConnectorPolicyData>> => {
    const mutationOptions: UseMutationOptions<AdminUpdateConnectorPolicyResponse, AdminUpdateConnectorPolicyError, Options<AdminUpdateConnectorPolicyData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await adminUpdateConnectorPolicy({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Admin Disable Connector
 *
 * Turn a connector off for everyone. Its owners can't turn it back on.
 */
export const adminDisableConnectorMutation = (options?: Partial<Options<AdminDisableConnectorData>>): UseMutationOptions<AdminDisableConnectorResponse, AdminDisableConnectorError, Options<AdminDisableConnectorData>> => {
    const mutationOptions: UseMutationOptions<AdminDisableConnectorResponse, AdminDisableConnectorError, Options<AdminDisableConnectorData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await adminDisableConnector({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Admin Enable Connector
 *
 * Allow a connector an admin turned off again.
 */
export const adminEnableConnectorMutation = (options?: Partial<Options<AdminEnableConnectorData>>): UseMutationOptions<AdminEnableConnectorResponse, AdminEnableConnectorError, Options<AdminEnableConnectorData>> => {
    const mutationOptions: UseMutationOptions<AdminEnableConnectorResponse, AdminEnableConnectorError, Options<AdminEnableConnectorData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await adminEnableConnector({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getContentFilterAnalyticsQueryKey = (options?: Options<GetContentFilterAnalyticsData>) => createQueryKey('getContentFilterAnalytics', options);

/**
 * Get Content Filter Analytics
 *
 * Counts by category, severity and UTC day. No user identity.
 */
export const getContentFilterAnalyticsOptions = (options?: Options<GetContentFilterAnalyticsData>) => queryOptions<GetContentFilterAnalyticsResponse, GetContentFilterAnalyticsError, GetContentFilterAnalyticsResponse, ReturnType<typeof getContentFilterAnalyticsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getContentFilterAnalytics({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getContentFilterAnalyticsQueryKey(options)
});

export const listContentFilterEventsQueryKey = (options?: Options<ListContentFilterEventsData>) => createQueryKey('listContentFilterEvents', options);

/**
 * List Content Filter Events
 *
 * Flagged categories, newest first. No user identity.
 */
export const listContentFilterEventsOptions = (options?: Options<ListContentFilterEventsData>) => queryOptions<ListContentFilterEventsResponse, ListContentFilterEventsError, ListContentFilterEventsResponse, ReturnType<typeof listContentFilterEventsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await listContentFilterEvents({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listContentFilterEventsQueryKey(options)
});

const createInfiniteParams = <K extends Pick<QueryKey<Options>[0], 'body' | 'headers' | 'path' | 'query'>>(queryKey: QueryKey<Options>, page: K) => {
    const params = { ...queryKey[0] };
    if (page.body) {
        params.body = {
            ...queryKey[0].body as any,
            ...page.body as any
        };
    }
    if (page.headers) {
        params.headers = {
            ...queryKey[0].headers,
            ...page.headers
        };
    }
    if (page.path) {
        params.path = {
            ...queryKey[0].path as any,
            ...page.path as any
        };
    }
    if (page.query) {
        params.query = {
            ...queryKey[0].query as any,
            ...page.query as any
        };
    }
    return params as unknown as typeof page;
};

export const listContentFilterEventsInfiniteQueryKey = (options?: Options<ListContentFilterEventsData>): QueryKey<Options<ListContentFilterEventsData>> => createQueryKey('listContentFilterEvents', options, true);

/**
 * List Content Filter Events
 *
 * Flagged categories, newest first. No user identity.
 */
export const listContentFilterEventsInfiniteOptions = (options?: Options<ListContentFilterEventsData>) => {
    const opts = infiniteQueryOptions<ListContentFilterEventsResponse, ListContentFilterEventsError, InfiniteData<ListContentFilterEventsResponse>, QueryKey<Options<ListContentFilterEventsData>>, number | Pick<QueryKey<Options<ListContentFilterEventsData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<ListContentFilterEventsData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                query: {
                    page: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await listContentFilterEvents({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: listContentFilterEventsInfiniteQueryKey(options)
    });
    return opts as Omit<typeof opts, 'initialData'>;
};

export const correlateContentFilterEventQueryKey = (options: Options<CorrelateContentFilterEventData>) => createQueryKey('correlateContentFilterEvent', options);

/**
 * Correlate Content Filter Event
 *
 * Who triggered one event and in which conversation, for human follow-up. Audited.
 */
export const correlateContentFilterEventOptions = (options: Options<CorrelateContentFilterEventData>) => queryOptions<CorrelateContentFilterEventResponse, CorrelateContentFilterEventError, CorrelateContentFilterEventResponse, ReturnType<typeof correlateContentFilterEventQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await correlateContentFilterEvent({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: correlateContentFilterEventQueryKey(options)
});

export const getGovernanceOverviewQueryKey = (options?: Options<GetGovernanceOverviewData>) => createQueryKey('getGovernanceOverview', options);

/**
 * Get Governance Overview
 *
 * Return a complete governance dashboard with policies, blocklists,
 * and deployment configuration pulled from the Azure Management API.
 */
export const getGovernanceOverviewOptions = (options?: Options<GetGovernanceOverviewData>) => queryOptions<GetGovernanceOverviewResponse, DefaultError, GetGovernanceOverviewResponse, ReturnType<typeof getGovernanceOverviewQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getGovernanceOverview({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getGovernanceOverviewQueryKey(options)
});

export const getLicenseDetailQueryKey = (options?: Options<GetLicenseDetailData>) => createQueryKey('getLicenseDetail', options);

/**
 * Get License Detail
 *
 * Get full license details (MH admin only).
 *
 * Includes all configuration, internal notes, and exempt domains.
 */
export const getLicenseDetailOptions = (options?: Options<GetLicenseDetailData>) => queryOptions<GetLicenseDetailResponse, DefaultError, GetLicenseDetailResponse, ReturnType<typeof getLicenseDetailQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getLicenseDetail({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getLicenseDetailQueryKey(options)
});

/**
 * Update License
 *
 * Update license configuration (MH admin only).
 *
 * Allows changing seat limits, expiry dates, exempt domains, etc.
 */
export const updateLicenseMutation = (options?: Partial<Options<UpdateLicenseData>>): UseMutationOptions<UpdateLicenseResponse, UpdateLicenseError, Options<UpdateLicenseData>> => {
    const mutationOptions: UseMutationOptions<UpdateLicenseResponse, UpdateLicenseError, Options<UpdateLicenseData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await updateLicense({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Resume Platform
 *
 * Resume the platform after suspension (MH admin only).
 *
 * Clears the suspension state and restores access for all users.
 */
export const resumePlatformMutation = (options?: Partial<Options<ResumePlatformData>>): UseMutationOptions<ResumePlatformResponse, ResumePlatformError, Options<ResumePlatformData>> => {
    const mutationOptions: UseMutationOptions<ResumePlatformResponse, ResumePlatformError, Options<ResumePlatformData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await resumePlatform({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getLicenseStatusQueryKey = (options?: Options<GetLicenseStatusData>) => createQueryKey('getLicenseStatus', options);

/**
 * Get License Status
 *
 * Get license status summary (any platform admin).
 *
 * Returns a lightweight view suitable for customer admin dashboards:
 * seat usage, expiry date, and overall status.
 */
export const getLicenseStatusOptions = (options?: Options<GetLicenseStatusData>) => queryOptions<GetLicenseStatusResponse, DefaultError, GetLicenseStatusResponse, ReturnType<typeof getLicenseStatusQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getLicenseStatus({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getLicenseStatusQueryKey(options)
});

/**
 * Suspend Platform
 *
 * Suspend the platform immediately (MH admin only).
 *
 * All non-exempt users will be locked out until the platform is resumed.
 * MH staff can still access to troubleshoot or export data.
 */
export const suspendPlatformMutation = (options?: Partial<Options<SuspendPlatformData>>): UseMutationOptions<SuspendPlatformResponse, SuspendPlatformError, Options<SuspendPlatformData>> => {
    const mutationOptions: UseMutationOptions<SuspendPlatformResponse, SuspendPlatformError, Options<SuspendPlatformData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await suspendPlatform({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const adminListModelsQueryKey = (options?: Options<AdminListModelsData>) => createQueryKey('adminListModels', options);

/**
 * Admin List Models
 *
 * List all models with admin details (includes disabled).
 */
export const adminListModelsOptions = (options?: Options<AdminListModelsData>) => queryOptions<AdminListModelsResponse, AdminListModelsError, AdminListModelsResponse, ReturnType<typeof adminListModelsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await adminListModels({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: adminListModelsQueryKey(options)
});

export const adminListModelsInfiniteQueryKey = (options?: Options<AdminListModelsData>): QueryKey<Options<AdminListModelsData>> => createQueryKey('adminListModels', options, true);

/**
 * Admin List Models
 *
 * List all models with admin details (includes disabled).
 */
export const adminListModelsInfiniteOptions = (options?: Options<AdminListModelsData>) => {
    const opts = infiniteQueryOptions<AdminListModelsResponse, AdminListModelsError, InfiniteData<AdminListModelsResponse>, QueryKey<Options<AdminListModelsData>>, number | Pick<QueryKey<Options<AdminListModelsData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<AdminListModelsData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                query: {
                    page: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await adminListModels({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: adminListModelsInfiniteQueryKey(options)
    });
    return opts as Omit<typeof opts, 'initialData'>;
};

/**
 * Admin Create Model
 *
 * Create a new AI model.
 */
export const adminCreateModelMutation = (options?: Partial<Options<AdminCreateModelData>>): UseMutationOptions<AdminCreateModelResponse, AdminCreateModelError, Options<AdminCreateModelData>> => {
    const mutationOptions: UseMutationOptions<AdminCreateModelResponse, AdminCreateModelError, Options<AdminCreateModelData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await adminCreateModel({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Admin Suggest Model
 *
 * Suggest configuration for a model based on its name.
 *
 * Uses the models.dev open-source database (https://models.dev) as the
 * primary source for model capabilities, pricing, and token limits.
 * Falls back to an LLM call when the model is not found in models.dev.
 *
 * When models.dev data IS available, the LLM is only used for fields
 * that models.dev doesn't cover (e.g. code_interpreter support) and to
 * normalize Azure-specific pricing when needed.
 *
 * When models.dev data is NOT available, falls back to the original
 * LLM-based approach with live Azure pricing + OpenAI docs scraping.
 */
export const adminSuggestModelMutation = (options?: Partial<Options<AdminSuggestModelData>>): UseMutationOptions<AdminSuggestModelResponse, AdminSuggestModelError, Options<AdminSuggestModelData>> => {
    const mutationOptions: UseMutationOptions<AdminSuggestModelResponse, AdminSuggestModelError, Options<AdminSuggestModelData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await adminSuggestModel({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const adminListTierDefaultsQueryKey = (options?: Options<AdminListTierDefaultsData>) => createQueryKey('adminListTierDefaults', options);

/**
 * Admin List Tier Defaults
 *
 * List all model tier defaults with their current assignments.
 */
export const adminListTierDefaultsOptions = (options?: Options<AdminListTierDefaultsData>) => queryOptions<AdminListTierDefaultsResponse, DefaultError, AdminListTierDefaultsResponse, ReturnType<typeof adminListTierDefaultsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await adminListTierDefaults({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: adminListTierDefaultsQueryKey(options)
});

/**
 * Admin Update Tier Default
 *
 * Update the model assignment for a specific tier.
 */
export const adminUpdateTierDefaultMutation = (options?: Partial<Options<AdminUpdateTierDefaultData>>): UseMutationOptions<AdminUpdateTierDefaultResponse, AdminUpdateTierDefaultError, Options<AdminUpdateTierDefaultData>> => {
    const mutationOptions: UseMutationOptions<AdminUpdateTierDefaultResponse, AdminUpdateTierDefaultError, Options<AdminUpdateTierDefaultData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await adminUpdateTierDefault({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Admin Delete Model
 *
 * Delete an AI model.
 */
export const adminDeleteModelMutation = (options?: Partial<Options<AdminDeleteModelData>>): UseMutationOptions<AdminDeleteModelResponse, AdminDeleteModelError, Options<AdminDeleteModelData>> => {
    const mutationOptions: UseMutationOptions<AdminDeleteModelResponse, AdminDeleteModelError, Options<AdminDeleteModelData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await adminDeleteModel({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const adminGetModelQueryKey = (options: Options<AdminGetModelData>) => createQueryKey('adminGetModel', options);

/**
 * Admin Get Model
 *
 * Get one model with admin details (includes disabled), for the new UI's configure page (MHS-714).
 */
export const adminGetModelOptions = (options: Options<AdminGetModelData>) => queryOptions<AdminGetModelResponse, AdminGetModelError, AdminGetModelResponse, ReturnType<typeof adminGetModelQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await adminGetModel({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: adminGetModelQueryKey(options)
});

/**
 * Admin Update Model
 *
 * Enable/disable a model or update settings.
 */
export const adminUpdateModelMutation = (options?: Partial<Options<AdminUpdateModelData>>): UseMutationOptions<AdminUpdateModelResponse, AdminUpdateModelError, Options<AdminUpdateModelData>> => {
    const mutationOptions: UseMutationOptions<AdminUpdateModelResponse, AdminUpdateModelError, Options<AdminUpdateModelData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await adminUpdateModel({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Admin Reassign Model
 *
 * Move a model's live agents and chats to an active replacement.
 */
export const adminReassignModelMutation = (options?: Partial<Options<AdminReassignModelData>>): UseMutationOptions<AdminReassignModelResponse, AdminReassignModelError, Options<AdminReassignModelData>> => {
    const mutationOptions: UseMutationOptions<AdminReassignModelResponse, AdminReassignModelError, Options<AdminReassignModelData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await adminReassignModel({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const adminListModelReferencesQueryKey = (options: Options<AdminListModelReferencesData>) => createQueryKey('adminListModelReferences', options);

/**
 * Admin List Model References
 *
 * Live agents and chats that still use a model.
 */
export const adminListModelReferencesOptions = (options: Options<AdminListModelReferencesData>) => queryOptions<AdminListModelReferencesResponse, AdminListModelReferencesError, AdminListModelReferencesResponse, ReturnType<typeof adminListModelReferencesQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await adminListModelReferences({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: adminListModelReferencesQueryKey(options)
});

export const getPlatformCostsQueryKey = (options?: Options<GetPlatformCostsData>) => createQueryKey('getPlatformCosts', options);

/**
 * Get Platform Costs
 *
 * Return platform cost data from Azure Cost Management.
 *
 * Includes total cost, breakdown by resource group, breakdown by
 * resource group + service, and a daily cost trend. Data is cached
 * for 1 hour since Azure billing data lags 24-48 hours.
 *
 * Uses ``PlatformAdminLight`` (no request-scoped DB session) because the
 * upstream Azure Cost Management call can take 2-3 minutes; holding a pooled
 * DB connection for that long can exhaust the pool and block other requests
 * (e.g. editing a budget). See the session-per-phase rule in AGENTS.md.
 */
export const getPlatformCostsOptions = (options?: Options<GetPlatformCostsData>) => queryOptions<GetPlatformCostsResponse, GetPlatformCostsError, GetPlatformCostsResponse, ReturnType<typeof getPlatformCostsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getPlatformCosts({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getPlatformCostsQueryKey(options)
});

export const platformListOauthClientsQueryKey = (options?: Options<PlatformListOauthClientsData>) => createQueryKey('platformListOauthClients', options);

/**
 * Platform List Oauth Clients
 *
 * List all registered OAuth clients.
 */
export const platformListOauthClientsOptions = (options?: Options<PlatformListOauthClientsData>) => queryOptions<PlatformListOauthClientsResponse, DefaultError, PlatformListOauthClientsResponse, ReturnType<typeof platformListOauthClientsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await platformListOauthClients({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: platformListOauthClientsQueryKey(options)
});

/**
 * Platform Create Oauth Client
 *
 * Register a new OAuth client. A confidential client's secret is returned once.
 */
export const platformCreateOauthClientMutation = (options?: Partial<Options<PlatformCreateOauthClientData>>): UseMutationOptions<PlatformCreateOauthClientResponse, PlatformCreateOauthClientError, Options<PlatformCreateOauthClientData>> => {
    const mutationOptions: UseMutationOptions<PlatformCreateOauthClientResponse, PlatformCreateOauthClientError, Options<PlatformCreateOauthClientData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await platformCreateOauthClient({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Platform Delete Oauth Client
 *
 * Delete a client. First-party clients cannot be deleted.
 */
export const platformDeleteOauthClientMutation = (options?: Partial<Options<PlatformDeleteOauthClientData>>): UseMutationOptions<PlatformDeleteOauthClientResponse, PlatformDeleteOauthClientError, Options<PlatformDeleteOauthClientData>> => {
    const mutationOptions: UseMutationOptions<PlatformDeleteOauthClientResponse, PlatformDeleteOauthClientError, Options<PlatformDeleteOauthClientData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await platformDeleteOauthClient({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Platform Update Oauth Client
 *
 * Update a client's mutable fields.
 */
export const platformUpdateOauthClientMutation = (options?: Partial<Options<PlatformUpdateOauthClientData>>): UseMutationOptions<PlatformUpdateOauthClientResponse, PlatformUpdateOauthClientError, Options<PlatformUpdateOauthClientData>> => {
    const mutationOptions: UseMutationOptions<PlatformUpdateOauthClientResponse, PlatformUpdateOauthClientError, Options<PlatformUpdateOauthClientData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await platformUpdateOauthClient({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const adminGetUsageQueryKey = (options?: Options<AdminGetUsageData>) => createQueryKey('adminGetUsage', options);

/**
 * Admin Get Usage
 *
 * Get platform usage statistics.
 */
export const adminGetUsageOptions = (options?: Options<AdminGetUsageData>) => queryOptions<AdminGetUsageResponse, AdminGetUsageError, AdminGetUsageResponse, ReturnType<typeof adminGetUsageQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await adminGetUsage({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: adminGetUsageQueryKey(options)
});

export const adminListUsersQueryKey = (options?: Options<AdminListUsersData>) => createQueryKey('adminListUsers', options);

/**
 * Admin List Users
 *
 * List all users.
 */
export const adminListUsersOptions = (options?: Options<AdminListUsersData>) => queryOptions<AdminListUsersResponse, AdminListUsersError, AdminListUsersResponse, ReturnType<typeof adminListUsersQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await adminListUsers({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: adminListUsersQueryKey(options)
});

export const adminListUsersInfiniteQueryKey = (options?: Options<AdminListUsersData>): QueryKey<Options<AdminListUsersData>> => createQueryKey('adminListUsers', options, true);

/**
 * Admin List Users
 *
 * List all users.
 */
export const adminListUsersInfiniteOptions = (options?: Options<AdminListUsersData>) => {
    const opts = infiniteQueryOptions<AdminListUsersResponse, AdminListUsersError, InfiniteData<AdminListUsersResponse>, QueryKey<Options<AdminListUsersData>>, number | Pick<QueryKey<Options<AdminListUsersData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<AdminListUsersData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                query: {
                    page: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await adminListUsers({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: adminListUsersInfiniteQueryKey(options)
    });
    return opts as Omit<typeof opts, 'initialData'>;
};

/**
 * Admin Create User
 *
 * Pre-provision a user before their first login.
 *
 * Creates a user record without an external_id (IdP subject identifier).
 * When the user logs in for the first time, the auth middleware will match
 * them by email and link their IdP identity automatically.
 *
 * The user is automatically added to the "Everyone" team. Additional teams
 * can be specified via `team_uuids`.
 */
export const adminCreateUserMutation = (options?: Partial<Options<AdminCreateUserData>>): UseMutationOptions<AdminCreateUserResponse, AdminCreateUserError, Options<AdminCreateUserData>> => {
    const mutationOptions: UseMutationOptions<AdminCreateUserResponse, AdminCreateUserError, Options<AdminCreateUserData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await adminCreateUser({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Admin Delete User
 *
 * Permanently delete a deactivated user who has never signed in.
 */
export const adminDeleteUserMutation = (options?: Partial<Options<AdminDeleteUserData>>): UseMutationOptions<AdminDeleteUserResponse, AdminDeleteUserError, Options<AdminDeleteUserData>> => {
    const mutationOptions: UseMutationOptions<AdminDeleteUserResponse, AdminDeleteUserError, Options<AdminDeleteUserData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await adminDeleteUser({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Admin Update User
 *
 * Update user (role, active status).
 *
 * When deactivating a user, an optional `deactivation_reason` can be provided.
 * When activating a user, the deactivation_reason is automatically cleared.
 *
 * Role assignment rules:
 * - Any platform_admin or install_admin can assign member or platform_admin roles.
 * - Only an install_admin can assign the install_admin role to another user.
 */
export const adminUpdateUserMutation = (options?: Partial<Options<AdminUpdateUserData>>): UseMutationOptions<AdminUpdateUserResponse, AdminUpdateUserError, Options<AdminUpdateUserData>> => {
    const mutationOptions: UseMutationOptions<AdminUpdateUserResponse, AdminUpdateUserError, Options<AdminUpdateUserData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await adminUpdateUser({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Clear All Agent Memory
 *
 * Delete everything every agent remembers about you.
 */
export const clearAllAgentMemoryMutation = (options?: Partial<Options<ClearAllAgentMemoryData>>): UseMutationOptions<ClearAllAgentMemoryResponse, DefaultError, Options<ClearAllAgentMemoryData>> => {
    const mutationOptions: UseMutationOptions<ClearAllAgentMemoryResponse, DefaultError, Options<ClearAllAgentMemoryData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await clearAllAgentMemory({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const listAgentMemoriesQueryKey = (options?: Options<ListAgentMemoriesData>) => createQueryKey('listAgentMemories', options);

/**
 * List Agent Memories
 *
 * Everything your agents remember about you, by agent (the default AnthmAI chat first).
 */
export const listAgentMemoriesOptions = (options?: Options<ListAgentMemoriesData>) => queryOptions<ListAgentMemoriesResponse, DefaultError, ListAgentMemoriesResponse, ReturnType<typeof listAgentMemoriesQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await listAgentMemories({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listAgentMemoriesQueryKey(options)
});

/**
 * Clear Agent Memory
 *
 * Delete everything one agent remembers about you (``default``: the default AnthmAI chat).
 */
export const clearAgentMemoryMutation = (options?: Partial<Options<ClearAgentMemoryData>>): UseMutationOptions<ClearAgentMemoryResponse, ClearAgentMemoryError, Options<ClearAgentMemoryData>> => {
    const mutationOptions: UseMutationOptions<ClearAgentMemoryResponse, ClearAgentMemoryError, Options<ClearAgentMemoryData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await clearAgentMemory({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Delete Agent Memory
 *
 * Delete one note (404 if it isn't yours, the same as missing).
 */
export const deleteAgentMemoryMutation = (options?: Partial<Options<DeleteAgentMemoryData>>): UseMutationOptions<DeleteAgentMemoryResponse, DeleteAgentMemoryError, Options<DeleteAgentMemoryData>> => {
    const mutationOptions: UseMutationOptions<DeleteAgentMemoryResponse, DeleteAgentMemoryError, Options<DeleteAgentMemoryData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await deleteAgentMemory({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const listAgentsQueryKey = (options?: Options<ListAgentsData>) => createQueryKey('listAgents', options);

/**
 * List Agents
 *
 * List agents the user can access.
 *
 * An agent is accessible when the user has a membership role on it (directly
 * or via a team), or is a platform admin. ``team_uuid`` filters by the agent's
 * organizational team association (not access).
 *
 * When ``project_uuid`` is provided, results are further restricted to agents
 * attached to that project as a resource.
 */
export const listAgentsOptions = (options?: Options<ListAgentsData>) => queryOptions<ListAgentsResponse, ListAgentsError, ListAgentsResponse, ReturnType<typeof listAgentsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await listAgents({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listAgentsQueryKey(options)
});

export const listAgentsInfiniteQueryKey = (options?: Options<ListAgentsData>): QueryKey<Options<ListAgentsData>> => createQueryKey('listAgents', options, true);

/**
 * List Agents
 *
 * List agents the user can access.
 *
 * An agent is accessible when the user has a membership role on it (directly
 * or via a team), or is a platform admin. ``team_uuid`` filters by the agent's
 * organizational team association (not access).
 *
 * When ``project_uuid`` is provided, results are further restricted to agents
 * attached to that project as a resource.
 */
export const listAgentsInfiniteOptions = (options?: Options<ListAgentsData>) => {
    const opts = infiniteQueryOptions<ListAgentsResponse, ListAgentsError, InfiniteData<ListAgentsResponse>, QueryKey<Options<ListAgentsData>>, number | Pick<QueryKey<Options<ListAgentsData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<ListAgentsData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                query: {
                    page: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await listAgents({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: listAgentsInfiniteQueryKey(options)
    });
    return opts as Omit<typeof opts, 'initialData'>;
};

/**
 * Create Agent
 *
 * Create a new agent.
 *
 * The agent is created in the specified team.
 */
export const createAgentMutation = (options?: Partial<Options<CreateAgentData>>): UseMutationOptions<CreateAgentResponse, CreateAgentError, Options<CreateAgentData>> => {
    const mutationOptions: UseMutationOptions<CreateAgentResponse, CreateAgentError, Options<CreateAgentData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await createAgent({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const listAgentPinsQueryKey = (options?: Options<ListAgentPinsData>) => createQueryKey('listAgentPins', options);

/**
 * List Agent Pins
 *
 * The caller's starred agents, in pin order (Home's "Pinned agents").
 */
export const listAgentPinsOptions = (options?: Options<ListAgentPinsData>) => queryOptions<ListAgentPinsResponse, DefaultError, ListAgentPinsResponse, ReturnType<typeof listAgentPinsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await listAgentPins({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listAgentPinsQueryKey(options)
});

/**
 * Add Agent Pin
 *
 * Star an agent. Requires view access to it.
 */
export const addAgentPinMutation = (options?: Partial<Options<AddAgentPinData>>): UseMutationOptions<AddAgentPinResponse, AddAgentPinError, Options<AddAgentPinData>> => {
    const mutationOptions: UseMutationOptions<AddAgentPinResponse, AddAgentPinError, Options<AddAgentPinData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await addAgentPin({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Remove Agent Pin
 *
 * Unstar an agent.
 */
export const removeAgentPinMutation = (options?: Partial<Options<RemoveAgentPinData>>): UseMutationOptions<RemoveAgentPinResponse, RemoveAgentPinError, Options<RemoveAgentPinData>> => {
    const mutationOptions: UseMutationOptions<RemoveAgentPinResponse, RemoveAgentPinError, Options<RemoveAgentPinData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await removeAgentPin({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Delete Agent
 *
 * Delete an agent (soft delete).
 *
 * Only the creator or platform admin can delete an agent.
 */
export const deleteAgentMutation = (options?: Partial<Options<DeleteAgentData>>): UseMutationOptions<DeleteAgentResponse, DeleteAgentError, Options<DeleteAgentData>> => {
    const mutationOptions: UseMutationOptions<DeleteAgentResponse, DeleteAgentError, Options<DeleteAgentData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await deleteAgent({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getAgentQueryKey = (options: Options<GetAgentData>) => createQueryKey('getAgent', options);

/**
 * Get Agent
 *
 * Get agent details.
 */
export const getAgentOptions = (options: Options<GetAgentData>) => queryOptions<GetAgentResponse, GetAgentError, GetAgentResponse, ReturnType<typeof getAgentQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getAgent({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getAgentQueryKey(options)
});

/**
 * Update Agent
 *
 * Update an agent.
 *
 * Only the creator or platform admin can update an agent.
 */
export const updateAgentMutation = (options?: Partial<Options<UpdateAgentData>>): UseMutationOptions<UpdateAgentResponse, UpdateAgentError, Options<UpdateAgentData>> => {
    const mutationOptions: UseMutationOptions<UpdateAgentResponse, UpdateAgentError, Options<UpdateAgentData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await updateAgent({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const listAgentConnectorsQueryKey = (options: Options<ListAgentConnectorsData>) => createQueryKey('listAgentConnectors', options);

/**
 * List Agent Connectors
 *
 * The agent's connectors (viewer+), and whether I can use each.
 */
export const listAgentConnectorsOptions = (options: Options<ListAgentConnectorsData>) => queryOptions<ListAgentConnectorsResponse, ListAgentConnectorsError, ListAgentConnectorsResponse, ReturnType<typeof listAgentConnectorsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await listAgentConnectors({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listAgentConnectorsQueryKey(options)
});

/**
 * Set Agent Connectors
 *
 * Replace the agent's connectors (editor+; each new one must be one I can use).
 */
export const setAgentConnectorsMutation = (options?: Partial<Options<SetAgentConnectorsData>>): UseMutationOptions<SetAgentConnectorsResponse, SetAgentConnectorsError, Options<SetAgentConnectorsData>> => {
    const mutationOptions: UseMutationOptions<SetAgentConnectorsResponse, SetAgentConnectorsError, Options<SetAgentConnectorsData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await setAgentConnectors({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const agentDeleteImpactQueryKey = (options: Options<AgentDeleteImpactData>) => createQueryKey('agentDeleteImpact', options);

/**
 * Agent Delete Impact
 *
 * What deleting this agent would affect: the skill imported alongside it,
 * and whether that skill is attached to other agents (MHS-359).
 */
export const agentDeleteImpactOptions = (options: Options<AgentDeleteImpactData>) => queryOptions<AgentDeleteImpactResponse2, AgentDeleteImpactError, AgentDeleteImpactResponse2, ReturnType<typeof agentDeleteImpactQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await agentDeleteImpact({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: agentDeleteImpactQueryKey(options)
});

export const getAgentMembersQueryKey = (options: Options<GetAgentMembersData>) => createQueryKey('getAgentMembers', options);

/**
 * Get Agent Members
 *
 * List an agent's user + team members and the caller's effective role.
 *
 * Any user who can view the agent may read its membership.
 */
export const getAgentMembersOptions = (options: Options<GetAgentMembersData>) => queryOptions<GetAgentMembersResponse, GetAgentMembersError, GetAgentMembersResponse, ReturnType<typeof getAgentMembersQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getAgentMembers({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getAgentMembersQueryKey(options)
});

/**
 * Add Agent Team Member
 *
 * Add (or update) a team's role on an agent. Requires agent admin.
 *
 * Granting a role to the special "Everyone" team makes the agent available
 * org-wide at that role.
 */
export const addAgentTeamMemberMutation = (options?: Partial<Options<AddAgentTeamMemberData>>): UseMutationOptions<AddAgentTeamMemberResponse, AddAgentTeamMemberError, Options<AddAgentTeamMemberData>> => {
    const mutationOptions: UseMutationOptions<AddAgentTeamMemberResponse, AddAgentTeamMemberError, Options<AddAgentTeamMemberData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await addAgentTeamMember({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Remove Agent Team Member
 *
 * Remove a team member. Requires agent admin (cannot remove the last admin).
 */
export const removeAgentTeamMemberMutation = (options?: Partial<Options<RemoveAgentTeamMemberData>>): UseMutationOptions<RemoveAgentTeamMemberResponse, RemoveAgentTeamMemberError, Options<RemoveAgentTeamMemberData>> => {
    const mutationOptions: UseMutationOptions<RemoveAgentTeamMemberResponse, RemoveAgentTeamMemberError, Options<RemoveAgentTeamMemberData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await removeAgentTeamMember({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Update Agent Team Member
 *
 * Change a team member's role. Requires agent admin. 404 if not a member.
 */
export const updateAgentTeamMemberMutation = (options?: Partial<Options<UpdateAgentTeamMemberData>>): UseMutationOptions<UpdateAgentTeamMemberResponse, UpdateAgentTeamMemberError, Options<UpdateAgentTeamMemberData>> => {
    const mutationOptions: UseMutationOptions<UpdateAgentTeamMemberResponse, UpdateAgentTeamMemberError, Options<UpdateAgentTeamMemberData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await updateAgentTeamMember({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Add Agent User Member
 *
 * Add (or update) a user's role on an agent. Requires agent admin.
 */
export const addAgentUserMemberMutation = (options?: Partial<Options<AddAgentUserMemberData>>): UseMutationOptions<AddAgentUserMemberResponse, AddAgentUserMemberError, Options<AddAgentUserMemberData>> => {
    const mutationOptions: UseMutationOptions<AddAgentUserMemberResponse, AddAgentUserMemberError, Options<AddAgentUserMemberData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await addAgentUserMember({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Remove Agent User Member
 *
 * Remove a user member. Requires agent admin (cannot remove the last admin).
 */
export const removeAgentUserMemberMutation = (options?: Partial<Options<RemoveAgentUserMemberData>>): UseMutationOptions<RemoveAgentUserMemberResponse, RemoveAgentUserMemberError, Options<RemoveAgentUserMemberData>> => {
    const mutationOptions: UseMutationOptions<RemoveAgentUserMemberResponse, RemoveAgentUserMemberError, Options<RemoveAgentUserMemberData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await removeAgentUserMember({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Update Agent User Member
 *
 * Change a user member's role. Requires agent admin.
 */
export const updateAgentUserMemberMutation = (options?: Partial<Options<UpdateAgentUserMemberData>>): UseMutationOptions<UpdateAgentUserMemberResponse, UpdateAgentUserMemberError, Options<UpdateAgentUserMemberData>> => {
    const mutationOptions: UseMutationOptions<UpdateAgentUserMemberResponse, UpdateAgentUserMemberError, Options<UpdateAgentUserMemberData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await updateAgentUserMember({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const listAgentSkillsQueryKey = (options: Options<ListAgentSkillsData>) => createQueryKey('listAgentSkills', options);

/**
 * List Agent Skills
 *
 * List skills attached to an agent.
 *
 * Returns skills ordered by priority (highest first).
 */
export const listAgentSkillsOptions = (options: Options<ListAgentSkillsData>) => queryOptions<ListAgentSkillsResponse, ListAgentSkillsError, ListAgentSkillsResponse, ReturnType<typeof listAgentSkillsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await listAgentSkills({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listAgentSkillsQueryKey(options)
});

/**
 * Attach Skills To Agent
 *
 * Attach one or more skills to an agent.
 *
 * If a skill is already attached, it will be updated with the new config.
 * Tools required by the skill are auto-provisioned onto the agent.
 */
export const attachSkillsToAgentMutation = (options?: Partial<Options<AttachSkillsToAgentData>>): UseMutationOptions<AttachSkillsToAgentResponse, AttachSkillsToAgentError, Options<AttachSkillsToAgentData>> => {
    const mutationOptions: UseMutationOptions<AttachSkillsToAgentResponse, AttachSkillsToAgentError, Options<AttachSkillsToAgentData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await attachSkillsToAgent({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Detach Skill From Agent
 *
 * Detach a skill from an agent.
 *
 * The skill itself is not deleted, only the association.
 * Tools that were auto-provisioned by this skill (and not needed by other skills)
 * are automatically de-provisioned.
 */
export const detachSkillFromAgentMutation = (options?: Partial<Options<DetachSkillFromAgentData>>): UseMutationOptions<DetachSkillFromAgentResponse, DetachSkillFromAgentError, Options<DetachSkillFromAgentData>> => {
    const mutationOptions: UseMutationOptions<DetachSkillFromAgentResponse, DetachSkillFromAgentError, Options<DetachSkillFromAgentData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await detachSkillFromAgent({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Update Agent Skill
 *
 * Update a skill's configuration on an agent.
 *
 * Only updates fields that are provided.
 */
export const updateAgentSkillMutation = (options?: Partial<Options<UpdateAgentSkillData>>): UseMutationOptions<UpdateAgentSkillResponse, UpdateAgentSkillError, Options<UpdateAgentSkillData>> => {
    const mutationOptions: UseMutationOptions<UpdateAgentSkillResponse, UpdateAgentSkillError, Options<UpdateAgentSkillData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await updateAgentSkill({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Stream Agent
 *
 * Stream an agent response via OperationManager.
 *
 * Returns ``{"operation_id": "...", "session_uuid": "..."}`` immediately (HTTP 202).
 * The actual LLM streaming runs as a background ``asyncio.Task``.
 * Subscribe to progress via ``GET /api/v1/operations/{operation_id}/stream``.
 *
 * Executes the agent with tool calling. Tool execution happens
 * in between streams, only the final response is streamed.
 */
export const streamAgentMutation = (options?: Partial<Options<StreamAgentData>>): UseMutationOptions<StreamAgentResponse, StreamAgentError, Options<StreamAgentData>> => {
    const mutationOptions: UseMutationOptions<StreamAgentResponse, StreamAgentError, Options<StreamAgentData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await streamAgent({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const listApiKeysQueryKey = (options?: Options<ListApiKeysData>) => createQueryKey('listApiKeys', options);

/**
 * List Api Keys
 *
 * List all API keys for the current user (never returns the key itself).
 */
export const listApiKeysOptions = (options?: Options<ListApiKeysData>) => queryOptions<ListApiKeysResponse, DefaultError, ListApiKeysResponse, ReturnType<typeof listApiKeysQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await listApiKeys({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listApiKeysQueryKey(options)
});

/**
 * Create Api Key
 *
 * Generate a new API key. The full key is returned only once.
 */
export const createApiKeyMutation = (options?: Partial<Options<CreateApiKeyData>>): UseMutationOptions<CreateApiKeyResponse, CreateApiKeyError, Options<CreateApiKeyData>> => {
    const mutationOptions: UseMutationOptions<CreateApiKeyResponse, CreateApiKeyError, Options<CreateApiKeyData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await createApiKey({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Revoke Api Key
 *
 * Revoke an API key (soft delete).
 */
export const revokeApiKeyMutation = (options?: Partial<Options<RevokeApiKeyData>>): UseMutationOptions<RevokeApiKeyResponse, RevokeApiKeyError, Options<RevokeApiKeyData>> => {
    const mutationOptions: UseMutationOptions<RevokeApiKeyResponse, RevokeApiKeyError, Options<RevokeApiKeyData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await revokeApiKey({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getCurrentUserInfoQueryKey = (options?: Options<GetCurrentUserInfoData>) => createQueryKey('getCurrentUserInfo', options);

/**
 * Get Current User Info
 *
 * Get current authenticated user information.
 *
 * Returns user profile and list of teams they belong to.
 */
export const getCurrentUserInfoOptions = (options?: Options<GetCurrentUserInfoData>) => queryOptions<GetCurrentUserInfoResponse, DefaultError, GetCurrentUserInfoResponse, ReturnType<typeof getCurrentUserInfoQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getCurrentUserInfo({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getCurrentUserInfoQueryKey(options)
});

/**
 * Update User Settings
 *
 * Update current user's settings.
 *
 * Only fields present in the request body are applied; absent fields are
 * left unchanged.  Sending ``null`` for a field removes it from settings.
 *
 * Adding a new user setting requires only adding the field to
 * ``UserSettingsUpdate`` — no whitelist or manual mapping needed.
 */
export const updateUserSettingsMutation = (options?: Partial<Options<UpdateUserSettingsData>>): UseMutationOptions<UpdateUserSettingsResponse, UpdateUserSettingsError, Options<UpdateUserSettingsData>> => {
    const mutationOptions: UseMutationOptions<UpdateUserSettingsResponse, UpdateUserSettingsError, Options<UpdateUserSettingsData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await updateUserSettings({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const searchUsersQueryKey = (options: Options<SearchUsersData>) => createQueryKey('searchUsers', options);

/**
 * Search Users
 *
 * Search for platform users by name or email.
 *
 * Returns up to 10 matching users, excluding the current user.
 * Used by the share dialog to find users to share with.
 */
export const searchUsersOptions = (options: Options<SearchUsersData>) => queryOptions<SearchUsersResponse, SearchUsersError, SearchUsersResponse, ReturnType<typeof searchUsersQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await searchUsers({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: searchUsersQueryKey(options)
});

export const listMyAuthorizationsQueryKey = (options?: Options<ListMyAuthorizationsData>) => createQueryKey('listMyAuthorizations', options);

/**
 * List My Authorizations
 *
 * List the current user's cached delegated authorizations.
 */
export const listMyAuthorizationsOptions = (options?: Options<ListMyAuthorizationsData>) => queryOptions<ListMyAuthorizationsResponse, DefaultError, ListMyAuthorizationsResponse, ReturnType<typeof listMyAuthorizationsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await listMyAuthorizations({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listMyAuthorizationsQueryKey(options)
});

export const listAllAuthorizationsQueryKey = (options?: Options<ListAllAuthorizationsData>) => createQueryKey('listAllAuthorizations', options);

/**
 * List All Authorizations
 *
 * Admin: list all cached authorizations across the organization.
 */
export const listAllAuthorizationsOptions = (options?: Options<ListAllAuthorizationsData>) => queryOptions<ListAllAuthorizationsResponse, DefaultError, ListAllAuthorizationsResponse, ReturnType<typeof listAllAuthorizationsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await listAllAuthorizations({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listAllAuthorizationsQueryKey(options)
});

/**
 * Revoke My Authorization
 *
 * Revoke (delete) the current user's authorization for a purpose.
 */
export const revokeMyAuthorizationMutation = (options?: Partial<Options<RevokeMyAuthorizationData>>): UseMutationOptions<RevokeMyAuthorizationResponse, RevokeMyAuthorizationError, Options<RevokeMyAuthorizationData>> => {
    const mutationOptions: UseMutationOptions<RevokeMyAuthorizationResponse, RevokeMyAuthorizationError, Options<RevokeMyAuthorizationData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await revokeMyAuthorization({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const listBrandsQueryKey = (options?: Options<ListBrandsData>) => createQueryKey('listBrands', options);

/**
 * List Brands
 *
 * List brands the caller can access (plus the company default).
 */
export const listBrandsOptions = (options?: Options<ListBrandsData>) => queryOptions<ListBrandsResponse, ListBrandsError, ListBrandsResponse, ReturnType<typeof listBrandsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await listBrands({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listBrandsQueryKey(options)
});

export const listBrandsInfiniteQueryKey = (options?: Options<ListBrandsData>): QueryKey<Options<ListBrandsData>> => createQueryKey('listBrands', options, true);

/**
 * List Brands
 *
 * List brands the caller can access (plus the company default).
 */
export const listBrandsInfiniteOptions = (options?: Options<ListBrandsData>) => {
    const opts = infiniteQueryOptions<ListBrandsResponse, ListBrandsError, InfiniteData<ListBrandsResponse>, QueryKey<Options<ListBrandsData>>, number | Pick<QueryKey<Options<ListBrandsData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<ListBrandsData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                query: {
                    page: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await listBrands({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: listBrandsInfiniteQueryKey(options)
    });
    return opts as Omit<typeof opts, 'initialData'>;
};

/**
 * Create Brand
 *
 * Create a brand owned (admin) by the caller.
 */
export const createBrandMutation = (options?: Partial<Options<CreateBrandData>>): UseMutationOptions<CreateBrandResponse, CreateBrandError, Options<CreateBrandData>> => {
    const mutationOptions: UseMutationOptions<CreateBrandResponse, CreateBrandError, Options<CreateBrandData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await createBrand({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Extract Brand
 *
 * Extract a draft brand kit + logo candidates from a guidelines document.
 *
 * Non-persisting: returns a draft for the user to review/edit before saving
 * via the normal create/update endpoints. Any authenticated user may extract;
 * saving still enforces brand permissions. No DB session is held during the
 * (potentially slow) document parse + LLM call.
 */
export const extractBrandMutation = (options?: Partial<Options<ExtractBrandData>>): UseMutationOptions<ExtractBrandResponse, ExtractBrandError, Options<ExtractBrandData>> => {
    const mutationOptions: UseMutationOptions<ExtractBrandResponse, ExtractBrandError, Options<ExtractBrandData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await extractBrand({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Delete Brand
 *
 * Soft-delete a brand (admin only). The company default is protected.
 */
export const deleteBrandMutation = (options?: Partial<Options<DeleteBrandData>>): UseMutationOptions<DeleteBrandResponse, DeleteBrandError, Options<DeleteBrandData>> => {
    const mutationOptions: UseMutationOptions<DeleteBrandResponse, DeleteBrandError, Options<DeleteBrandData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await deleteBrand({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getBrandQueryKey = (options: Options<GetBrandData>) => createQueryKey('getBrand', options);

/**
 * Get Brand
 *
 * Get a single brand.
 */
export const getBrandOptions = (options: Options<GetBrandData>) => queryOptions<GetBrandResponse, GetBrandError, GetBrandResponse, ReturnType<typeof getBrandQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getBrand({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getBrandQueryKey(options)
});

/**
 * Update Brand
 *
 * Update a brand's metadata/tokens (editor+ only).
 */
export const updateBrandMutation = (options?: Partial<Options<UpdateBrandData>>): UseMutationOptions<UpdateBrandResponse, UpdateBrandError, Options<UpdateBrandData>> => {
    const mutationOptions: UseMutationOptions<UpdateBrandResponse, UpdateBrandError, Options<UpdateBrandData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await updateBrand({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Upload Brand Logo
 *
 * Upload/replace a brand's logo image (editor+ only).
 *
 * Session-per-phase: authz runs on the request session, the blob upload
 * happens after that session is out of scope, and persistence uses a fresh
 * short-lived session — no pooled connection is held during the Blob call.
 */
export const uploadBrandLogoMutation = (options?: Partial<Options<UploadBrandLogoData>>): UseMutationOptions<UploadBrandLogoResponse, UploadBrandLogoError, Options<UploadBrandLogoData>> => {
    const mutationOptions: UseMutationOptions<UploadBrandLogoResponse, UploadBrandLogoError, Options<UploadBrandLogoData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await uploadBrandLogo({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getBrandMembersQueryKey = (options: Options<GetBrandMembersData>) => createQueryKey('getBrandMembers', options);

/**
 * Get Brand Members
 *
 * List a brand's members (viewer+).
 */
export const getBrandMembersOptions = (options: Options<GetBrandMembersData>) => queryOptions<GetBrandMembersResponse, GetBrandMembersError, GetBrandMembersResponse, ReturnType<typeof getBrandMembersQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getBrandMembers({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getBrandMembersQueryKey(options)
});

/**
 * Add Brand Team Member
 *
 * Grant a team a role on a brand (admin only).
 */
export const addBrandTeamMemberMutation = (options?: Partial<Options<AddBrandTeamMemberData>>): UseMutationOptions<AddBrandTeamMemberResponse, AddBrandTeamMemberError, Options<AddBrandTeamMemberData>> => {
    const mutationOptions: UseMutationOptions<AddBrandTeamMemberResponse, AddBrandTeamMemberError, Options<AddBrandTeamMemberData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await addBrandTeamMember({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Remove Brand Team Member
 *
 * Remove a team member (admin only; never the last admin).
 */
export const removeBrandTeamMemberMutation = (options?: Partial<Options<RemoveBrandTeamMemberData>>): UseMutationOptions<RemoveBrandTeamMemberResponse, RemoveBrandTeamMemberError, Options<RemoveBrandTeamMemberData>> => {
    const mutationOptions: UseMutationOptions<RemoveBrandTeamMemberResponse, RemoveBrandTeamMemberError, Options<RemoveBrandTeamMemberData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await removeBrandTeamMember({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Update Brand Team Member
 *
 * Change a team member's role (admin only).
 */
export const updateBrandTeamMemberMutation = (options?: Partial<Options<UpdateBrandTeamMemberData>>): UseMutationOptions<UpdateBrandTeamMemberResponse, UpdateBrandTeamMemberError, Options<UpdateBrandTeamMemberData>> => {
    const mutationOptions: UseMutationOptions<UpdateBrandTeamMemberResponse, UpdateBrandTeamMemberError, Options<UpdateBrandTeamMemberData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await updateBrandTeamMember({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Add Brand User Member
 *
 * Grant a user a role on a brand (admin only).
 */
export const addBrandUserMemberMutation = (options?: Partial<Options<AddBrandUserMemberData>>): UseMutationOptions<AddBrandUserMemberResponse, AddBrandUserMemberError, Options<AddBrandUserMemberData>> => {
    const mutationOptions: UseMutationOptions<AddBrandUserMemberResponse, AddBrandUserMemberError, Options<AddBrandUserMemberData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await addBrandUserMember({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Remove Brand User Member
 *
 * Remove a user member (admin only; never the last admin).
 */
export const removeBrandUserMemberMutation = (options?: Partial<Options<RemoveBrandUserMemberData>>): UseMutationOptions<RemoveBrandUserMemberResponse, RemoveBrandUserMemberError, Options<RemoveBrandUserMemberData>> => {
    const mutationOptions: UseMutationOptions<RemoveBrandUserMemberResponse, RemoveBrandUserMemberError, Options<RemoveBrandUserMemberData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await removeBrandUserMember({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Update Brand User Member
 *
 * Change a user member's role (admin only).
 */
export const updateBrandUserMemberMutation = (options?: Partial<Options<UpdateBrandUserMemberData>>): UseMutationOptions<UpdateBrandUserMemberResponse, UpdateBrandUserMemberError, Options<UpdateBrandUserMemberData>> => {
    const mutationOptions: UseMutationOptions<UpdateBrandUserMemberResponse, UpdateBrandUserMemberError, Options<UpdateBrandUserMemberData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await updateBrandUserMember({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const listBrandTemplatesQueryKey = (options: Options<ListBrandTemplatesData>) => createQueryKey('listBrandTemplates', options);

/**
 * List Brand Templates
 *
 * List a brand's templates (viewer+).
 */
export const listBrandTemplatesOptions = (options: Options<ListBrandTemplatesData>) => queryOptions<ListBrandTemplatesResponse, ListBrandTemplatesError, ListBrandTemplatesResponse, ReturnType<typeof listBrandTemplatesQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await listBrandTemplates({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listBrandTemplatesQueryKey(options)
});

/**
 * Delete Brand Template
 *
 * Remove the brand's template for one format (editor+ only).
 */
export const deleteBrandTemplateMutation = (options?: Partial<Options<DeleteBrandTemplateData>>): UseMutationOptions<DeleteBrandTemplateResponse, DeleteBrandTemplateError, Options<DeleteBrandTemplateData>> => {
    const mutationOptions: UseMutationOptions<DeleteBrandTemplateResponse, DeleteBrandTemplateError, Options<DeleteBrandTemplateData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await deleteBrandTemplate({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Upload Brand Template
 *
 * Upload or replace the brand's template for one format (editor+ only).
 *
 * The file must be a real Office package of that format with no macros, ActiveX or embedded
 * objects. A .potx/.dotx/.xltx is stored as a .pptx/.docx/.xlsx. Session-per-phase like the logo upload.
 */
export const uploadBrandTemplateMutation = (options?: Partial<Options<UploadBrandTemplateData>>): UseMutationOptions<UploadBrandTemplateResponse, UploadBrandTemplateError, Options<UploadBrandTemplateData>> => {
    const mutationOptions: UseMutationOptions<UploadBrandTemplateResponse, UploadBrandTemplateError, Options<UploadBrandTemplateData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await uploadBrandTemplate({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const downloadBrandTemplateQueryKey = (options: Options<DownloadBrandTemplateData>) => createQueryKey('downloadBrandTemplate', options);

/**
 * Download Brand Template
 *
 * Download the brand's template for one format (viewer+).
 */
export const downloadBrandTemplateOptions = (options: Options<DownloadBrandTemplateData>) => queryOptions<unknown, DownloadBrandTemplateError, unknown, ReturnType<typeof downloadBrandTemplateQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await downloadBrandTemplate({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: downloadBrandTemplateQueryKey(options)
});

export const getBrandTemplateThumbnailQueryKey = (options: Options<GetBrandTemplateThumbnailData>) => createQueryKey('getBrandTemplateThumbnail', options);

/**
 * Get Brand Template Thumbnail
 *
 * The preview image embedded in the template, when it has one (viewer+).
 */
export const getBrandTemplateThumbnailOptions = (options: Options<GetBrandTemplateThumbnailData>) => queryOptions<unknown, GetBrandTemplateThumbnailError, unknown, ReturnType<typeof getBrandTemplateThumbnailQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getBrandTemplateThumbnail({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getBrandTemplateThumbnailQueryKey(options)
});

export const listMessageAttachmentsQueryKey = (options: Options<ListMessageAttachmentsData>) => createQueryKey('listMessageAttachments', options);

/**
 * List Message Attachments
 *
 * One page of a message's attachments (its own files, then files it references), for long histories.
 */
export const listMessageAttachmentsOptions = (options: Options<ListMessageAttachmentsData>) => queryOptions<ListMessageAttachmentsResponse, ListMessageAttachmentsError, ListMessageAttachmentsResponse, ReturnType<typeof listMessageAttachmentsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await listMessageAttachments({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listMessageAttachmentsQueryKey(options)
});

export const listMessageAttachmentsInfiniteQueryKey = (options: Options<ListMessageAttachmentsData>): QueryKey<Options<ListMessageAttachmentsData>> => createQueryKey('listMessageAttachments', options, true);

/**
 * List Message Attachments
 *
 * One page of a message's attachments (its own files, then files it references), for long histories.
 */
export const listMessageAttachmentsInfiniteOptions = (options: Options<ListMessageAttachmentsData>) => {
    const opts = infiniteQueryOptions<ListMessageAttachmentsResponse, ListMessageAttachmentsError, InfiniteData<ListMessageAttachmentsResponse>, QueryKey<Options<ListMessageAttachmentsData>>, string | null | Pick<QueryKey<Options<ListMessageAttachmentsData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<ListMessageAttachmentsData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                query: {
                    cursor: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await listMessageAttachments({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: listMessageAttachmentsInfiniteQueryKey(options)
    });
    return opts as Omit<typeof opts, 'initialData'>;
};

/**
 * Attachment Status
 *
 * Authoritative lifecycle/capabilities/state_version from canonical state (no runtime call).
 */
export const attachmentStatusMutation = (options?: Partial<Options<AttachmentStatusData>>): UseMutationOptions<AttachmentStatusResponse2, DefaultError, Options<AttachmentStatusData>> => {
    const mutationOptions: UseMutationOptions<AttachmentStatusResponse2, DefaultError, Options<AttachmentStatusData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await attachmentStatus({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getAttachmentLimitsQueryKey = (options?: Options<GetAttachmentLimitsData>) => createQueryKey('getAttachmentLimits', options);

/**
 * Get Attachment Limits
 *
 * Size, type and count limits for chat attachment uploads.
 *
 * Clients check files against these before uploading; the upload endpoint
 * enforces the same limits (413 ``file_too_large``, 415
 * ``unsupported_file_type``, 400 ``too_many_files``).
 */
export const getAttachmentLimitsOptions = (options?: Options<GetAttachmentLimitsData>) => queryOptions<GetAttachmentLimitsResponse, DefaultError, GetAttachmentLimitsResponse, ReturnType<typeof getAttachmentLimitsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getAttachmentLimits({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getAttachmentLimitsQueryKey(options)
});

export const chatListSessionsQueryKey = (options?: Options<ChatListSessionsData>) => createQueryKey('chatListSessions', options);

/**
 * List Sessions
 *
 * List user's chat sessions.
 *
 * Sessions are ordered by most recently updated first.
 */
export const chatListSessionsOptions = (options?: Options<ChatListSessionsData>) => queryOptions<ChatListSessionsResponse, ChatListSessionsError, ChatListSessionsResponse, ReturnType<typeof chatListSessionsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await chatListSessions({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: chatListSessionsQueryKey(options)
});

export const chatListSessionsInfiniteQueryKey = (options?: Options<ChatListSessionsData>): QueryKey<Options<ChatListSessionsData>> => createQueryKey('chatListSessions', options, true);

/**
 * List Sessions
 *
 * List user's chat sessions.
 *
 * Sessions are ordered by most recently updated first.
 */
export const chatListSessionsInfiniteOptions = (options?: Options<ChatListSessionsData>) => {
    const opts = infiniteQueryOptions<ChatListSessionsResponse, ChatListSessionsError, InfiniteData<ChatListSessionsResponse>, QueryKey<Options<ChatListSessionsData>>, number | Pick<QueryKey<Options<ChatListSessionsData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<ChatListSessionsData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                query: {
                    page: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await chatListSessions({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: chatListSessionsInfiniteQueryKey(options)
    });
    return opts as Omit<typeof opts, 'initialData'>;
};

/**
 * Create Session
 *
 * Create a new chat session. With ``spaceUuid`` the chat starts in that
 * space; any member (viewer+) can, since asking questions is what viewers do.
 * The chat is the caller's own; changing the space still needs editor.
 */
export const chatCreateSessionMutation = (options?: Partial<Options<ChatCreateSessionData>>): UseMutationOptions<ChatCreateSessionResponse, ChatCreateSessionError, Options<ChatCreateSessionData>> => {
    const mutationOptions: UseMutationOptions<ChatCreateSessionResponse, ChatCreateSessionError, Options<ChatCreateSessionData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await chatCreateSession({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Edit With Ai
 *
 * The chat to edit a Build entity in (MHS-733): the chat that built it when it is yours, otherwise a new
 * build chat opened for it. Needs edit access to the entity.
 */
export const editWithAiMutation = (options?: Partial<Options<EditWithAiData>>): UseMutationOptions<EditWithAiResponse, EditWithAiError, Options<EditWithAiData>> => {
    const mutationOptions: UseMutationOptions<EditWithAiResponse, EditWithAiError, Options<EditWithAiData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await editWithAi({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Delete Session
 *
 * Delete a chat session (soft delete).
 */
export const chatDeleteSessionMutation = (options?: Partial<Options<ChatDeleteSessionData>>): UseMutationOptions<ChatDeleteSessionResponse, ChatDeleteSessionError, Options<ChatDeleteSessionData>> => {
    const mutationOptions: UseMutationOptions<ChatDeleteSessionResponse, ChatDeleteSessionError, Options<ChatDeleteSessionData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await chatDeleteSession({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const chatGetSessionQueryKey = (options: Options<ChatGetSessionData>) => createQueryKey('chatGetSession', options);

/**
 * Get Session
 *
 * Get chat session with messages (``attachmentsLimit`` pages each message's attachments).
 */
export const chatGetSessionOptions = (options: Options<ChatGetSessionData>) => queryOptions<ChatGetSessionResponse, ChatGetSessionError, ChatGetSessionResponse, ReturnType<typeof chatGetSessionQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await chatGetSession({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: chatGetSessionQueryKey(options)
});

/**
 * Update Session
 *
 * Update a chat session (title, starred status, reasoning effort).
 */
export const chatUpdateSessionMutation = (options?: Partial<Options<ChatUpdateSessionData>>): UseMutationOptions<ChatUpdateSessionResponse, ChatUpdateSessionError, Options<ChatUpdateSessionData>> => {
    const mutationOptions: UseMutationOptions<ChatUpdateSessionResponse, ChatUpdateSessionError, Options<ChatUpdateSessionData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await chatUpdateSession({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Upload Attachments
 *
 * Upload file attachments (images or documents) for a chat session.
 *
 * Files are stored in blob storage and can later be associated with a
 * message when the user sends their prompt. Returns a list of attachment
 * UUIDs that the frontend should include in the message request.
 *
 * Supported types and size limits: ``GET /chat/attachment-limits``.
 *
 * At most ten files per request: clients queue larger selections over several requests.
 *
 * Uses session-per-phase: validates with request session, uploads to blob
 * with no DB held, then persists records in a fresh short-lived session.
 * Files are streamed to storage in bounded chunks and classified legacy-unverified (MHS-646). With the file
 * pipeline on, checking them starts before the response (a short bounded wait, no DB held), so a client can wait
 * for them to be ready and they're usually ready by the message that uses them. Best effort: a file left
 * legacy-unverified (no preparation capacity free) is checked on first use instead.
 */
export const chatUploadAttachmentsMutation = (options?: Partial<Options<ChatUploadAttachmentsData>>): UseMutationOptions<ChatUploadAttachmentsResponse, ChatUploadAttachmentsError, Options<ChatUploadAttachmentsData>> => {
    const mutationOptions: UseMutationOptions<ChatUploadAttachmentsResponse, ChatUploadAttachmentsError, Options<ChatUploadAttachmentsData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await chatUploadAttachments({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const listSessionDocumentsQueryKey = (options: Options<ListSessionDocumentsData>) => createQueryKey('listSessionDocuments', options);

/**
 * List Session Documents
 *
 * List all document lineages for a chat session.
 *
 * Returns one entry per unique document (canonical filename) with the
 * full version history embedded.  Only sessions with at least one
 * tracked document version will have lineage records.
 */
export const listSessionDocumentsOptions = (options: Options<ListSessionDocumentsData>) => queryOptions<ListSessionDocumentsResponse, ListSessionDocumentsError, ListSessionDocumentsResponse, ReturnType<typeof listSessionDocumentsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await listSessionDocuments({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listSessionDocumentsQueryKey(options)
});

/**
 * Mark Draft Applied
 *
 * Record that a draft card created or saved its entity (MHS-733), so the card says so after a reload.
 *
 * The chat's owner only: its cards are read-only for anyone else.
 */
export const markDraftAppliedMutation = (options?: Partial<Options<MarkDraftAppliedData>>): UseMutationOptions<MarkDraftAppliedResponse, MarkDraftAppliedError, Options<MarkDraftAppliedData>> => {
    const mutationOptions: UseMutationOptions<MarkDraftAppliedResponse, MarkDraftAppliedError, Options<MarkDraftAppliedData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await markDraftApplied({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Fork Session
 *
 * Fork a shared chat session into the current user's own session.
 *
 * Copies the session and all its messages. The new session is owned
 * by the current user and is independent of the original.
 */
export const forkSessionMutation = (options?: Partial<Options<ForkSessionData>>): UseMutationOptions<ForkSessionResponse, ForkSessionError, Options<ForkSessionData>> => {
    const mutationOptions: UseMutationOptions<ForkSessionResponse, ForkSessionError, Options<ForkSessionData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await forkSession({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const listMessagesQueryKey = (options: Options<ListMessagesData>) => createQueryKey('listMessages', options);

/**
 * List Messages
 *
 * Get all messages for a chat session (``attachmentsLimit`` pages each message's attachments).
 */
export const listMessagesOptions = (options: Options<ListMessagesData>) => queryOptions<ListMessagesResponse, ListMessagesError, ListMessagesResponse, ReturnType<typeof listMessagesQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await listMessages({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listMessagesQueryKey(options)
});

/**
 * Stream Message
 *
 * Send a message and stream the AI response via OperationManager.
 *
 * Returns ``{"operation_id": "..."}`` immediately (HTTP 202).
 * The actual LLM streaming runs as a background ``asyncio.Task``.
 * Subscribe to progress via ``GET /api/v1/operations/{operation_id}/stream``.
 *
 * Event types emitted to the operation stream:
 * - message_start: Stream has started
 * - content_delta: A content chunk from the AI
 * - tool_start / tool_end: Tool execution lifecycle
 * - message_end: Stream has completed
 * - error: An error occurred
 */
export const chatStreamMessageMutation = (options?: Partial<Options<ChatStreamMessageData>>): UseMutationOptions<ChatStreamMessageResponse, ChatStreamMessageError, Options<ChatStreamMessageData>> => {
    const mutationOptions: UseMutationOptions<ChatStreamMessageResponse, ChatStreamMessageError, Options<ChatStreamMessageData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await chatStreamMessage({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const chatGetSessionSharingQueryKey = (options: Options<ChatGetSessionSharingData>) => createQueryKey('chatGetSessionSharing', options);

/**
 * Get Session Sharing
 *
 * Get all shares and share links for a session.
 */
export const chatGetSessionSharingOptions = (options: Options<ChatGetSessionSharingData>) => queryOptions<ChatGetSessionSharingResponse, ChatGetSessionSharingError, ChatGetSessionSharingResponse, ReturnType<typeof chatGetSessionSharingQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await chatGetSessionSharing({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: chatGetSessionSharingQueryKey(options)
});

/**
 * Create Share Link
 *
 * Create a shareable link for a chat session.
 */
export const chatCreateShareLinkMutation = (options?: Partial<Options<ChatCreateShareLinkData>>): UseMutationOptions<ChatCreateShareLinkResponse, ChatCreateShareLinkError, Options<ChatCreateShareLinkData>> => {
    const mutationOptions: UseMutationOptions<ChatCreateShareLinkResponse, ChatCreateShareLinkError, Options<ChatCreateShareLinkData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await chatCreateShareLink({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Deactivate Share Link
 *
 * Deactivate a share link.
 */
export const chatDeactivateShareLinkMutation = (options?: Partial<Options<ChatDeactivateShareLinkData>>): UseMutationOptions<ChatDeactivateShareLinkResponse, ChatDeactivateShareLinkError, Options<ChatDeactivateShareLinkData>> => {
    const mutationOptions: UseMutationOptions<ChatDeactivateShareLinkResponse, ChatDeactivateShareLinkError, Options<ChatDeactivateShareLinkData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await chatDeactivateShareLink({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Set Session Space Share
 *
 * Share the chat read-only with everyone in its space, or stop (owner only).
 *
 * Members, including people who join later, can read and fork it.
 */
export const setSessionSpaceShareMutation = (options?: Partial<Options<SetSessionSpaceShareData>>): UseMutationOptions<SetSessionSpaceShareResponse, SetSessionSpaceShareError, Options<SetSessionSpaceShareData>> => {
    const mutationOptions: UseMutationOptions<SetSessionSpaceShareResponse, SetSessionSpaceShareError, Options<SetSessionSpaceShareData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await setSessionSpaceShare({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Share With User
 *
 * Share a chat session with a specific user.
 */
export const chatShareWithUserMutation = (options?: Partial<Options<ChatShareWithUserData>>): UseMutationOptions<ChatShareWithUserResponse, ChatShareWithUserError, Options<ChatShareWithUserData>> => {
    const mutationOptions: UseMutationOptions<ChatShareWithUserResponse, ChatShareWithUserError, Options<ChatShareWithUserData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await chatShareWithUser({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Remove Share
 *
 * Remove a direct share from a chat session.
 */
export const chatRemoveShareMutation = (options?: Partial<Options<ChatRemoveShareData>>): UseMutationOptions<ChatRemoveShareResponse, ChatRemoveShareError, Options<ChatRemoveShareData>> => {
    const mutationOptions: UseMutationOptions<ChatRemoveShareResponse, ChatRemoveShareError, Options<ChatRemoveShareData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await chatRemoveShare({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const chatListSharedWithMeQueryKey = (options?: Options<ChatListSharedWithMeData>) => createQueryKey('chatListSharedWithMe', options);

/**
 * List Shared With Me
 *
 * List all chat sessions shared with the current user.
 */
export const chatListSharedWithMeOptions = (options?: Options<ChatListSharedWithMeData>) => queryOptions<ChatListSharedWithMeResponse, DefaultError, ChatListSharedWithMeResponse, ReturnType<typeof chatListSharedWithMeQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await chatListSharedWithMe({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: chatListSharedWithMeQueryKey(options)
});

export const chatAccessShareLinkQueryKey = (options: Options<ChatAccessShareLinkData>) => createQueryKey('chatAccessShareLink', options);

/**
 * Access Share Link
 *
 * Access a chat session via a share link token.
 */
export const chatAccessShareLinkOptions = (options: Options<ChatAccessShareLinkData>) => queryOptions<ChatAccessShareLinkResponse, ChatAccessShareLinkError, ChatAccessShareLinkResponse, ReturnType<typeof chatAccessShareLinkQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await chatAccessShareLink({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: chatAccessShareLinkQueryKey(options)
});

export const listConnectorsQueryKey = (options?: Options<ListConnectorsData>) => createQueryKey('listConnectors', options);

/**
 * List Connectors
 *
 * Connectors I can use (all of them for platform admins).
 */
export const listConnectorsOptions = (options?: Options<ListConnectorsData>) => queryOptions<ListConnectorsResponse, ListConnectorsError, ListConnectorsResponse, ReturnType<typeof listConnectorsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await listConnectors({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listConnectorsQueryKey(options)
});

export const listConnectorsInfiniteQueryKey = (options?: Options<ListConnectorsData>): QueryKey<Options<ListConnectorsData>> => createQueryKey('listConnectors', options, true);

/**
 * List Connectors
 *
 * Connectors I can use (all of them for platform admins).
 */
export const listConnectorsInfiniteOptions = (options?: Options<ListConnectorsData>) => {
    const opts = infiniteQueryOptions<ListConnectorsResponse, ListConnectorsError, InfiniteData<ListConnectorsResponse>, QueryKey<Options<ListConnectorsData>>, number | Pick<QueryKey<Options<ListConnectorsData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<ListConnectorsData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                query: {
                    page: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await listConnectors({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: listConnectorsInfiniteQueryKey(options)
    });
    return opts as Omit<typeof opts, 'initialData'>;
};

/**
 * Create Connector
 *
 * Add an MCP server or HTTP endpoint. I become its admin.
 */
export const createConnectorMutation = (options?: Partial<Options<CreateConnectorData>>): UseMutationOptions<CreateConnectorResponse, CreateConnectorError, Options<CreateConnectorData>> => {
    const mutationOptions: UseMutationOptions<CreateConnectorResponse, CreateConnectorError, Options<CreateConnectorData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await createConnector({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Create Connector From Template
 *
 * Add a connector from a template with my key: finds its tools, keeps it read-only if asked, and can
 * add the template's starter skill (mine, to attach in a space).
 */
export const createConnectorFromTemplateMutation = (options?: Partial<Options<CreateConnectorFromTemplateData>>): UseMutationOptions<CreateConnectorFromTemplateResponse, CreateConnectorFromTemplateError, Options<CreateConnectorFromTemplateData>> => {
    const mutationOptions: UseMutationOptions<CreateConnectorFromTemplateResponse, CreateConnectorFromTemplateError, Options<CreateConnectorFromTemplateData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await createConnectorFromTemplate({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Create Connector Instance
 *
 * Add my own connector for an integration (e.g. our team's HubSpot), with my key. I become its admin.
 */
export const createConnectorInstanceMutation = (options?: Partial<Options<CreateConnectorInstanceData>>): UseMutationOptions<CreateConnectorInstanceResponse, CreateConnectorInstanceError, Options<CreateConnectorInstanceData>> => {
    const mutationOptions: UseMutationOptions<CreateConnectorInstanceResponse, CreateConnectorInstanceError, Options<CreateConnectorInstanceData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await createConnectorInstance({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const listConnectorIntegrationsQueryKey = (options?: Options<ListConnectorIntegrationsData>) => createQueryKey('listConnectorIntegrations', options);

/**
 * List Connector Integrations
 *
 * Integrations I can add my own connector for, with my own key (HubSpot, Slack, SQL...).
 */
export const listConnectorIntegrationsOptions = (options?: Options<ListConnectorIntegrationsData>) => queryOptions<ListConnectorIntegrationsResponse, DefaultError, ListConnectorIntegrationsResponse, ReturnType<typeof listConnectorIntegrationsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await listConnectorIntegrations({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listConnectorIntegrationsQueryKey(options)
});

export const listMyConnectorConnectionsQueryKey = (options?: Options<ListMyConnectorConnectionsData>) => createQueryKey('listMyConnectorConnections', options);

/**
 * List My Connector Connections
 *
 * Connectors I can use that need my own token, and whether I've added it (Settings > Connections).
 *
 * Uses my own grants only (a platform admin's see-everything bypass doesn't apply), like chat does.
 */
export const listMyConnectorConnectionsOptions = (options?: Options<ListMyConnectorConnectionsData>) => queryOptions<ListMyConnectorConnectionsResponse, DefaultError, ListMyConnectorConnectionsResponse, ReturnType<typeof listMyConnectorConnectionsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await listMyConnectorConnections({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listMyConnectorConnectionsQueryKey(options)
});

export const getConnectorPolicyQueryKey = (options?: Options<GetConnectorPolicyData>) => createQueryKey('getConnectorPolicy', options);

/**
 * Get Connector Policy
 *
 * The organization's connector rules, so the app can explain them (anyone).
 */
export const getConnectorPolicyOptions = (options?: Options<GetConnectorPolicyData>) => queryOptions<GetConnectorPolicyResponse, DefaultError, GetConnectorPolicyResponse, ReturnType<typeof getConnectorPolicyQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getConnectorPolicy({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getConnectorPolicyQueryKey(options)
});

export const listConnectorTemplatesQueryKey = (options?: Options<ListConnectorTemplatesData>) => createQueryKey('listConnectorTemplates', options);

/**
 * List Connector Templates
 *
 * Known servers (GitHub, Linear, ...) you can connect in one step, with their setup guides (MHS-875).
 */
export const listConnectorTemplatesOptions = (options?: Options<ListConnectorTemplatesData>) => queryOptions<ListConnectorTemplatesResponse, DefaultError, ListConnectorTemplatesResponse, ReturnType<typeof listConnectorTemplatesQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await listConnectorTemplates({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listConnectorTemplatesQueryKey(options)
});

/**
 * Delete Connector
 *
 * Delete (admin).
 */
export const deleteConnectorMutation = (options?: Partial<Options<DeleteConnectorData>>): UseMutationOptions<DeleteConnectorResponse, DeleteConnectorError, Options<DeleteConnectorData>> => {
    const mutationOptions: UseMutationOptions<DeleteConnectorResponse, DeleteConnectorError, Options<DeleteConnectorData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await deleteConnector({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getConnectorDetailQueryKey = (options: Options<GetConnectorDetailData>) => createQueryKey('getConnectorDetail', options);

/**
 * Get Connector Detail
 *
 * A connector's settings (viewer+). Never its secrets.
 */
export const getConnectorDetailOptions = (options: Options<GetConnectorDetailData>) => queryOptions<GetConnectorDetailResponse, GetConnectorDetailError, GetConnectorDetailResponse, ReturnType<typeof getConnectorDetailQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getConnectorDetail({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getConnectorDetailQueryKey(options)
});

/**
 * Update Connector
 *
 * Change settings (editor+).
 */
export const updateConnectorMutation = (options?: Partial<Options<UpdateConnectorData>>): UseMutationOptions<UpdateConnectorResponse, UpdateConnectorError, Options<UpdateConnectorData>> => {
    const mutationOptions: UseMutationOptions<UpdateConnectorResponse, UpdateConnectorError, Options<UpdateConnectorData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await updateConnector({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getConnectorMembersQueryKey = (options: Options<GetConnectorMembersData>) => createQueryKey('getConnectorMembers', options);

/**
 * Get Connector Members
 *
 * Who can use a connector (viewer+).
 */
export const getConnectorMembersOptions = (options: Options<GetConnectorMembersData>) => queryOptions<GetConnectorMembersResponse, GetConnectorMembersError, GetConnectorMembersResponse, ReturnType<typeof getConnectorMembersQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getConnectorMembers({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getConnectorMembersQueryKey(options)
});

/**
 * Add Connector Team Member
 *
 * Grant a team a role (admin only).
 */
export const addConnectorTeamMemberMutation = (options?: Partial<Options<AddConnectorTeamMemberData>>): UseMutationOptions<AddConnectorTeamMemberResponse, AddConnectorTeamMemberError, Options<AddConnectorTeamMemberData>> => {
    const mutationOptions: UseMutationOptions<AddConnectorTeamMemberResponse, AddConnectorTeamMemberError, Options<AddConnectorTeamMemberData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await addConnectorTeamMember({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Remove Connector Team Member
 *
 * Remove a team member (admin only; never the last admin).
 */
export const removeConnectorTeamMemberMutation = (options?: Partial<Options<RemoveConnectorTeamMemberData>>): UseMutationOptions<RemoveConnectorTeamMemberResponse, RemoveConnectorTeamMemberError, Options<RemoveConnectorTeamMemberData>> => {
    const mutationOptions: UseMutationOptions<RemoveConnectorTeamMemberResponse, RemoveConnectorTeamMemberError, Options<RemoveConnectorTeamMemberData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await removeConnectorTeamMember({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Update Connector Team Member
 *
 * Change a team member's role (admin only).
 */
export const updateConnectorTeamMemberMutation = (options?: Partial<Options<UpdateConnectorTeamMemberData>>): UseMutationOptions<UpdateConnectorTeamMemberResponse, UpdateConnectorTeamMemberError, Options<UpdateConnectorTeamMemberData>> => {
    const mutationOptions: UseMutationOptions<UpdateConnectorTeamMemberResponse, UpdateConnectorTeamMemberError, Options<UpdateConnectorTeamMemberData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await updateConnectorTeamMember({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Add Connector User Member
 *
 * Grant a user a role (admin only).
 */
export const addConnectorUserMemberMutation = (options?: Partial<Options<AddConnectorUserMemberData>>): UseMutationOptions<AddConnectorUserMemberResponse, AddConnectorUserMemberError, Options<AddConnectorUserMemberData>> => {
    const mutationOptions: UseMutationOptions<AddConnectorUserMemberResponse, AddConnectorUserMemberError, Options<AddConnectorUserMemberData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await addConnectorUserMember({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Remove Connector User Member
 *
 * Remove a user member (admin only; never the last admin).
 */
export const removeConnectorUserMemberMutation = (options?: Partial<Options<RemoveConnectorUserMemberData>>): UseMutationOptions<RemoveConnectorUserMemberResponse, RemoveConnectorUserMemberError, Options<RemoveConnectorUserMemberData>> => {
    const mutationOptions: UseMutationOptions<RemoveConnectorUserMemberResponse, RemoveConnectorUserMemberError, Options<RemoveConnectorUserMemberData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await removeConnectorUserMember({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Update Connector User Member
 *
 * Change a user member's role (admin only).
 */
export const updateConnectorUserMemberMutation = (options?: Partial<Options<UpdateConnectorUserMemberData>>): UseMutationOptions<UpdateConnectorUserMemberResponse, UpdateConnectorUserMemberError, Options<UpdateConnectorUserMemberData>> => {
    const mutationOptions: UseMutationOptions<UpdateConnectorUserMemberResponse, UpdateConnectorUserMemberError, Options<UpdateConnectorUserMemberData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await updateConnectorUserMember({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Clear My Connector Credential
 *
 * Remove my own token.
 */
export const clearMyConnectorCredentialMutation = (options?: Partial<Options<ClearMyConnectorCredentialData>>): UseMutationOptions<ClearMyConnectorCredentialResponse, ClearMyConnectorCredentialError, Options<ClearMyConnectorCredentialData>> => {
    const mutationOptions: UseMutationOptions<ClearMyConnectorCredentialResponse, ClearMyConnectorCredentialError, Options<ClearMyConnectorCredentialData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await clearMyConnectorCredential({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Set My Connector Credential
 *
 * Add or replace my own token for a per-user connector (anyone who can use it). Never returned.
 */
export const setMyConnectorCredentialMutation = (options?: Partial<Options<SetMyConnectorCredentialData>>): UseMutationOptions<SetMyConnectorCredentialResponse, SetMyConnectorCredentialError, Options<SetMyConnectorCredentialData>> => {
    const mutationOptions: UseMutationOptions<SetMyConnectorCredentialResponse, SetMyConnectorCredentialError, Options<SetMyConnectorCredentialData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await setMyConnectorCredential({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Start Connector Oauth
 *
 * Start signing in to the connector's server as me; the browser then goes to ``authorizeUrl``.
 */
export const startConnectorOauthMutation = (options?: Partial<Options<StartConnectorOauthData>>): UseMutationOptions<StartConnectorOauthResponse, StartConnectorOauthError, Options<StartConnectorOauthData>> => {
    const mutationOptions: UseMutationOptions<StartConnectorOauthResponse, StartConnectorOauthError, Options<StartConnectorOauthData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await startConnectorOauth({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Refresh Connector Tools
 *
 * Ask the server again what it offers (editor+). 502 with the reason if it can't be reached.
 */
export const refreshConnectorToolsMutation = (options?: Partial<Options<RefreshConnectorToolsData>>): UseMutationOptions<RefreshConnectorToolsResponse, RefreshConnectorToolsError, Options<RefreshConnectorToolsData>> => {
    const mutationOptions: UseMutationOptions<RefreshConnectorToolsResponse, RefreshConnectorToolsError, Options<RefreshConnectorToolsData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await refreshConnectorTools({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Clear Connector Secret
 *
 * Remove the shared secret (admin).
 */
export const clearConnectorSecretMutation = (options?: Partial<Options<ClearConnectorSecretData>>): UseMutationOptions<ClearConnectorSecretResponse, ClearConnectorSecretError, Options<ClearConnectorSecretData>> => {
    const mutationOptions: UseMutationOptions<ClearConnectorSecretResponse, ClearConnectorSecretError, Options<ClearConnectorSecretData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await clearConnectorSecret({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Set Connector Secret
 *
 * Set or replace the shared secret everyone's calls use (admin). Never returned.
 */
export const setConnectorSecretMutation = (options?: Partial<Options<SetConnectorSecretData>>): UseMutationOptions<SetConnectorSecretResponse, SetConnectorSecretError, Options<SetConnectorSecretData>> => {
    const mutationOptions: UseMutationOptions<SetConnectorSecretResponse, SetConnectorSecretError, Options<SetConnectorSecretData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await setConnectorSecret({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const listConnectorToolsQueryKey = (options: Options<ListConnectorToolsData>) => createQueryKey('listConnectorTools', options);

/**
 * List Connector Tools
 *
 * The tools a connector offers (viewer+).
 */
export const listConnectorToolsOptions = (options: Options<ListConnectorToolsData>) => queryOptions<ListConnectorToolsResponse, ListConnectorToolsError, ListConnectorToolsResponse, ReturnType<typeof listConnectorToolsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await listConnectorTools({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listConnectorToolsQueryKey(options)
});

/**
 * Update Connector Tool
 *
 * Reclassify a tool (reads / acts, asks first or not), turn it off, or reset it (editor+).
 */
export const updateConnectorToolMutation = (options?: Partial<Options<UpdateConnectorToolData>>): UseMutationOptions<UpdateConnectorToolResponse, UpdateConnectorToolError, Options<UpdateConnectorToolData>> => {
    const mutationOptions: UseMutationOptions<UpdateConnectorToolResponse, UpdateConnectorToolError, Options<UpdateConnectorToolData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await updateConnectorTool({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const listDataSourcesQueryKey = (options?: Options<ListDataSourcesData>) => createQueryKey('listDataSources', options);

/**
 * List Data Sources
 *
 * List data collections the caller has been granted access to (platform admins see all).
 */
export const listDataSourcesOptions = (options?: Options<ListDataSourcesData>) => queryOptions<ListDataSourcesResponse, ListDataSourcesError, ListDataSourcesResponse, ReturnType<typeof listDataSourcesQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await listDataSources({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listDataSourcesQueryKey(options)
});

export const listDataSourcesInfiniteQueryKey = (options?: Options<ListDataSourcesData>): QueryKey<Options<ListDataSourcesData>> => createQueryKey('listDataSources', options, true);

/**
 * List Data Sources
 *
 * List data collections the caller has been granted access to (platform admins see all).
 */
export const listDataSourcesInfiniteOptions = (options?: Options<ListDataSourcesData>) => {
    const opts = infiniteQueryOptions<ListDataSourcesResponse, ListDataSourcesError, InfiniteData<ListDataSourcesResponse>, QueryKey<Options<ListDataSourcesData>>, number | Pick<QueryKey<Options<ListDataSourcesData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<ListDataSourcesData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                query: {
                    page: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await listDataSources({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: listDataSourcesInfiniteQueryKey(options)
    });
    return opts as Omit<typeof opts, 'initialData'>;
};

/**
 * Create Data Source
 *
 * Create a new data collection.
 *
 * For notes source_type, if content is provided, it will be saved as a
 * markdown file and indexed automatically.
 */
export const createDataSourceMutation = (options?: Partial<Options<CreateDataSourceData>>): UseMutationOptions<CreateDataSourceResponse, CreateDataSourceError, Options<CreateDataSourceData>> => {
    const mutationOptions: UseMutationOptions<CreateDataSourceResponse, CreateDataSourceError, Options<CreateDataSourceData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await createDataSource({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Delete Data Source
 *
 * Delete a data collection (soft delete).
 *
 * Uses session-per-phase: validates with request session, deletes vector
 * store with no DB held, then soft-deletes in a fresh short-lived session.
 */
export const deleteDataSourceMutation = (options?: Partial<Options<DeleteDataSourceData>>): UseMutationOptions<DeleteDataSourceResponse, DeleteDataSourceError, Options<DeleteDataSourceData>> => {
    const mutationOptions: UseMutationOptions<DeleteDataSourceResponse, DeleteDataSourceError, Options<DeleteDataSourceData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await deleteDataSource({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getDataSourceQueryKey = (options: Options<GetDataSourceData>) => createQueryKey('getDataSource', options);

/**
 * Get Data Source
 *
 * Get data collection details.
 */
export const getDataSourceOptions = (options: Options<GetDataSourceData>) => queryOptions<GetDataSourceResponse, GetDataSourceError, GetDataSourceResponse, ReturnType<typeof getDataSourceQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getDataSource({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getDataSourceQueryKey(options)
});

/**
 * Update Data Source
 *
 * Update a data collection.
 */
export const updateDataSourceMutation = (options?: Partial<Options<UpdateDataSourceData>>): UseMutationOptions<UpdateDataSourceResponse, UpdateDataSourceError, Options<UpdateDataSourceData>> => {
    const mutationOptions: UseMutationOptions<UpdateDataSourceResponse, UpdateDataSourceError, Options<UpdateDataSourceData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await updateDataSource({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Upload Files
 *
 * Upload files to a data collection.
 *
 * Files are stored in Azure Blob Storage and metadata is saved to the database.
 *
 * Uses session-per-phase: validates with request session, uploads to blob
 * with no DB held, then persists records in a fresh short-lived session.
 */
export const uploadFilesMutation = (options?: Partial<Options<UploadFilesData>>): UseMutationOptions<UploadFilesResponse, UploadFilesError, Options<UploadFilesData>> => {
    const mutationOptions: UseMutationOptions<UploadFilesResponse, UploadFilesError, Options<UploadFilesData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await uploadFiles({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Delete File
 *
 * Delete a file from a data collection.
 *
 * Uses session-per-phase: validates with request session, deletes from blob
 * and vector store with no DB held, then deletes record in fresh session.
 */
export const deleteFileMutation = (options?: Partial<Options<DeleteFileData>>): UseMutationOptions<DeleteFileResponse, DeleteFileError, Options<DeleteFileData>> => {
    const mutationOptions: UseMutationOptions<DeleteFileResponse, DeleteFileError, Options<DeleteFileData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await deleteFile({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getFileDownloadUrlQueryKey = (options: Options<GetFileDownloadUrlData>) => createQueryKey('getFileDownloadUrl', options);

/**
 * Get File Download Url
 *
 * Generate a temporary download URL (SAS token) for a file.
 *
 * The URL is valid for the specified number of hours (default 1 hour).
 */
export const getFileDownloadUrlOptions = (options: Options<GetFileDownloadUrlData>) => queryOptions<GetFileDownloadUrlResponse, GetFileDownloadUrlError, GetFileDownloadUrlResponse, ReturnType<typeof getFileDownloadUrlQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getFileDownloadUrl({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getFileDownloadUrlQueryKey(options)
});

export const getFileMarkdownQueryKey = (options: Options<GetFileMarkdownData>) => createQueryKey('getFileMarkdown', options);

/**
 * Get File Markdown
 *
 * Extract and return the AI-ready markdown version of a file.
 *
 * Downloads the file from blob storage, runs it through the text extraction
 * pipeline (same as indexing), and returns the resulting markdown.
 */
export const getFileMarkdownOptions = (options: Options<GetFileMarkdownData>) => queryOptions<unknown, GetFileMarkdownError, unknown, ReturnType<typeof getFileMarkdownQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getFileMarkdown({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getFileMarkdownQueryKey(options)
});

export const getDataSourceMembersQueryKey = (options: Options<GetDataSourceMembersData>) => createQueryKey('getDataSourceMembers', options);

/**
 * Get Data Source Members
 *
 * List who has access to a data source (viewer+).
 */
export const getDataSourceMembersOptions = (options: Options<GetDataSourceMembersData>) => queryOptions<GetDataSourceMembersResponse, GetDataSourceMembersError, GetDataSourceMembersResponse, ReturnType<typeof getDataSourceMembersQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getDataSourceMembers({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getDataSourceMembersQueryKey(options)
});

/**
 * Add Data Source Team Member
 *
 * Grant a team a role on a data source (admin only).
 */
export const addDataSourceTeamMemberMutation = (options?: Partial<Options<AddDataSourceTeamMemberData>>): UseMutationOptions<AddDataSourceTeamMemberResponse, AddDataSourceTeamMemberError, Options<AddDataSourceTeamMemberData>> => {
    const mutationOptions: UseMutationOptions<AddDataSourceTeamMemberResponse, AddDataSourceTeamMemberError, Options<AddDataSourceTeamMemberData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await addDataSourceTeamMember({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Remove Data Source Team Member
 *
 * Remove a team member (admin only; never the last admin).
 */
export const removeDataSourceTeamMemberMutation = (options?: Partial<Options<RemoveDataSourceTeamMemberData>>): UseMutationOptions<RemoveDataSourceTeamMemberResponse, RemoveDataSourceTeamMemberError, Options<RemoveDataSourceTeamMemberData>> => {
    const mutationOptions: UseMutationOptions<RemoveDataSourceTeamMemberResponse, RemoveDataSourceTeamMemberError, Options<RemoveDataSourceTeamMemberData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await removeDataSourceTeamMember({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Update Data Source Team Member
 *
 * Change a team member's role (admin only).
 */
export const updateDataSourceTeamMemberMutation = (options?: Partial<Options<UpdateDataSourceTeamMemberData>>): UseMutationOptions<UpdateDataSourceTeamMemberResponse, UpdateDataSourceTeamMemberError, Options<UpdateDataSourceTeamMemberData>> => {
    const mutationOptions: UseMutationOptions<UpdateDataSourceTeamMemberResponse, UpdateDataSourceTeamMemberError, Options<UpdateDataSourceTeamMemberData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await updateDataSourceTeamMember({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Add Data Source User Member
 *
 * Grant a user a role on a data source (admin only).
 */
export const addDataSourceUserMemberMutation = (options?: Partial<Options<AddDataSourceUserMemberData>>): UseMutationOptions<AddDataSourceUserMemberResponse, AddDataSourceUserMemberError, Options<AddDataSourceUserMemberData>> => {
    const mutationOptions: UseMutationOptions<AddDataSourceUserMemberResponse, AddDataSourceUserMemberError, Options<AddDataSourceUserMemberData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await addDataSourceUserMember({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Remove Data Source User Member
 *
 * Remove a user member (admin only; never the last admin).
 */
export const removeDataSourceUserMemberMutation = (options?: Partial<Options<RemoveDataSourceUserMemberData>>): UseMutationOptions<RemoveDataSourceUserMemberResponse, RemoveDataSourceUserMemberError, Options<RemoveDataSourceUserMemberData>> => {
    const mutationOptions: UseMutationOptions<RemoveDataSourceUserMemberResponse, RemoveDataSourceUserMemberError, Options<RemoveDataSourceUserMemberData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await removeDataSourceUserMember({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Update Data Source User Member
 *
 * Change a user member's role (admin only).
 */
export const updateDataSourceUserMemberMutation = (options?: Partial<Options<UpdateDataSourceUserMemberData>>): UseMutationOptions<UpdateDataSourceUserMemberResponse, UpdateDataSourceUserMemberError, Options<UpdateDataSourceUserMemberData>> => {
    const mutationOptions: UseMutationOptions<UpdateDataSourceUserMemberResponse, UpdateDataSourceUserMemberError, Options<UpdateDataSourceUserMemberData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await updateDataSourceUserMember({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Add Note
 *
 * Add a note (ad-hoc text) to a data collection.
 *
 * The note content is saved as a .md file in blob storage and indexed
 * through the normal pipeline. This allows any collection to accept
 * pasted text alongside uploaded files, SharePoint docs, etc.
 *
 * Uses session-per-phase: validates with request session, uploads to
 * blob with no DB held, then persists record in fresh short-lived session.
 */
export const addNoteMutation = (options?: Partial<Options<AddNoteData>>): UseMutationOptions<AddNoteResponse, AddNoteError, Options<AddNoteData>> => {
    const mutationOptions: UseMutationOptions<AddNoteResponse, AddNoteError, Options<AddNoteData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await addNote({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Update Note
 *
 * Update an existing note's content and/or title.
 *
 * Re-uploads the markdown file to blob storage and re-indexes it.
 *
 * Uses session-per-phase: validates with request session, uploads to
 * blob with no DB held, then updates record in fresh short-lived session.
 */
export const updateNoteMutation = (options?: Partial<Options<UpdateNoteData>>): UseMutationOptions<UpdateNoteResponse, UpdateNoteError, Options<UpdateNoteData>> => {
    const mutationOptions: UseMutationOptions<UpdateNoteResponse, UpdateNoteError, Options<UpdateNoteData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await updateNote({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Sync Data Source
 *
 * Trigger sync for a data collection.
 *
 * For file collections, this triggers indexing/embedding of pending files.
 * For website collections, this fetches the URL content first, then indexes.
 * Processing happens in the background.
 *
 * Uses **session-per-phase**: the request-scoped ``session`` is used only
 * for fast validation.  SharePoint Graph API downloads and blob uploads
 * run with no DB connection held, using short-lived ``async_session_maker``
 * sessions for each DB write.
 */
export const syncDataSourceMutation = (options?: Partial<Options<SyncDataSourceData>>): UseMutationOptions<SyncDataSourceResponse, SyncDataSourceError, Options<SyncDataSourceData>> => {
    const mutationOptions: UseMutationOptions<SyncDataSourceResponse, SyncDataSourceError, Options<SyncDataSourceData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await syncDataSource({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Add Website Url
 *
 * Add a website URL to a website-type data collection.
 *
 * The URL is added to the collection's config and immediately synced.
 */
export const addWebsiteUrlMutation = (options?: Partial<Options<AddWebsiteUrlData>>): UseMutationOptions<AddWebsiteUrlResponse, AddWebsiteUrlError, Options<AddWebsiteUrlData>> => {
    const mutationOptions: UseMutationOptions<AddWebsiteUrlResponse, AddWebsiteUrlError, Options<AddWebsiteUrlData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await addWebsiteUrl({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getExportCapabilitiesQueryKey = (options?: Options<GetExportCapabilitiesData>) => createQueryKey('getExportCapabilities', options);

/**
 * Get Export Capabilities
 *
 * Get available export formats and templates.
 *
 * Returns information about which formats are available (e.g., PDF
 * requires LibreOffice) and available styling templates.
 */
export const getExportCapabilitiesOptions = (options?: Options<GetExportCapabilitiesData>) => queryOptions<GetExportCapabilitiesResponse, DefaultError, GetExportCapabilitiesResponse, ReturnType<typeof getExportCapabilitiesQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getExportCapabilities({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getExportCapabilitiesQueryKey(options)
});

export const listExtensionsQueryKey = (options?: Options<ListExtensionsData>) => createQueryKey('listExtensions', options);

/**
 * List Extensions
 *
 * List all extensions (platform admin only).
 */
export const listExtensionsOptions = (options?: Options<ListExtensionsData>) => queryOptions<ListExtensionsResponse, DefaultError, ListExtensionsResponse, ReturnType<typeof listExtensionsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await listExtensions({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listExtensionsQueryKey(options)
});

export const getExtensionQueryKey = (options: Options<GetExtensionData>) => createQueryKey('getExtension', options);

/**
 * Get Extension
 *
 * Get full extension detail (platform admin only).
 */
export const getExtensionOptions = (options: Options<GetExtensionData>) => queryOptions<GetExtensionResponse, GetExtensionError, GetExtensionResponse, ReturnType<typeof getExtensionQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getExtension({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getExtensionQueryKey(options)
});

/**
 * Update Extension
 *
 * Update extension settings (platform admin only).
 *
 * System extensions only allow display_order and config changes.
 */
export const updateExtensionMutation = (options?: Partial<Options<UpdateExtensionData>>): UseMutationOptions<UpdateExtensionResponse, UpdateExtensionError, Options<UpdateExtensionData>> => {
    const mutationOptions: UseMutationOptions<UpdateExtensionResponse, UpdateExtensionError, Options<UpdateExtensionData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await updateExtension({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Update Credential
 *
 * Set or update a credential value (platform admin only).
 *
 * The value is encrypted before storage using Fernet (AES-128-CBC + HMAC-SHA256).
 */
export const updateCredentialMutation = (options?: Partial<Options<UpdateCredentialData>>): UseMutationOptions<UpdateCredentialResponse, UpdateCredentialError, Options<UpdateCredentialData>> => {
    const mutationOptions: UseMutationOptions<UpdateCredentialResponse, UpdateCredentialError, Options<UpdateCredentialData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await updateCredential({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Clear Credential
 *
 * Clear (remove) the stored value for a credential (platform admin only).
 *
 * The credential row remains (so it still shows as a required key) but
 * its encrypted_value is set to NULL, marking it as "not configured".
 */
export const clearCredentialMutation = (options?: Partial<Options<ClearCredentialData>>): UseMutationOptions<ClearCredentialResponse, ClearCredentialError, Options<ClearCredentialData>> => {
    const mutationOptions: UseMutationOptions<ClearCredentialResponse, ClearCredentialError, Options<ClearCredentialData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await clearCredential({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Update Team Access
 *
 * Set team access for an extension (platform admin only).
 *
 * Replaces the entire access list. An empty list makes the extension global.
 */
export const updateTeamAccessMutation = (options?: Partial<Options<UpdateTeamAccessData>>): UseMutationOptions<UpdateTeamAccessResponse, UpdateTeamAccessError, Options<UpdateTeamAccessData>> => {
    const mutationOptions: UseMutationOptions<UpdateTeamAccessResponse, UpdateTeamAccessError, Options<UpdateTeamAccessData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await updateTeamAccess({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Toggle Extension
 *
 * Enable or disable an extension (platform admin only).
 */
export const toggleExtensionMutation = (options?: Partial<Options<ToggleExtensionData>>): UseMutationOptions<ToggleExtensionResponse, ToggleExtensionError, Options<ToggleExtensionData>> => {
    const mutationOptions: UseMutationOptions<ToggleExtensionResponse, ToggleExtensionError, Options<ToggleExtensionData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await toggleExtension({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const listAllFeedbackQueryKey = (options?: Options<ListAllFeedbackData>) => createQueryKey('listAllFeedback', options);

/**
 * List All Feedback
 *
 * List all feedback (admin only).
 */
export const listAllFeedbackOptions = (options?: Options<ListAllFeedbackData>) => queryOptions<ListAllFeedbackResponse, ListAllFeedbackError, ListAllFeedbackResponse, ReturnType<typeof listAllFeedbackQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await listAllFeedback({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listAllFeedbackQueryKey(options)
});

export const listAllFeedbackInfiniteQueryKey = (options?: Options<ListAllFeedbackData>): QueryKey<Options<ListAllFeedbackData>> => createQueryKey('listAllFeedback', options, true);

/**
 * List All Feedback
 *
 * List all feedback (admin only).
 */
export const listAllFeedbackInfiniteOptions = (options?: Options<ListAllFeedbackData>) => {
    const opts = infiniteQueryOptions<ListAllFeedbackResponse, ListAllFeedbackError, InfiniteData<ListAllFeedbackResponse>, QueryKey<Options<ListAllFeedbackData>>, number | Pick<QueryKey<Options<ListAllFeedbackData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<ListAllFeedbackData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                query: {
                    page: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await listAllFeedback({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: listAllFeedbackInfiniteQueryKey(options)
    });
    return opts as Omit<typeof opts, 'initialData'>;
};

/**
 * Submit Feedback
 *
 * Submit a bug report or feature request, optionally with screenshots.
 */
export const submitFeedbackMutation = (options?: Partial<Options<SubmitFeedbackData>>): UseMutationOptions<SubmitFeedbackResponse, SubmitFeedbackError, Options<SubmitFeedbackData>> => {
    const mutationOptions: UseMutationOptions<SubmitFeedbackResponse, SubmitFeedbackError, Options<SubmitFeedbackData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await submitFeedback({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getFeedbackQueryKey = (options: Options<GetFeedbackData>) => createQueryKey('getFeedback', options);

/**
 * Get Feedback
 *
 * Get one feedback item (admin only).
 */
export const getFeedbackOptions = (options: Options<GetFeedbackData>) => queryOptions<GetFeedbackResponse, GetFeedbackError, GetFeedbackResponse, ReturnType<typeof getFeedbackQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getFeedback({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getFeedbackQueryKey(options)
});

/**
 * Update Feedback Status
 *
 * Update the status of a feedback item (admin only).
 */
export const updateFeedbackStatusMutation = (options?: Partial<Options<UpdateFeedbackStatusData>>): UseMutationOptions<UpdateFeedbackStatusResponse, UpdateFeedbackStatusError, Options<UpdateFeedbackStatusData>> => {
    const mutationOptions: UseMutationOptions<UpdateFeedbackStatusResponse, UpdateFeedbackStatusError, Options<UpdateFeedbackStatusData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await updateFeedbackStatus({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const downloadScreenshotQueryKey = (options: Options<DownloadScreenshotData>) => createQueryKey('downloadScreenshot', options);

/**
 * Download Screenshot
 *
 * Stream a feedback screenshot's bytes directly.
 *
 * Works for both local and Azure Blob storage — no SAS URL or
 * file:// path is exposed to the client.
 */
export const downloadScreenshotOptions = (options: Options<DownloadScreenshotData>) => queryOptions<unknown, DownloadScreenshotError, unknown, ReturnType<typeof downloadScreenshotQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await downloadScreenshot({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: downloadScreenshotQueryKey(options)
});

export const listFlowsQueryKey = (options?: Options<ListFlowsData>) => createQueryKey('listFlows', options);

/**
 * List Flows
 *
 * List workflows the user holds a grant on (directly or through a team).
 */
export const listFlowsOptions = (options?: Options<ListFlowsData>) => queryOptions<ListFlowsResponse, ListFlowsError, ListFlowsResponse, ReturnType<typeof listFlowsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await listFlows({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listFlowsQueryKey(options)
});

export const listFlowsInfiniteQueryKey = (options?: Options<ListFlowsData>): QueryKey<Options<ListFlowsData>> => createQueryKey('listFlows', options, true);

/**
 * List Flows
 *
 * List workflows the user holds a grant on (directly or through a team).
 */
export const listFlowsInfiniteOptions = (options?: Options<ListFlowsData>) => {
    const opts = infiniteQueryOptions<ListFlowsResponse, ListFlowsError, InfiniteData<ListFlowsResponse>, QueryKey<Options<ListFlowsData>>, number | Pick<QueryKey<Options<ListFlowsData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<ListFlowsData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                query: {
                    page: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await listFlows({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: listFlowsInfiniteQueryKey(options)
    });
    return opts as Omit<typeof opts, 'initialData'>;
};

/**
 * Create Flow
 *
 * Create a new agent flow.
 */
export const createFlowMutation = (options?: Partial<Options<CreateFlowData>>): UseMutationOptions<CreateFlowResponse, CreateFlowError, Options<CreateFlowData>> => {
    const mutationOptions: UseMutationOptions<CreateFlowResponse, CreateFlowError, Options<CreateFlowData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await createFlow({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Delete Flow
 *
 * Delete a flow (soft delete, admin only).
 */
export const deleteFlowMutation = (options?: Partial<Options<DeleteFlowData>>): UseMutationOptions<DeleteFlowResponse, DeleteFlowError, Options<DeleteFlowData>> => {
    const mutationOptions: UseMutationOptions<DeleteFlowResponse, DeleteFlowError, Options<DeleteFlowData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await deleteFlow({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getFlowQueryKey = (options: Options<GetFlowData>) => createQueryKey('getFlow', options);

/**
 * Get Flow
 *
 * Get flow details (viewer+).
 */
export const getFlowOptions = (options: Options<GetFlowData>) => queryOptions<GetFlowResponse, GetFlowError, GetFlowResponse, ReturnType<typeof getFlowQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getFlow({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getFlowQueryKey(options)
});

/**
 * Update Flow
 *
 * Update a flow (editor+).
 */
export const updateFlowMutation = (options?: Partial<Options<UpdateFlowData>>): UseMutationOptions<UpdateFlowResponse, UpdateFlowError, Options<UpdateFlowData>> => {
    const mutationOptions: UseMutationOptions<UpdateFlowResponse, UpdateFlowError, Options<UpdateFlowData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await updateFlow({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getFlowAuthorizationQueryKey = (options: Options<GetFlowAuthorizationData>) => createQueryKey('getFlowAuthorization', options);

/**
 * Get Flow Authorization
 *
 * Report the current user's background-access authorization for this flow.
 *
 * The ``scheduled_flows`` delegated token is user-scoped (one per user), so the
 * reported ``status`` reflects the user's overall scheduled-flow authorization.
 * ``has_scheduled_trigger`` indicates whether this flow has a schedule that
 * would actually use it. Detection is intentionally NOT based on which tools
 * the flow uses: agentless steps (a plain prompt) can call delegated tools at
 * runtime, so any scheduled flow may need this authorization.
 */
export const getFlowAuthorizationOptions = (options: Options<GetFlowAuthorizationData>) => queryOptions<GetFlowAuthorizationResponse, GetFlowAuthorizationError, GetFlowAuthorizationResponse, ReturnType<typeof getFlowAuthorizationQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getFlowAuthorization({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getFlowAuthorizationQueryKey(options)
});

/**
 * Authorize Flow
 *
 * Explicitly (re-)authorize background delegated access for scheduled flows.
 *
 * Captures the caller's live delegated token for the ``scheduled_flows``
 * purpose so background scheduled runs can act on their behalf (SharePoint,
 * Teams, Outlook, etc.). This is the user-initiated equivalent of the SharePoint
 * "Automated sync" authorize action.
 */
export const authorizeFlowMutation = (options?: Partial<Options<AuthorizeFlowData>>): UseMutationOptions<AuthorizeFlowResponse, AuthorizeFlowError, Options<AuthorizeFlowData>> => {
    const mutationOptions: UseMutationOptions<AuthorizeFlowResponse, AuthorizeFlowError, Options<AuthorizeFlowData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await authorizeFlow({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getFlowMembersQueryKey = (options: Options<GetFlowMembersData>) => createQueryKey('getFlowMembers', options);

/**
 * Get Flow Members
 *
 * List who has access to a workflow (viewer+).
 */
export const getFlowMembersOptions = (options: Options<GetFlowMembersData>) => queryOptions<GetFlowMembersResponse, GetFlowMembersError, GetFlowMembersResponse, ReturnType<typeof getFlowMembersQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getFlowMembers({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getFlowMembersQueryKey(options)
});

/**
 * Add Flow Team Member
 *
 * Grant a team a role on a workflow (admin only).
 */
export const addFlowTeamMemberMutation = (options?: Partial<Options<AddFlowTeamMemberData>>): UseMutationOptions<AddFlowTeamMemberResponse, AddFlowTeamMemberError, Options<AddFlowTeamMemberData>> => {
    const mutationOptions: UseMutationOptions<AddFlowTeamMemberResponse, AddFlowTeamMemberError, Options<AddFlowTeamMemberData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await addFlowTeamMember({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Remove Flow Team Member
 *
 * Remove a team member (admin only; never the last admin).
 */
export const removeFlowTeamMemberMutation = (options?: Partial<Options<RemoveFlowTeamMemberData>>): UseMutationOptions<RemoveFlowTeamMemberResponse, RemoveFlowTeamMemberError, Options<RemoveFlowTeamMemberData>> => {
    const mutationOptions: UseMutationOptions<RemoveFlowTeamMemberResponse, RemoveFlowTeamMemberError, Options<RemoveFlowTeamMemberData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await removeFlowTeamMember({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Update Flow Team Member
 *
 * Change a team member's role (admin only).
 */
export const updateFlowTeamMemberMutation = (options?: Partial<Options<UpdateFlowTeamMemberData>>): UseMutationOptions<UpdateFlowTeamMemberResponse, UpdateFlowTeamMemberError, Options<UpdateFlowTeamMemberData>> => {
    const mutationOptions: UseMutationOptions<UpdateFlowTeamMemberResponse, UpdateFlowTeamMemberError, Options<UpdateFlowTeamMemberData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await updateFlowTeamMember({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Add Flow User Member
 *
 * Grant a user a role on a workflow (admin only).
 */
export const addFlowUserMemberMutation = (options?: Partial<Options<AddFlowUserMemberData>>): UseMutationOptions<AddFlowUserMemberResponse, AddFlowUserMemberError, Options<AddFlowUserMemberData>> => {
    const mutationOptions: UseMutationOptions<AddFlowUserMemberResponse, AddFlowUserMemberError, Options<AddFlowUserMemberData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await addFlowUserMember({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Remove Flow User Member
 *
 * Remove a user member (admin only; never the last admin).
 */
export const removeFlowUserMemberMutation = (options?: Partial<Options<RemoveFlowUserMemberData>>): UseMutationOptions<RemoveFlowUserMemberResponse, RemoveFlowUserMemberError, Options<RemoveFlowUserMemberData>> => {
    const mutationOptions: UseMutationOptions<RemoveFlowUserMemberResponse, RemoveFlowUserMemberError, Options<RemoveFlowUserMemberData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await removeFlowUserMember({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Update Flow User Member
 *
 * Change a user member's role (admin only).
 */
export const updateFlowUserMemberMutation = (options?: Partial<Options<UpdateFlowUserMemberData>>): UseMutationOptions<UpdateFlowUserMemberResponse, UpdateFlowUserMemberError, Options<UpdateFlowUserMemberData>> => {
    const mutationOptions: UseMutationOptions<UpdateFlowUserMemberResponse, UpdateFlowUserMemberError, Options<UpdateFlowUserMemberData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await updateFlowUserMember({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const listFlowRunsQueryKey = (options: Options<ListFlowRunsData>) => createQueryKey('listFlowRuns', options);

/**
 * List Flow Runs
 *
 * List runs for a flow.
 */
export const listFlowRunsOptions = (options: Options<ListFlowRunsData>) => queryOptions<ListFlowRunsResponse, ListFlowRunsError, ListFlowRunsResponse, ReturnType<typeof listFlowRunsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await listFlowRuns({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listFlowRunsQueryKey(options)
});

export const listFlowRunsInfiniteQueryKey = (options: Options<ListFlowRunsData>): QueryKey<Options<ListFlowRunsData>> => createQueryKey('listFlowRuns', options, true);

/**
 * List Flow Runs
 *
 * List runs for a flow.
 */
export const listFlowRunsInfiniteOptions = (options: Options<ListFlowRunsData>) => {
    const opts = infiniteQueryOptions<ListFlowRunsResponse, ListFlowRunsError, InfiniteData<ListFlowRunsResponse>, QueryKey<Options<ListFlowRunsData>>, number | Pick<QueryKey<Options<ListFlowRunsData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<ListFlowRunsData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                query: {
                    page: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await listFlowRuns({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: listFlowRunsInfiniteQueryKey(options)
    });
    return opts as Omit<typeof opts, 'initialData'>;
};

/**
 * Stream Flow Run
 *
 * Start a flow run as a background operation and return the operation ID.
 *
 * Uses ``get_streaming_auth`` (lightweight auth) instead of
 * ``get_current_user`` / ``get_db`` so that **no request-scoped DB
 * session is held**.  All DB work is done via short-lived sessions from
 * ``async_session_maker``.
 *
 * The caller's live bearer token (``auth.access_token``) is threaded into
 * the flow context so delegated Microsoft Graph tools (SharePoint, Teams,
 * Outlook) can perform their OBO exchange during a manual run — mirroring
 * how chat/Task Mode pass the token. Without it, Graph tools would fail
 * mid-run with a spurious "needs permission" error even though the user is
 * fully consented.
 *
 * Returns a JSON response with ``operation_id`` which the client uses to
 * subscribe to events via ``GET /api/v1/operations/{op_id}/stream``.
 */
export const streamFlowRunMutation = (options?: Partial<Options<StreamFlowRunData>>): UseMutationOptions<StreamFlowRunResponse, StreamFlowRunError, Options<StreamFlowRunData>> => {
    const mutationOptions: UseMutationOptions<StreamFlowRunResponse, StreamFlowRunError, Options<StreamFlowRunData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await streamFlowRun({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getFlowRunQueryKey = (options: Options<GetFlowRunData>) => createQueryKey('getFlowRun', options);

/**
 * Get Flow Run
 *
 * Get a specific flow run.
 */
export const getFlowRunOptions = (options: Options<GetFlowRunData>) => queryOptions<GetFlowRunResponse, GetFlowRunError, GetFlowRunResponse, ReturnType<typeof getFlowRunQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getFlowRun({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getFlowRunQueryKey(options)
});

/**
 * Cancel Flow Run
 *
 * Cancel a running or paused flow run.
 */
export const cancelFlowRunMutation = (options?: Partial<Options<CancelFlowRunData>>): UseMutationOptions<CancelFlowRunResponse, CancelFlowRunError, Options<CancelFlowRunData>> => {
    const mutationOptions: UseMutationOptions<CancelFlowRunResponse, CancelFlowRunError, Options<CancelFlowRunData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await cancelFlowRun({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Resume Flow Run
 *
 * Resume a paused flow run.
 *
 * Used when a flow step has requires_review=True and is waiting for human approval.
 *
 * For approval: validates, prepares the resume (marks paused step completed,
 * sets run to RUNNING), fires off remaining step execution as a background
 * task, and returns immediately with the current run state.  The client
 * should poll ``GET /flows/{uuid}/runs/{runId}`` for progress.
 *
 * For rejection: cancels the run synchronously and returns the final state.
 */
export const resumeFlowRunMutation = (options?: Partial<Options<ResumeFlowRunData>>): UseMutationOptions<ResumeFlowRunResponse, ResumeFlowRunError, Options<ResumeFlowRunData>> => {
    const mutationOptions: UseMutationOptions<ResumeFlowRunResponse, ResumeFlowRunError, Options<ResumeFlowRunData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await resumeFlowRun({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const listFlowTriggersQueryKey = (options: Options<ListFlowTriggersData>) => createQueryKey('listFlowTriggers', options);

/**
 * List Flow Triggers
 *
 * List all triggers for a flow.
 */
export const listFlowTriggersOptions = (options: Options<ListFlowTriggersData>) => queryOptions<ListFlowTriggersResponse, ListFlowTriggersError, ListFlowTriggersResponse, ReturnType<typeof listFlowTriggersQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await listFlowTriggers({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listFlowTriggersQueryKey(options)
});

/**
 * Create Flow Trigger
 *
 * Create a new trigger for a flow.
 */
export const createFlowTriggerMutation = (options?: Partial<Options<CreateFlowTriggerData>>): UseMutationOptions<unknown, CreateFlowTriggerError, Options<CreateFlowTriggerData>> => {
    const mutationOptions: UseMutationOptions<unknown, CreateFlowTriggerError, Options<CreateFlowTriggerData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await createFlowTrigger({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Delete Flow Trigger
 *
 * Delete a flow trigger.
 */
export const deleteFlowTriggerMutation = (options?: Partial<Options<DeleteFlowTriggerData>>): UseMutationOptions<DeleteFlowTriggerResponse, DeleteFlowTriggerError, Options<DeleteFlowTriggerData>> => {
    const mutationOptions: UseMutationOptions<DeleteFlowTriggerResponse, DeleteFlowTriggerError, Options<DeleteFlowTriggerData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await deleteFlowTrigger({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Update Flow Trigger
 *
 * Update a flow trigger (e.g. its schedule).
 */
export const updateFlowTriggerMutation = (options?: Partial<Options<UpdateFlowTriggerData>>): UseMutationOptions<UpdateFlowTriggerResponse, UpdateFlowTriggerError, Options<UpdateFlowTriggerData>> => {
    const mutationOptions: UseMutationOptions<UpdateFlowTriggerResponse, UpdateFlowTriggerError, Options<UpdateFlowTriggerData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await updateFlowTrigger({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Upload Flow Files
 *
 * Upload files for use in a flow run.
 *
 * Validates MIME types and sizes, uploads to Azure Blob Storage under
 * ``flow-attachments/{flow_uuid}/``, and returns blob paths that can be
 * passed in ``FlowRunCreate.file_blob_paths``.
 */
export const uploadFlowFilesMutation = (options?: Partial<Options<UploadFlowFilesData>>): UseMutationOptions<UploadFlowFilesResponse, UploadFlowFilesError, Options<UploadFlowFilesData>> => {
    const mutationOptions: UseMutationOptions<UploadFlowFilesResponse, UploadFlowFilesError, Options<UploadFlowFilesData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await uploadFlowFiles({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Download Document
 *
 * Download a Google Drive document and extract its text content.
 *
 * For Google Workspace files (Docs, Sheets, Slides), exports to a
 * portable format first.  For presentations, converts slides to images.
 */
export const googleDriveDownloadDocumentMutation = (options?: Partial<Options<GoogleDriveDownloadDocumentData>>): UseMutationOptions<GoogleDriveDownloadDocumentResponse, GoogleDriveDownloadDocumentError, Options<GoogleDriveDownloadDocumentData>> => {
    const mutationOptions: UseMutationOptions<GoogleDriveDownloadDocumentResponse, GoogleDriveDownloadDocumentError, Options<GoogleDriveDownloadDocumentData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await googleDriveDownloadDocument({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const listFilesQueryKey = (options?: Options<ListFilesData>) => createQueryKey('listFiles', options);

/**
 * List Files
 *
 * List files and folders within a folder (defaults to My Drive root).
 */
export const listFilesOptions = (options?: Options<ListFilesData>) => queryOptions<ListFilesResponse, ListFilesError, ListFilesResponse, ReturnType<typeof listFilesQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await listFiles({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listFilesQueryKey(options)
});

export const searchFilesQueryKey = (options: Options<SearchFilesData>) => createQueryKey('searchFiles', options);

/**
 * Search Files
 *
 * Search for files in the user's Google Drive.
 */
export const searchFilesOptions = (options: Options<SearchFilesData>) => queryOptions<SearchFilesResponse, SearchFilesError, SearchFilesResponse, ReturnType<typeof searchFilesQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await searchFiles({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: searchFilesQueryKey(options)
});

export const listMyJobsQueryKey = (options?: Options<ListMyJobsData>) => createQueryKey('listMyJobs', options);

/**
 * List My Jobs
 *
 * List the signed-in user's recent harness jobs (most recent first).
 */
export const listMyJobsOptions = (options?: Options<ListMyJobsData>) => queryOptions<ListMyJobsResponse, ListMyJobsError, ListMyJobsResponse, ReturnType<typeof listMyJobsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await listMyJobs({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listMyJobsQueryKey(options)
});

export const listWorkersQueryKey = (options?: Options<ListWorkersData>) => createQueryKey('listWorkers', options);

/**
 * List Workers
 *
 * List the signed-in user's harness workers with derived presence.
 */
export const listWorkersOptions = (options?: Options<ListWorkersData>) => queryOptions<ListWorkersResponse, DefaultError, ListWorkersResponse, ReturnType<typeof listWorkersQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await listWorkers({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listWorkersQueryKey(options)
});

export const listAvailableQueryKey = (options?: Options<ListAvailableData>) => createQueryKey('listAvailable', options);

/**
 * List Available
 *
 * Enabled per-user-credential extensions the user can access + status.
 */
export const listAvailableOptions = (options?: Options<ListAvailableData>) => queryOptions<ListAvailableResponse, DefaultError, ListAvailableResponse, ReturnType<typeof listAvailableQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await listAvailable({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listAvailableQueryKey(options)
});

export const listExtensionConsentQueryKey = (options?: Options<ListExtensionConsentData>) => createQueryKey('listExtensionConsent', options);

/**
 * List Extension Consent
 *
 * Integration extensions the user can access, with their read/write consent (MHS-588).
 */
export const listExtensionConsentOptions = (options?: Options<ListExtensionConsentData>) => queryOptions<ListExtensionConsentResponse, DefaultError, ListExtensionConsentResponse, ReturnType<typeof listExtensionConsentQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await listExtensionConsent({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listExtensionConsentQueryKey(options)
});

/**
 * Clear Extension Preference
 *
 * Drop the user's choice so the extension's default applies again. Repeating it is harmless.
 */
export const clearExtensionPreferenceMutation = (options?: Partial<Options<ClearExtensionPreferenceData>>): UseMutationOptions<ClearExtensionPreferenceResponse, ClearExtensionPreferenceError, Options<ClearExtensionPreferenceData>> => {
    const mutationOptions: UseMutationOptions<ClearExtensionPreferenceResponse, ClearExtensionPreferenceError, Options<ClearExtensionPreferenceData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await clearExtensionPreference({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Set Extension Preference
 *
 * Save the user's read or write choice for an extension. Repeating it is harmless.
 */
export const setExtensionPreferenceMutation = (options?: Partial<Options<SetExtensionPreferenceData>>): UseMutationOptions<SetExtensionPreferenceResponse, SetExtensionPreferenceError, Options<SetExtensionPreferenceData>> => {
    const mutationOptions: UseMutationOptions<SetExtensionPreferenceResponse, SetExtensionPreferenceError, Options<SetExtensionPreferenceData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await setExtensionPreference({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const authorizeQueryKey = (options: Options<AuthorizeData>) => createQueryKey('authorize', options);

/**
 * Authorize
 *
 * Begin the OAuth connect flow for an extension.
 */
export const authorizeOptions = (options: Options<AuthorizeData>) => queryOptions<AuthorizeResponse2, AuthorizeError, AuthorizeResponse2, ReturnType<typeof authorizeQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await authorize({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: authorizeQueryKey(options)
});

/**
 * Disconnect
 *
 * Revoke (best-effort) and delete the user's credential for an extension.
 */
export const disconnectMutation = (options?: Partial<Options<DisconnectData>>): UseMutationOptions<DisconnectResponse, DisconnectError, Options<DisconnectData>> => {
    const mutationOptions: UseMutationOptions<DisconnectResponse, DisconnectError, Options<DisconnectData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await disconnect({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const listImportsQueryKey = (options?: Options<ListImportsData>) => createQueryKey('listImports', options);

/**
 * List Imports
 *
 * Your recent imports (newest first), optionally for one space.
 */
export const listImportsOptions = (options?: Options<ListImportsData>) => queryOptions<ListImportsResponse, ListImportsError, ListImportsResponse, ReturnType<typeof listImportsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await listImports({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listImportsQueryKey(options)
});

/**
 * Delete Import
 *
 * Cancel a running import, or delete a finished one with its pending proposals (accepted facts stay).
 */
export const deleteImportMutation = (options?: Partial<Options<DeleteImportData>>): UseMutationOptions<DeleteImportResponse, DeleteImportError, Options<DeleteImportData>> => {
    const mutationOptions: UseMutationOptions<DeleteImportResponse, DeleteImportError, Options<DeleteImportData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await deleteImport({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getImportQueryKey = (options: Options<GetImportData>) => createQueryKey('getImport', options);

/**
 * Get Import
 *
 * One of your imports: status and progress (poll while it runs).
 */
export const getImportOptions = (options: Options<GetImportData>) => queryOptions<GetImportResponse, GetImportError, GetImportResponse, ReturnType<typeof getImportQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getImport({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getImportQueryKey(options)
});

/**
 * Accept All
 *
 * Accept up to 500 of an import's pending facts as proposed, into a space you can edit.
 *
 * No other names are written (confirm those per fact). Facts that can't be written stay pending (``skipped``).
 * 409 ``KG_IMPORT_RUNNING`` while it's still extracting; 403 ``WIKI_PUBLISH_FORBIDDEN`` for ``org`` pages
 * without admin on the space.
 */
export const acceptAllMutation = (options?: Partial<Options<AcceptAllData>>): UseMutationOptions<AcceptAllResponse, AcceptAllError, Options<AcceptAllData>> => {
    const mutationOptions: UseMutationOptions<AcceptAllResponse, AcceptAllError, Options<AcceptAllData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await acceptAll({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Dismiss All
 *
 * Dismiss all of an import's pending facts (they won't be proposed to you again).
 */
export const dismissAllMutation = (options?: Partial<Options<DismissAllData>>): UseMutationOptions<DismissAllResponse, DismissAllError, Options<DismissAllData>> => {
    const mutationOptions: UseMutationOptions<DismissAllResponse, DismissAllError, Options<DismissAllData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await dismissAll({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const listInboxQueryKey = (options?: Options<ListInboxData>) => createQueryKey('listInbox', options);

/**
 * List Inbox
 *
 * Your pending proposals, most confident first.
 */
export const listInboxOptions = (options?: Options<ListInboxData>) => queryOptions<ListInboxResponse, DefaultError, ListInboxResponse, ReturnType<typeof listInboxQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await listInbox({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listInboxQueryKey(options)
});

/**
 * Accept Proposal
 *
 * Accept a proposal (optionally corrected): write it into a wiki you can edit.
 *
 * Creates pages for things that don't have one in that space yet (private by
 * default) and adds the fact to the subject's page under ``## Relationships``.
 * 404 ``KG_PROPOSAL_NOT_FOUND``, 409 ``KG_PROPOSAL_NOT_PENDING``, 400
 * ``KG_PROPOSAL_INVALID``, 409 ``WIKI_CONFLICT`` (a page changed meanwhile:
 * retry), 403/404 if the target space isn't editable.
 */
export const acceptProposalMutation = (options?: Partial<Options<AcceptProposalData>>): UseMutationOptions<AcceptProposalResponse, AcceptProposalError, Options<AcceptProposalData>> => {
    const mutationOptions: UseMutationOptions<AcceptProposalResponse, AcceptProposalError, Options<AcceptProposalData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await acceptProposal({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Reject Proposal
 *
 * Reject a proposal; the same fact won't be proposed to you again.
 */
export const rejectProposalMutation = (options?: Partial<Options<RejectProposalData>>): UseMutationOptions<RejectProposalResponse, RejectProposalError, Options<RejectProposalData>> => {
    const mutationOptions: UseMutationOptions<RejectProposalResponse, RejectProposalError, Options<RejectProposalData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await rejectProposal({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const listDuplicatesQueryKey = (options: Options<ListDuplicatesData>) => createQueryKey('listDuplicates', options);

/**
 * List Duplicates
 *
 * Pages in this space that look like the same thing (editor+), strongest first.
 */
export const listDuplicatesOptions = (options: Options<ListDuplicatesData>) => queryOptions<ListDuplicatesResponse, ListDuplicatesError, ListDuplicatesResponse, ReturnType<typeof listDuplicatesQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await listDuplicates({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listDuplicatesQueryKey(options)
});

/**
 * Dismiss Duplicate
 *
 * "Not the same thing": don't suggest merging these two again (editor+).
 */
export const dismissDuplicateMutation = (options?: Partial<Options<DismissDuplicateData>>): UseMutationOptions<DismissDuplicateResponse, DismissDuplicateError, Options<DismissDuplicateData>> => {
    const mutationOptions: UseMutationOptions<DismissDuplicateResponse, DismissDuplicateError, Options<DismissDuplicateData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await dismissDuplicate({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Create Import
 *
 * Import pasted text, or a file already in the space's knowledge base (editor+ on the space).
 *
 * Send exactly one of ``text`` and ``spaceFileUuid``. 400 ``KG_IMPORT_INVALID`` / ``KG_IMPORT_UNSUPPORTED``,
 * 404 if the space file isn't in this space, 429 ``KG_IMPORT_BUSY``.
 */
export const createImportMutation = (options?: Partial<Options<CreateImportData>>): UseMutationOptions<CreateImportResponse, CreateImportError, Options<CreateImportData>> => {
    const mutationOptions: UseMutationOptions<CreateImportResponse, CreateImportError, Options<CreateImportData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await createImport({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Upload Import
 *
 * Import an uploaded document into your inbox as proposed facts (editor+ on the space).
 *
 * The file isn't kept. 400 ``KG_IMPORT_UNSUPPORTED``, 413 ``KG_IMPORT_TOO_LARGE``, 429 ``KG_IMPORT_BUSY``.
 */
export const uploadImportMutation = (options?: Partial<Options<UploadImportData>>): UseMutationOptions<UploadImportResponse, UploadImportError, Options<UploadImportData>> => {
    const mutationOptions: UseMutationOptions<UploadImportResponse, UploadImportError, Options<UploadImportData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await uploadImport({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const listMergesQueryKey = (options: Options<ListMergesData>) => createQueryKey('listMerges', options);

/**
 * List Merges
 *
 * Recent merges in this space, newest first (editor+): the audit trail, with undo.
 */
export const listMergesOptions = (options: Options<ListMergesData>) => queryOptions<ListMergesResponse, ListMergesError, ListMergesResponse, ReturnType<typeof listMergesQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await listMerges({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listMergesQueryKey(options)
});

/**
 * Merge Pages
 *
 * Merge ``removePath`` into ``keepPath`` (editor+). 409 ``KG_MERGE_CONFLICT`` if either changed
 * since the preview. Undo with ``POST .../merges/{uuid}/undo``.
 */
export const mergePagesMutation = (options?: Partial<Options<MergePagesData>>): UseMutationOptions<MergePagesResponse, MergePagesError, Options<MergePagesData>> => {
    const mutationOptions: UseMutationOptions<MergePagesResponse, MergePagesError, Options<MergePagesData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await mergePages({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Preview Merge
 *
 * What merging ``removePath`` into ``keepPath`` would do (editor+). Changes nothing.
 */
export const previewMergeMutation = (options?: Partial<Options<PreviewMergeData>>): UseMutationOptions<PreviewMergeResponse, PreviewMergeError, Options<PreviewMergeData>> => {
    const mutationOptions: UseMutationOptions<PreviewMergeResponse, PreviewMergeError, Options<PreviewMergeData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await previewMerge({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Undo Merge
 *
 * Restore every page a merge changed (editor+). 409 ``KG_MERGE_CONFLICT`` if any changed since.
 */
export const undoMergeMutation = (options?: Partial<Options<UndoMergeData>>): UseMutationOptions<UndoMergeResponse, UndoMergeError, Options<UndoMergeData>> => {
    const mutationOptions: UseMutationOptions<UndoMergeResponse, UndoMergeError, Options<UndoMergeData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await undoMerge({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const listWikiFilesQueryKey = (options: Options<ListWikiFilesData>) => createQueryKey('listWikiFiles', options);

/**
 * List Wiki Files
 *
 * Wiki files in the space that the caller may read.
 *
 * Members see what their role allows; anyone else sees only the space's ``org`` pages,
 * and a space with none looks the same to them as one that doesn't exist (404).
 */
export const listWikiFilesOptions = (options: Options<ListWikiFilesData>) => queryOptions<ListWikiFilesResponse, ListWikiFilesError, ListWikiFilesResponse, ReturnType<typeof listWikiFilesQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await listWikiFiles({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listWikiFilesQueryKey(options)
});

/**
 * Delete Wiki File
 *
 * Delete a wiki file (its history is kept), then reindex (editor+).
 */
export const deleteWikiFileMutation = (options?: Partial<Options<DeleteWikiFileData>>): UseMutationOptions<DeleteWikiFileResponse, DeleteWikiFileError, Options<DeleteWikiFileData>> => {
    const mutationOptions: UseMutationOptions<DeleteWikiFileResponse, DeleteWikiFileError, Options<DeleteWikiFileData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await deleteWikiFile({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getWikiFileQueryKey = (options: Options<GetWikiFileData>) => createQueryKey('getWikiFile', options);

/**
 * Get Wiki File
 *
 * One wiki file: markdown, indexed node, diagnostics, links and backlinks (viewer+).
 */
export const getWikiFileOptions = (options: Options<GetWikiFileData>) => queryOptions<GetWikiFileResponse, GetWikiFileError, GetWikiFileResponse, ReturnType<typeof getWikiFileQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getWikiFile({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getWikiFileQueryKey(options)
});

/**
 * Save Wiki File
 *
 * Create (``baseRevision`` null) or update a wiki file, then reindex (editor+).
 *
 * 409 ``WIKI_CONFLICT`` if the file changed since ``baseRevision``. The page's
 * embedding (for the broker) is refreshed after the response.
 */
export const saveWikiFileMutation = (options?: Partial<Options<SaveWikiFileData>>): UseMutationOptions<SaveWikiFileResponse, SaveWikiFileError, Options<SaveWikiFileData>> => {
    const mutationOptions: UseMutationOptions<SaveWikiFileResponse, SaveWikiFileError, Options<SaveWikiFileData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await saveWikiFile({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const listMicroAppsQueryKey = (options?: Options<ListMicroAppsData>) => createQueryKey('listMicroApps', options);

/**
 * List Micro Apps
 *
 * List micro apps the caller can access.
 */
export const listMicroAppsOptions = (options?: Options<ListMicroAppsData>) => queryOptions<ListMicroAppsResponse, ListMicroAppsError, ListMicroAppsResponse, ReturnType<typeof listMicroAppsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await listMicroApps({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listMicroAppsQueryKey(options)
});

export const listMicroAppsInfiniteQueryKey = (options?: Options<ListMicroAppsData>): QueryKey<Options<ListMicroAppsData>> => createQueryKey('listMicroApps', options, true);

/**
 * List Micro Apps
 *
 * List micro apps the caller can access.
 */
export const listMicroAppsInfiniteOptions = (options?: Options<ListMicroAppsData>) => {
    const opts = infiniteQueryOptions<ListMicroAppsResponse, ListMicroAppsError, InfiniteData<ListMicroAppsResponse>, QueryKey<Options<ListMicroAppsData>>, number | Pick<QueryKey<Options<ListMicroAppsData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<ListMicroAppsData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                query: {
                    page: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await listMicroApps({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: listMicroAppsInfiniteQueryKey(options)
    });
    return opts as Omit<typeof opts, 'initialData'>;
};

export const getAttachmentBindingsQueryKey = (options: Options<GetAttachmentBindingsData>) => createQueryKey('getAttachmentBindings', options);

/**
 * Get Attachment Bindings
 *
 * Read an attachment's data bindings (grouped per source) for the publish dialog.
 *
 * Lets the author see each data source and choose its mode before publishing.
 */
export const getAttachmentBindingsOptions = (options: Options<GetAttachmentBindingsData>) => queryOptions<GetAttachmentBindingsResponse, GetAttachmentBindingsError, GetAttachmentBindingsResponse, ReturnType<typeof getAttachmentBindingsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getAttachmentBindings({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getAttachmentBindingsQueryKey(options)
});

/**
 * Publish Micro App
 *
 * Publish a generated HTML attachment as a first-class micro app.
 */
export const publishMicroAppMutation = (options?: Partial<Options<PublishMicroAppData>>): UseMutationOptions<PublishMicroAppResponse, PublishMicroAppError, Options<PublishMicroAppData>> => {
    const mutationOptions: UseMutationOptions<PublishMicroAppResponse, PublishMicroAppError, Options<PublishMicroAppData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await publishMicroApp({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Delete Micro App
 *
 * Soft-delete a micro app (admin only).
 */
export const deleteMicroAppMutation = (options?: Partial<Options<DeleteMicroAppData>>): UseMutationOptions<DeleteMicroAppResponse, DeleteMicroAppError, Options<DeleteMicroAppData>> => {
    const mutationOptions: UseMutationOptions<DeleteMicroAppResponse, DeleteMicroAppError, Options<DeleteMicroAppData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await deleteMicroApp({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getMicroAppQueryKey = (options: Options<GetMicroAppData>) => createQueryKey('getMicroApp', options);

/**
 * Get Micro App
 *
 * Get a single micro app's metadata.
 */
export const getMicroAppOptions = (options: Options<GetMicroAppData>) => queryOptions<GetMicroAppResponse, GetMicroAppError, GetMicroAppResponse, ReturnType<typeof getMicroAppQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getMicroApp({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getMicroAppQueryKey(options)
});

/**
 * Update Micro App
 *
 * Update a micro app's metadata (editor+ only).
 */
export const updateMicroAppMutation = (options?: Partial<Options<UpdateMicroAppData>>): UseMutationOptions<UpdateMicroAppResponse, UpdateMicroAppError, Options<UpdateMicroAppData>> => {
    const mutationOptions: UseMutationOptions<UpdateMicroAppResponse, UpdateMicroAppError, Options<UpdateMicroAppData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await updateMicroApp({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getMicroAppContentQueryKey = (options: Options<GetMicroAppContentData>) => createQueryKey('getMicroAppContent', options);

/**
 * Get Micro App Content
 *
 * Return the rendered micro app content (HTML) for the viewer.
 *
 * Uses ETag revalidation (``no-cache`` + ``ETag``) rather than a blind TTL so
 * that a re-published/edited dashboard is picked up immediately: the browser
 * revalidates on every load and gets a cheap ``304`` when unchanged or fresh
 * ``200`` when the content (blob) has changed.
 */
export const getMicroAppContentOptions = (options: Options<GetMicroAppContentData>) => queryOptions<unknown, GetMicroAppContentError, unknown, ReturnType<typeof getMicroAppContentQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getMicroAppContent({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getMicroAppContentQueryKey(options)
});

export const getMicroAppInfoQueryKey = (options: Options<GetMicroAppInfoData>) => createQueryKey('getMicroAppInfo', options);

/**
 * Get Micro App Info
 *
 * Return the end-user Info/About panel: identity + authorship + provenance.
 *
 * Composes the app's narrative (``about``) and factual, auto-derived data
 * provenance (sources, refresh cadence, last refresh). Lightweight auth; the
 * same view gate as opening the app.
 */
export const getMicroAppInfoOptions = (options: Options<GetMicroAppInfoData>) => queryOptions<GetMicroAppInfoResponse, GetMicroAppInfoError, GetMicroAppInfoResponse, ReturnType<typeof getMicroAppInfoQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getMicroAppInfo({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getMicroAppInfoQueryKey(options)
});

export const getMicroAppMembersQueryKey = (options: Options<GetMicroAppMembersData>) => createQueryKey('getMicroAppMembers', options);

/**
 * Get Micro App Members
 *
 * List a micro app's members (viewer+).
 */
export const getMicroAppMembersOptions = (options: Options<GetMicroAppMembersData>) => queryOptions<GetMicroAppMembersResponse, GetMicroAppMembersError, GetMicroAppMembersResponse, ReturnType<typeof getMicroAppMembersQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getMicroAppMembers({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getMicroAppMembersQueryKey(options)
});

/**
 * Add Micro App Team Member
 *
 * Grant a team a role on a micro app (admin only).
 */
export const addMicroAppTeamMemberMutation = (options?: Partial<Options<AddMicroAppTeamMemberData>>): UseMutationOptions<AddMicroAppTeamMemberResponse, AddMicroAppTeamMemberError, Options<AddMicroAppTeamMemberData>> => {
    const mutationOptions: UseMutationOptions<AddMicroAppTeamMemberResponse, AddMicroAppTeamMemberError, Options<AddMicroAppTeamMemberData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await addMicroAppTeamMember({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Remove Micro App Team Member
 *
 * Remove a team member (admin only).
 */
export const removeMicroAppTeamMemberMutation = (options?: Partial<Options<RemoveMicroAppTeamMemberData>>): UseMutationOptions<RemoveMicroAppTeamMemberResponse, RemoveMicroAppTeamMemberError, Options<RemoveMicroAppTeamMemberData>> => {
    const mutationOptions: UseMutationOptions<RemoveMicroAppTeamMemberResponse, RemoveMicroAppTeamMemberError, Options<RemoveMicroAppTeamMemberData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await removeMicroAppTeamMember({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Update Micro App Team Member
 *
 * Change a team member's role (admin only).
 */
export const updateMicroAppTeamMemberMutation = (options?: Partial<Options<UpdateMicroAppTeamMemberData>>): UseMutationOptions<UpdateMicroAppTeamMemberResponse, UpdateMicroAppTeamMemberError, Options<UpdateMicroAppTeamMemberData>> => {
    const mutationOptions: UseMutationOptions<UpdateMicroAppTeamMemberResponse, UpdateMicroAppTeamMemberError, Options<UpdateMicroAppTeamMemberData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await updateMicroAppTeamMember({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Add Micro App User Member
 *
 * Grant a user a role on a micro app (admin only).
 */
export const addMicroAppUserMemberMutation = (options?: Partial<Options<AddMicroAppUserMemberData>>): UseMutationOptions<AddMicroAppUserMemberResponse, AddMicroAppUserMemberError, Options<AddMicroAppUserMemberData>> => {
    const mutationOptions: UseMutationOptions<AddMicroAppUserMemberResponse, AddMicroAppUserMemberError, Options<AddMicroAppUserMemberData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await addMicroAppUserMember({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Remove Micro App User Member
 *
 * Remove a user member (admin only).
 */
export const removeMicroAppUserMemberMutation = (options?: Partial<Options<RemoveMicroAppUserMemberData>>): UseMutationOptions<RemoveMicroAppUserMemberResponse, RemoveMicroAppUserMemberError, Options<RemoveMicroAppUserMemberData>> => {
    const mutationOptions: UseMutationOptions<RemoveMicroAppUserMemberResponse, RemoveMicroAppUserMemberError, Options<RemoveMicroAppUserMemberData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await removeMicroAppUserMember({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Update Micro App User Member
 *
 * Change a user member's role (admin only).
 */
export const updateMicroAppUserMemberMutation = (options?: Partial<Options<UpdateMicroAppUserMemberData>>): UseMutationOptions<UpdateMicroAppUserMemberResponse, UpdateMicroAppUserMemberError, Options<UpdateMicroAppUserMemberData>> => {
    const mutationOptions: UseMutationOptions<UpdateMicroAppUserMemberResponse, UpdateMicroAppUserMemberError, Options<UpdateMicroAppUserMemberData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await updateMicroAppUserMember({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Republish Micro App
 *
 * Replace a micro app's content from a newly generated attachment (editor+ only).
 *
 * Copies the new HTML blob, re-extracts and reconciles the live-data bindings,
 * and preserves the existing author-delegated authorization when the data owner
 * is unchanged. Lets an owner iterate on a dashboard in chat and push the new
 * version to the already-published app instead of forking a new one.
 */
export const republishMicroAppMutation = (options?: Partial<Options<RepublishMicroAppData>>): UseMutationOptions<RepublishMicroAppResponse, RepublishMicroAppError, Options<RepublishMicroAppData>> => {
    const mutationOptions: UseMutationOptions<RepublishMicroAppResponse, RepublishMicroAppError, Options<RepublishMicroAppData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await republishMicroApp({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const modelsListModelsQueryKey = (options?: Options<ModelsListModelsData>) => createQueryKey('modelsListModels', options);

/**
 * List Models
 *
 * List available AI models.
 *
 * By default shows enabled models plus deprecated ones (so agent owners can be
 * warned). Admins can see disabled models.
 */
export const modelsListModelsOptions = (options?: Options<ModelsListModelsData>) => queryOptions<ModelsListModelsResponse, ModelsListModelsError, ModelsListModelsResponse, ReturnType<typeof modelsListModelsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await modelsListModels({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: modelsListModelsQueryKey(options)
});

export const modelsListModelsInfiniteQueryKey = (options?: Options<ModelsListModelsData>): QueryKey<Options<ModelsListModelsData>> => createQueryKey('modelsListModels', options, true);

/**
 * List Models
 *
 * List available AI models.
 *
 * By default shows enabled models plus deprecated ones (so agent owners can be
 * warned). Admins can see disabled models.
 */
export const modelsListModelsInfiniteOptions = (options?: Options<ModelsListModelsData>) => {
    const opts = infiniteQueryOptions<ModelsListModelsResponse, ModelsListModelsError, InfiniteData<ModelsListModelsResponse>, QueryKey<Options<ModelsListModelsData>>, number | Pick<QueryKey<Options<ModelsListModelsData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<ModelsListModelsData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                query: {
                    page: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await modelsListModels({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: modelsListModelsInfiniteQueryKey(options)
    });
    return opts as Omit<typeof opts, 'initialData'>;
};

export const listUserFacingTierDefaultsQueryKey = (options?: Options<ListUserFacingTierDefaultsData>) => createQueryKey('listUserFacingTierDefaults', options);

/**
 * List User Facing Tier Defaults
 *
 * List user-facing model tier defaults (Default Fast, Default Thorough, etc.).
 *
 * These appear in model dropdowns as virtual model options that automatically
 * resolve to the admin-configured model deployment.
 */
export const listUserFacingTierDefaultsOptions = (options?: Options<ListUserFacingTierDefaultsData>) => queryOptions<ListUserFacingTierDefaultsResponse, DefaultError, ListUserFacingTierDefaultsResponse, ReturnType<typeof listUserFacingTierDefaultsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await listUserFacingTierDefaults({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listUserFacingTierDefaultsQueryKey(options)
});

export const listNotificationsQueryKey = (options?: Options<ListNotificationsData>) => createQueryKey('listNotifications', options);

/**
 * List Notifications
 *
 * List notifications for the authenticated user.
 */
export const listNotificationsOptions = (options?: Options<ListNotificationsData>) => queryOptions<ListNotificationsResponse, ListNotificationsError, ListNotificationsResponse, ReturnType<typeof listNotificationsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await listNotifications({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listNotificationsQueryKey(options)
});

export const listNotificationsInfiniteQueryKey = (options?: Options<ListNotificationsData>): QueryKey<Options<ListNotificationsData>> => createQueryKey('listNotifications', options, true);

/**
 * List Notifications
 *
 * List notifications for the authenticated user.
 */
export const listNotificationsInfiniteOptions = (options?: Options<ListNotificationsData>) => {
    const opts = infiniteQueryOptions<ListNotificationsResponse, ListNotificationsError, InfiniteData<ListNotificationsResponse>, QueryKey<Options<ListNotificationsData>>, number | Pick<QueryKey<Options<ListNotificationsData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<ListNotificationsData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                query: {
                    page: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await listNotifications({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: listNotificationsInfiniteQueryKey(options)
    });
    return opts as Omit<typeof opts, 'initialData'>;
};

/**
 * Mark All Read
 *
 * Mark all unread notifications as read.
 */
export const markAllReadMutation = (options?: Partial<Options<MarkAllReadData>>): UseMutationOptions<MarkAllReadResponse, DefaultError, Options<MarkAllReadData>> => {
    const mutationOptions: UseMutationOptions<MarkAllReadResponse, DefaultError, Options<MarkAllReadData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await markAllRead({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getPreferencesQueryKey = (options?: Options<GetPreferencesData>) => createQueryKey('getPreferences', options);

/**
 * Get Preferences
 *
 * Get notification preferences for all event types.
 */
export const getPreferencesOptions = (options?: Options<GetPreferencesData>) => queryOptions<GetPreferencesResponse, DefaultError, GetPreferencesResponse, ReturnType<typeof getPreferencesQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getPreferences({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getPreferencesQueryKey(options)
});

/**
 * Update Preferences
 *
 * Update notification preferences (bulk upsert).
 */
export const updatePreferencesMutation = (options?: Partial<Options<UpdatePreferencesData>>): UseMutationOptions<UpdatePreferencesResponse, UpdatePreferencesError, Options<UpdatePreferencesData>> => {
    const mutationOptions: UseMutationOptions<UpdatePreferencesResponse, UpdatePreferencesError, Options<UpdatePreferencesData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await updatePreferences({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getUnreadCountQueryKey = (options?: Options<GetUnreadCountData>) => createQueryKey('getUnreadCount', options);

/**
 * Get Unread Count
 *
 * Get the number of unread notifications.
 */
export const getUnreadCountOptions = (options?: Options<GetUnreadCountData>) => queryOptions<GetUnreadCountResponse, DefaultError, GetUnreadCountResponse, ReturnType<typeof getUnreadCountQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getUnreadCount({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getUnreadCountQueryKey(options)
});

/**
 * Mark Notification Read
 *
 * Mark a single notification as read.
 */
export const markNotificationReadMutation = (options?: Partial<Options<MarkNotificationReadData>>): UseMutationOptions<MarkNotificationReadResponse, MarkNotificationReadError, Options<MarkNotificationReadData>> => {
    const mutationOptions: UseMutationOptions<MarkNotificationReadResponse, MarkNotificationReadError, Options<MarkNotificationReadData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await markNotificationRead({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const listActiveOperationsQueryKey = (options?: Options<ListActiveOperationsData>) => createQueryKey('listActiveOperations', options);

/**
 * List Active Operations
 *
 * List all active operations for the current user.
 *
 * Used by the old frontend's ``OperationContext`` on mount, and by web/ to reattach a running reply after a
 * reload (MHS-793). Stale operations are failed lazily here (15 minutes without a sign of life), and listed this
 * once more with status ``failed``, so a reply whose worker died shows as failed instead of vanishing.
 */
export const listActiveOperationsOptions = (options?: Options<ListActiveOperationsData>) => queryOptions<ListActiveOperationsResponse, DefaultError, ListActiveOperationsResponse, ReturnType<typeof listActiveOperationsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await listActiveOperations({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listActiveOperationsQueryKey(options)
});

/**
 * Cancel Operation
 *
 * Ask a running operation to stop (cooperative, idempotent).
 *
 * The runner stops at its next check (within about a second), then finishes
 * with the normal ``operation_completed`` event carrying ``cancelled: true``.
 * Closing a stream alone only unsubscribes; this actually stops the work.
 */
export const cancelOperationMutation = (options?: Partial<Options<CancelOperationData>>): UseMutationOptions<CancelOperationResponse, CancelOperationError, Options<CancelOperationData>> => {
    const mutationOptions: UseMutationOptions<CancelOperationResponse, CancelOperationError, Options<CancelOperationData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await cancelOperation({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Download Document
 *
 * Download a SharePoint document and extract its text content.
 *
 * Resolves the URL, downloads the file bytes, and extracts readable text.
 * For presentations (.pptx/.ppt), converts slides to images instead.
 * Supports PDF, PowerPoint (.pptx), Word (.docx), plain text, CSV, JSON,
 * and Markdown files.
 */
export const sharepointDownloadDocumentMutation = (options?: Partial<Options<SharepointDownloadDocumentData>>): UseMutationOptions<SharepointDownloadDocumentResponse, SharepointDownloadDocumentError, Options<SharepointDownloadDocumentData>> => {
    const mutationOptions: UseMutationOptions<SharepointDownloadDocumentResponse, SharepointDownloadDocumentError, Options<SharepointDownloadDocumentData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await sharepointDownloadDocument({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const listDriveItemsQueryKey = (options: Options<ListDriveItemsData>) => createQueryKey('listDriveItems', options);

/**
 * List Drive Items
 *
 * List files and folders within a drive or a specific folder.
 *
 * Either provide ``folder_id`` to browse by ID, ``path`` to browse by
 * path, or omit both to list the drive root.
 */
export const listDriveItemsOptions = (options: Options<ListDriveItemsData>) => queryOptions<ListDriveItemsResponse, ListDriveItemsError, ListDriveItemsResponse, ReturnType<typeof listDriveItemsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await listDriveItems({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listDriveItemsQueryKey(options)
});

export const sharepointCountFolderItemsQueryKey = (options: Options<SharepointCountFolderItemsData>) => createQueryKey('sharepointCountFolderItems', options);

/**
 * Count Folder Items
 *
 * Count files inside a SharePoint folder.
 *
 * Returns the number of *supported* files (those with indexable
 * extensions) and the total number of files.  When ``recursive=true``,
 * includes files in all sub-folders.  The total count is capped at
 * 1000 — if exceeded, ``truncated`` is ``true``.
 */
export const sharepointCountFolderItemsOptions = (options: Options<SharepointCountFolderItemsData>) => queryOptions<SharepointCountFolderItemsResponse, SharepointCountFolderItemsError, SharepointCountFolderItemsResponse, ReturnType<typeof sharepointCountFolderItemsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await sharepointCountFolderItems({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: sharepointCountFolderItemsQueryKey(options)
});

export const searchDriveItemsQueryKey = (options: Options<SearchDriveItemsData>) => createQueryKey('searchDriveItems', options);

/**
 * Search Drive Items
 *
 * Search for files within a specific document library.
 */
export const searchDriveItemsOptions = (options: Options<SearchDriveItemsData>) => queryOptions<SearchDriveItemsResponse, SearchDriveItemsError, SearchDriveItemsResponse, ReturnType<typeof searchDriveItemsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await searchDriveItems({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: searchDriveItemsQueryKey(options)
});

export const getMyOnedriveQueryKey = (options?: Options<GetMyOnedriveData>) => createQueryKey('getMyOnedrive', options);

/**
 * Get My Onedrive
 *
 * Get the current user's personal OneDrive (as a drive).
 *
 * Returned in the same shape as a SharePoint document library so the
 * frontend can reuse the existing drive/item browsing flow. The returned
 * ``id`` is the OneDrive drive ID; feed it to the existing
 * ``/drives/{drive_id}/items`` endpoints to browse.
 */
export const getMyOnedriveOptions = (options?: Options<GetMyOnedriveData>) => queryOptions<GetMyOnedriveResponse, DefaultError, GetMyOnedriveResponse, ReturnType<typeof getMyOnedriveQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getMyOnedrive({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getMyOnedriveQueryKey(options)
});

export const resolveSharepointUrlQueryKey = (options: Options<ResolveSharepointUrlData>) => createQueryKey('resolveSharepointUrl', options);

/**
 * Resolve Sharepoint Url
 *
 * Resolve a SharePoint/OneDrive URL to a file item.
 *
 * Supports various URL formats including sharing links and direct file paths.
 */
export const resolveSharepointUrlOptions = (options: Options<ResolveSharepointUrlData>) => queryOptions<ResolveSharepointUrlResponse, ResolveSharepointUrlError, ResolveSharepointUrlResponse, ReturnType<typeof resolveSharepointUrlQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await resolveSharepointUrl({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: resolveSharepointUrlQueryKey(options)
});

export const searchSitesQueryKey = (options?: Options<SearchSitesData>) => createQueryKey('searchSites', options);

/**
 * Search Sites
 *
 * Search for SharePoint sites the current user has access to.
 */
export const searchSitesOptions = (options?: Options<SearchSitesData>) => queryOptions<SearchSitesResponse, SearchSitesError, SearchSitesResponse, ReturnType<typeof searchSitesQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await searchSites({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: searchSitesQueryKey(options)
});

export const listSiteDrivesQueryKey = (options: Options<ListSiteDrivesData>) => createQueryKey('listSiteDrives', options);

/**
 * List Site Drives
 *
 * List document libraries (drives) within a SharePoint site.
 */
export const listSiteDrivesOptions = (options: Options<ListSiteDrivesData>) => queryOptions<ListSiteDrivesResponse, ListSiteDrivesError, ListSiteDrivesResponse, ReturnType<typeof listSiteDrivesQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await listSiteDrives({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listSiteDrivesQueryKey(options)
});

export const listSkillsQueryKey = (options?: Options<ListSkillsData>) => createQueryKey('listSkills', options);

/**
 * List Skills
 *
 * List skills accessible to the user.
 *
 * Returns platform-managed (system/extension) skills plus skills the user
 * holds a grant on (directly or via a team). Platform admins see all skills.
 */
export const listSkillsOptions = (options?: Options<ListSkillsData>) => queryOptions<ListSkillsResponse, ListSkillsError, ListSkillsResponse, ReturnType<typeof listSkillsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await listSkills({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listSkillsQueryKey(options)
});

export const listSkillsInfiniteQueryKey = (options?: Options<ListSkillsData>): QueryKey<Options<ListSkillsData>> => createQueryKey('listSkills', options, true);

/**
 * List Skills
 *
 * List skills accessible to the user.
 *
 * Returns platform-managed (system/extension) skills plus skills the user
 * holds a grant on (directly or via a team). Platform admins see all skills.
 */
export const listSkillsInfiniteOptions = (options?: Options<ListSkillsData>) => {
    const opts = infiniteQueryOptions<ListSkillsResponse, ListSkillsError, InfiniteData<ListSkillsResponse>, QueryKey<Options<ListSkillsData>>, number | Pick<QueryKey<Options<ListSkillsData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<ListSkillsData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                query: {
                    page: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await listSkills({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: listSkillsInfiniteQueryKey(options)
    });
    return opts as Omit<typeof opts, 'initialData'>;
};

/**
 * Create Skill
 *
 * Create a new skill. The creator becomes its admin.
 */
export const createSkillMutation = (options?: Partial<Options<CreateSkillData>>): UseMutationOptions<CreateSkillResponse, CreateSkillError, Options<CreateSkillData>> => {
    const mutationOptions: UseMutationOptions<CreateSkillResponse, CreateSkillError, Options<CreateSkillData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await createSkill({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const listSkillCategoriesQueryKey = (options?: Options<ListSkillCategoriesData>) => createQueryKey('listSkillCategories', options);

/**
 * List Skill Categories
 *
 * List all unique skill categories.
 */
export const listSkillCategoriesOptions = (options?: Options<ListSkillCategoriesData>) => queryOptions<ListSkillCategoriesResponse, DefaultError, ListSkillCategoriesResponse, ReturnType<typeof listSkillCategoriesQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await listSkillCategories({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listSkillCategoriesQueryKey(options)
});

/**
 * Import Skills
 *
 * Import selected skills/agents from an uploaded Agent-Skills bundle (MHS-359).
 *
 * The zip may contain a single ``SKILL.md`` bundle at the root or several
 * bundles nested one level down. Imported skills are created **private** to the
 * uploading user; ``required_tools`` are resolved by name and any not present
 * in this install are reported back (not fatal). When ``selection`` is
 * provided, only the listed skills/agents are created (with optional agent
 * renames); otherwise everything found is imported.
 */
export const importSkillsMutation = (options?: Partial<Options<ImportSkillsData>>): UseMutationOptions<ImportSkillsResponse, ImportSkillsError, Options<ImportSkillsData>> => {
    const mutationOptions: UseMutationOptions<ImportSkillsResponse, ImportSkillsError, Options<ImportSkillsData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await importSkills({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Analyze Import
 *
 * Analyze an uploaded bundle and report what *would* be imported — no writes.
 *
 * Returns the detected skills and agents (with tool matches/gaps and whether a
 * skill name is already taken) so the UI can let the user uncheck items and
 * rename agents before approving (MHS-359).
 */
export const analyzeImportMutation = (options?: Partial<Options<AnalyzeImportData>>): UseMutationOptions<AnalyzeImportResponse, AnalyzeImportError, Options<AnalyzeImportData>> => {
    const mutationOptions: UseMutationOptions<AnalyzeImportResponse, AnalyzeImportError, Options<AnalyzeImportData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await analyzeImport({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Delete Skill
 *
 * Soft delete a skill.
 *
 * Requires admin. System skills cannot be deleted; extension skills only by
 * platform admins.
 */
export const deleteSkillMutation = (options?: Partial<Options<DeleteSkillData>>): UseMutationOptions<DeleteSkillResponse, DeleteSkillError, Options<DeleteSkillData>> => {
    const mutationOptions: UseMutationOptions<DeleteSkillResponse, DeleteSkillError, Options<DeleteSkillData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await deleteSkill({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getSkillQueryKey = (options: Options<GetSkillData>) => createQueryKey('getSkill', options);

/**
 * Get Skill
 *
 * Get a skill by UUID.
 */
export const getSkillOptions = (options: Options<GetSkillData>) => queryOptions<GetSkillResponse, GetSkillError, GetSkillResponse, ReturnType<typeof getSkillQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getSkill({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getSkillQueryKey(options)
});

/**
 * Update Skill
 *
 * Update a skill.
 *
 * Requires editor. System skills cannot be modified; extension skills only
 * by platform admins.
 */
export const updateSkillMutation = (options?: Partial<Options<UpdateSkillData>>): UseMutationOptions<UpdateSkillResponse, UpdateSkillError, Options<UpdateSkillData>> => {
    const mutationOptions: UseMutationOptions<UpdateSkillResponse, UpdateSkillError, Options<UpdateSkillData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await updateSkill({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const skillDeleteImpactQueryKey = (options: Options<SkillDeleteImpactData>) => createQueryKey('skillDeleteImpact', options);

/**
 * Skill Delete Impact
 *
 * What deleting this skill would affect: imported sibling agents + how many
 * agents it's attached to (MHS-359).
 */
export const skillDeleteImpactOptions = (options: Options<SkillDeleteImpactData>) => queryOptions<SkillDeleteImpactResponse2, SkillDeleteImpactError, SkillDeleteImpactResponse2, ReturnType<typeof skillDeleteImpactQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await skillDeleteImpact({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: skillDeleteImpactQueryKey(options)
});

export const getSkillMembersQueryKey = (options: Options<GetSkillMembersData>) => createQueryKey('getSkillMembers', options);

/**
 * Get Skill Members
 *
 * List who has access to a skill (viewer+).
 */
export const getSkillMembersOptions = (options: Options<GetSkillMembersData>) => queryOptions<GetSkillMembersResponse, GetSkillMembersError, GetSkillMembersResponse, ReturnType<typeof getSkillMembersQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getSkillMembers({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getSkillMembersQueryKey(options)
});

/**
 * Add Skill Team Member
 *
 * Grant a team a role on a skill (admin only).
 */
export const addSkillTeamMemberMutation = (options?: Partial<Options<AddSkillTeamMemberData>>): UseMutationOptions<AddSkillTeamMemberResponse, AddSkillTeamMemberError, Options<AddSkillTeamMemberData>> => {
    const mutationOptions: UseMutationOptions<AddSkillTeamMemberResponse, AddSkillTeamMemberError, Options<AddSkillTeamMemberData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await addSkillTeamMember({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Remove Skill Team Member
 *
 * Remove a team member (admin only; never the last admin).
 */
export const removeSkillTeamMemberMutation = (options?: Partial<Options<RemoveSkillTeamMemberData>>): UseMutationOptions<RemoveSkillTeamMemberResponse, RemoveSkillTeamMemberError, Options<RemoveSkillTeamMemberData>> => {
    const mutationOptions: UseMutationOptions<RemoveSkillTeamMemberResponse, RemoveSkillTeamMemberError, Options<RemoveSkillTeamMemberData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await removeSkillTeamMember({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Update Skill Team Member
 *
 * Change a team member's role (admin only).
 */
export const updateSkillTeamMemberMutation = (options?: Partial<Options<UpdateSkillTeamMemberData>>): UseMutationOptions<UpdateSkillTeamMemberResponse, UpdateSkillTeamMemberError, Options<UpdateSkillTeamMemberData>> => {
    const mutationOptions: UseMutationOptions<UpdateSkillTeamMemberResponse, UpdateSkillTeamMemberError, Options<UpdateSkillTeamMemberData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await updateSkillTeamMember({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Add Skill User Member
 *
 * Grant a user a role on a skill (admin only).
 */
export const addSkillUserMemberMutation = (options?: Partial<Options<AddSkillUserMemberData>>): UseMutationOptions<AddSkillUserMemberResponse, AddSkillUserMemberError, Options<AddSkillUserMemberData>> => {
    const mutationOptions: UseMutationOptions<AddSkillUserMemberResponse, AddSkillUserMemberError, Options<AddSkillUserMemberData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await addSkillUserMember({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Remove Skill User Member
 *
 * Remove a user member (admin only; never the last admin).
 */
export const removeSkillUserMemberMutation = (options?: Partial<Options<RemoveSkillUserMemberData>>): UseMutationOptions<RemoveSkillUserMemberResponse, RemoveSkillUserMemberError, Options<RemoveSkillUserMemberData>> => {
    const mutationOptions: UseMutationOptions<RemoveSkillUserMemberResponse, RemoveSkillUserMemberError, Options<RemoveSkillUserMemberData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await removeSkillUserMember({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Update Skill User Member
 *
 * Change a user member's role (admin only).
 */
export const updateSkillUserMemberMutation = (options?: Partial<Options<UpdateSkillUserMemberData>>): UseMutationOptions<UpdateSkillUserMemberResponse, UpdateSkillUserMemberError, Options<UpdateSkillUserMemberData>> => {
    const mutationOptions: UseMutationOptions<UpdateSkillUserMemberResponse, UpdateSkillUserMemberError, Options<UpdateSkillUserMemberData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await updateSkillUserMember({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const listSpacesQueryKey = (options?: Options<ListSpacesData>) => createQueryKey('listSpaces', options);

/**
 * List Spaces
 *
 * List spaces the caller can access (active by default; archived on request).
 */
export const listSpacesOptions = (options?: Options<ListSpacesData>) => queryOptions<ListSpacesResponse, ListSpacesError, ListSpacesResponse, ReturnType<typeof listSpacesQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await listSpaces({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listSpacesQueryKey(options)
});

export const listSpacesInfiniteQueryKey = (options?: Options<ListSpacesData>): QueryKey<Options<ListSpacesData>> => createQueryKey('listSpaces', options, true);

/**
 * List Spaces
 *
 * List spaces the caller can access (active by default; archived on request).
 */
export const listSpacesInfiniteOptions = (options?: Options<ListSpacesData>) => {
    const opts = infiniteQueryOptions<ListSpacesResponse, ListSpacesError, InfiniteData<ListSpacesResponse>, QueryKey<Options<ListSpacesData>>, number | Pick<QueryKey<Options<ListSpacesData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<ListSpacesData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                query: {
                    page: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await listSpaces({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: listSpacesInfiniteQueryKey(options)
    });
    return opts as Omit<typeof opts, 'initialData'>;
};

/**
 * Create Space
 *
 * Create a space. The creator becomes an admin member.
 */
export const createSpaceMutation = (options?: Partial<Options<CreateSpaceData>>): UseMutationOptions<CreateSpaceResponse, CreateSpaceError, Options<CreateSpaceData>> => {
    const mutationOptions: UseMutationOptions<CreateSpaceResponse, CreateSpaceError, Options<CreateSpaceData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await createSpace({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const listRecentActivitiesQueryKey = (options?: Options<ListRecentActivitiesData>) => createQueryKey('listRecentActivities', options);

/**
 * List Recent Activities
 *
 * Newest activity across every space the caller can view (Home and Spaces feeds).
 */
export const listRecentActivitiesOptions = (options?: Options<ListRecentActivitiesData>) => queryOptions<ListRecentActivitiesResponse, ListRecentActivitiesError, ListRecentActivitiesResponse, ReturnType<typeof listRecentActivitiesQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await listRecentActivities({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listRecentActivitiesQueryKey(options)
});

export const getPersonalSpaceQueryKey = (options?: Options<GetPersonalSpaceData>) => createQueryKey('getPersonalSpace', options);

/**
 * Get Personal Space
 *
 * Get-or-create the caller's personal space ("My Private Space").
 */
export const getPersonalSpaceOptions = (options?: Options<GetPersonalSpaceData>) => queryOptions<GetPersonalSpaceResponse, DefaultError, GetPersonalSpaceResponse, ReturnType<typeof getPersonalSpaceQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getPersonalSpace({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getPersonalSpaceQueryKey(options)
});

export const listPinsQueryKey = (options?: Options<ListPinsData>) => createQueryKey('listPins', options);

/**
 * List Pins
 *
 * List the caller's pinned spaces (sidebar order).
 */
export const listPinsOptions = (options?: Options<ListPinsData>) => queryOptions<ListPinsResponse, DefaultError, ListPinsResponse, ReturnType<typeof listPinsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await listPins({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listPinsQueryKey(options)
});

/**
 * Add Pin
 *
 * Pin a space into the caller's sidebar. Requires view access to the space.
 */
export const addPinMutation = (options?: Partial<Options<AddPinData>>): UseMutationOptions<AddPinResponse, AddPinError, Options<AddPinData>> => {
    const mutationOptions: UseMutationOptions<AddPinResponse, AddPinError, Options<AddPinData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await addPin({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Reorder Pins
 *
 * Reorder the caller's pinned spaces.
 */
export const reorderPinsMutation = (options?: Partial<Options<ReorderPinsData>>): UseMutationOptions<ReorderPinsResponse, ReorderPinsError, Options<ReorderPinsData>> => {
    const mutationOptions: UseMutationOptions<ReorderPinsResponse, ReorderPinsError, Options<ReorderPinsData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await reorderPins({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Remove Pin
 *
 * Unpin a space from the caller's sidebar.
 */
export const removePinMutation = (options?: Partial<Options<RemovePinData>>): UseMutationOptions<RemovePinResponse, RemovePinError, Options<RemovePinData>> => {
    const mutationOptions: UseMutationOptions<RemovePinResponse, RemovePinError, Options<RemovePinData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await removePin({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getSpaceSidebarQueryKey = (options?: Options<GetSpaceSidebarData>) => createQueryKey('getSpaceSidebar', options);

/**
 * Get Space Sidebar
 *
 * The caller's sidebar: General, then their sections, each with its spaces in display order.
 */
export const getSpaceSidebarOptions = (options?: Options<GetSpaceSidebarData>) => queryOptions<GetSpaceSidebarResponse, DefaultError, GetSpaceSidebarResponse, ReturnType<typeof getSpaceSidebarQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getSpaceSidebar({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getSpaceSidebarQueryKey(options)
});

/**
 * Create Sidebar Section
 *
 * Add a section at the end. Returns the whole sidebar.
 */
export const createSidebarSectionMutation = (options?: Partial<Options<CreateSidebarSectionData>>): UseMutationOptions<CreateSidebarSectionResponse, CreateSidebarSectionError, Options<CreateSidebarSectionData>> => {
    const mutationOptions: UseMutationOptions<CreateSidebarSectionResponse, CreateSidebarSectionError, Options<CreateSidebarSectionData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await createSidebarSection({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Reorder Sidebar Sections
 *
 * Put the caller's sections in this order (General stays first).
 */
export const reorderSidebarSectionsMutation = (options?: Partial<Options<ReorderSidebarSectionsData>>): UseMutationOptions<ReorderSidebarSectionsResponse, ReorderSidebarSectionsError, Options<ReorderSidebarSectionsData>> => {
    const mutationOptions: UseMutationOptions<ReorderSidebarSectionsResponse, ReorderSidebarSectionsError, Options<ReorderSidebarSectionsData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await reorderSidebarSections({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Delete Sidebar Section
 *
 * Delete a section (not General); its spaces move to General.
 */
export const deleteSidebarSectionMutation = (options?: Partial<Options<DeleteSidebarSectionData>>): UseMutationOptions<DeleteSidebarSectionResponse, DeleteSidebarSectionError, Options<DeleteSidebarSectionData>> => {
    const mutationOptions: UseMutationOptions<DeleteSidebarSectionResponse, DeleteSidebarSectionError, Options<DeleteSidebarSectionData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await deleteSidebarSection({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Update Sidebar Section
 *
 * Rename (not General), change how it's sorted, or collapse/expand it.
 */
export const updateSidebarSectionMutation = (options?: Partial<Options<UpdateSidebarSectionData>>): UseMutationOptions<UpdateSidebarSectionResponse, UpdateSidebarSectionError, Options<UpdateSidebarSectionData>> => {
    const mutationOptions: UseMutationOptions<UpdateSidebarSectionResponse, UpdateSidebarSectionError, Options<UpdateSidebarSectionData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await updateSidebarSection({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Move Sidebar Space
 *
 * Move a space to a section (or General), optionally at a position in its custom order.
 */
export const moveSidebarSpaceMutation = (options?: Partial<Options<MoveSidebarSpaceData>>): UseMutationOptions<MoveSidebarSpaceResponse, MoveSidebarSpaceError, Options<MoveSidebarSpaceData>> => {
    const mutationOptions: UseMutationOptions<MoveSidebarSpaceResponse, MoveSidebarSpaceError, Options<MoveSidebarSpaceData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await moveSidebarSpace({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Delete Space
 *
 * Soft-delete a space (admin). Personal spaces cannot be deleted.
 */
export const deleteSpaceMutation = (options?: Partial<Options<DeleteSpaceData>>): UseMutationOptions<DeleteSpaceResponse, DeleteSpaceError, Options<DeleteSpaceData>> => {
    const mutationOptions: UseMutationOptions<DeleteSpaceResponse, DeleteSpaceError, Options<DeleteSpaceData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await deleteSpace({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getSpaceQueryKey = (options: Options<GetSpaceData>) => createQueryKey('getSpace', options);

/**
 * Get Space
 *
 * Get a space (viewer+).
 */
export const getSpaceOptions = (options: Options<GetSpaceData>) => queryOptions<GetSpaceResponse, GetSpaceError, GetSpaceResponse, ReturnType<typeof getSpaceQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getSpace({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getSpaceQueryKey(options)
});

/**
 * Update Space
 *
 * Update space config (editor+).
 */
export const updateSpaceMutation = (options?: Partial<Options<UpdateSpaceData>>): UseMutationOptions<UpdateSpaceResponse, UpdateSpaceError, Options<UpdateSpaceData>> => {
    const mutationOptions: UseMutationOptions<UpdateSpaceResponse, UpdateSpaceError, Options<UpdateSpaceData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await updateSpace({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const listSpaceActivitiesQueryKey = (options: Options<ListSpaceActivitiesData>) => createQueryKey('listSpaceActivities', options);

/**
 * List Space Activities
 *
 * List a space's activity feed (viewer+).
 */
export const listSpaceActivitiesOptions = (options: Options<ListSpaceActivitiesData>) => queryOptions<ListSpaceActivitiesResponse, ListSpaceActivitiesError, ListSpaceActivitiesResponse, ReturnType<typeof listSpaceActivitiesQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await listSpaceActivities({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listSpaceActivitiesQueryKey(options)
});

export const listSpaceActivitiesInfiniteQueryKey = (options: Options<ListSpaceActivitiesData>): QueryKey<Options<ListSpaceActivitiesData>> => createQueryKey('listSpaceActivities', options, true);

/**
 * List Space Activities
 *
 * List a space's activity feed (viewer+).
 */
export const listSpaceActivitiesInfiniteOptions = (options: Options<ListSpaceActivitiesData>) => {
    const opts = infiniteQueryOptions<ListSpaceActivitiesResponse, ListSpaceActivitiesError, InfiniteData<ListSpaceActivitiesResponse>, QueryKey<Options<ListSpaceActivitiesData>>, number | Pick<QueryKey<Options<ListSpaceActivitiesData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<ListSpaceActivitiesData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                query: {
                    page: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await listSpaceActivities({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: listSpaceActivitiesInfiniteQueryKey(options)
    });
    return opts as Omit<typeof opts, 'initialData'>;
};

export const listSpaceConnectorsQueryKey = (options: Options<ListSpaceConnectorsData>) => createQueryKey('listSpaceConnectors', options);

/**
 * List Space Connectors
 *
 * The connectors in a space (viewer+). Members can use them while chatting in it.
 */
export const listSpaceConnectorsOptions = (options: Options<ListSpaceConnectorsData>) => queryOptions<ListSpaceConnectorsResponse, ListSpaceConnectorsError, ListSpaceConnectorsResponse, ReturnType<typeof listSpaceConnectorsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await listSpaceConnectors({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listSpaceConnectorsQueryKey(options)
});

/**
 * Add Space Connector
 *
 * Add a connector I can use to a space I edit.
 */
export const addSpaceConnectorMutation = (options?: Partial<Options<AddSpaceConnectorData>>): UseMutationOptions<AddSpaceConnectorResponse, AddSpaceConnectorError, Options<AddSpaceConnectorData>> => {
    const mutationOptions: UseMutationOptions<AddSpaceConnectorResponse, AddSpaceConnectorError, Options<AddSpaceConnectorData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await addSpaceConnector({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Remove Space Connector
 *
 * Take a connector out of the space (editor+).
 */
export const removeSpaceConnectorMutation = (options?: Partial<Options<RemoveSpaceConnectorData>>): UseMutationOptions<RemoveSpaceConnectorResponse, RemoveSpaceConnectorError, Options<RemoveSpaceConnectorData>> => {
    const mutationOptions: UseMutationOptions<RemoveSpaceConnectorResponse, RemoveSpaceConnectorError, Options<RemoveSpaceConnectorData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await removeSpaceConnector({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Update Space Connector
 *
 * Set this space's values for the connector's settings (editor+).
 */
export const updateSpaceConnectorMutation = (options?: Partial<Options<UpdateSpaceConnectorData>>): UseMutationOptions<UpdateSpaceConnectorResponse, UpdateSpaceConnectorError, Options<UpdateSpaceConnectorData>> => {
    const mutationOptions: UseMutationOptions<UpdateSpaceConnectorResponse, UpdateSpaceConnectorError, Options<UpdateSpaceConnectorData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await updateSpaceConnector({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Set Space Connector Skills
 *
 * Replace the flavor skills (editor+, and I must be able to share each skill I attach).
 */
export const setSpaceConnectorSkillsMutation = (options?: Partial<Options<SetSpaceConnectorSkillsData>>): UseMutationOptions<SetSpaceConnectorSkillsResponse, SetSpaceConnectorSkillsError, Options<SetSpaceConnectorSkillsData>> => {
    const mutationOptions: UseMutationOptions<SetSpaceConnectorSkillsResponse, SetSpaceConnectorSkillsError, Options<SetSpaceConnectorSkillsData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await setSpaceConnectorSkills({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const listSpaceDocumentsQueryKey = (options: Options<ListSpaceDocumentsData>) => createQueryKey('listSpaceDocuments', options);

/**
 * List Space Documents
 *
 * Documents shared with the space, newest first (viewer+).
 */
export const listSpaceDocumentsOptions = (options: Options<ListSpaceDocumentsData>) => queryOptions<ListSpaceDocumentsResponse, ListSpaceDocumentsError, ListSpaceDocumentsResponse, ReturnType<typeof listSpaceDocumentsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await listSpaceDocuments({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listSpaceDocumentsQueryKey(options)
});

/**
 * Share Space Document
 *
 * Share one version of a document from my chat with the space, as a snapshot (editor+).
 */
export const shareSpaceDocumentMutation = (options?: Partial<Options<ShareSpaceDocumentData>>): UseMutationOptions<ShareSpaceDocumentResponse, ShareSpaceDocumentError, Options<ShareSpaceDocumentData>> => {
    const mutationOptions: UseMutationOptions<ShareSpaceDocumentResponse, ShareSpaceDocumentError, Options<ShareSpaceDocumentData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await shareSpaceDocument({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Remove Space Document
 *
 * Unshare a document (the sharer or a space admin).
 */
export const removeSpaceDocumentMutation = (options?: Partial<Options<RemoveSpaceDocumentData>>): UseMutationOptions<RemoveSpaceDocumentResponse, RemoveSpaceDocumentError, Options<RemoveSpaceDocumentData>> => {
    const mutationOptions: UseMutationOptions<RemoveSpaceDocumentResponse, RemoveSpaceDocumentError, Options<RemoveSpaceDocumentData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await removeSpaceDocument({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Upload Space Files
 *
 * Upload files to the space's default knowledge base (editor+).
 *
 * Session-per-phase: validate with the request session, upload to blob with no
 * DB held, then persist records in a fresh short-lived session.
 */
export const uploadSpaceFilesMutation = (options?: Partial<Options<UploadSpaceFilesData>>): UseMutationOptions<UploadSpaceFilesResponse, UploadSpaceFilesError, Options<UploadSpaceFilesData>> => {
    const mutationOptions: UseMutationOptions<UploadSpaceFilesResponse, UploadSpaceFilesError, Options<UploadSpaceFilesData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await uploadSpaceFiles({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Delete Space File
 *
 * Delete a file from the space's default knowledge base (editor+).
 */
export const deleteSpaceFileMutation = (options?: Partial<Options<DeleteSpaceFileData>>): UseMutationOptions<DeleteSpaceFileResponse, DeleteSpaceFileError, Options<DeleteSpaceFileData>> => {
    const mutationOptions: UseMutationOptions<DeleteSpaceFileResponse, DeleteSpaceFileError, Options<DeleteSpaceFileData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await deleteSpaceFile({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getSpaceHubQueryKey = (options: Options<GetSpaceHubData>) => createQueryKey('getSpaceHub', options);

/**
 * Get Space Hub
 *
 * Aggregated hub payload for the space's main page (viewer+).
 */
export const getSpaceHubOptions = (options: Options<GetSpaceHubData>) => queryOptions<GetSpaceHubResponse, GetSpaceHubError, GetSpaceHubResponse, ReturnType<typeof getSpaceHubQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getSpaceHub({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getSpaceHubQueryKey(options)
});

export const listSpaceKnowledgeQueryKey = (options: Options<ListSpaceKnowledgeData>) => createQueryKey('listSpaceKnowledge', options);

/**
 * List Space Knowledge
 *
 * List files in the space's default knowledge base (viewer+).
 */
export const listSpaceKnowledgeOptions = (options: Options<ListSpaceKnowledgeData>) => queryOptions<ListSpaceKnowledgeResponse, ListSpaceKnowledgeError, ListSpaceKnowledgeResponse, ReturnType<typeof listSpaceKnowledgeQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await listSpaceKnowledge({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listSpaceKnowledgeQueryKey(options)
});

export const getSpaceMembersQueryKey = (options: Options<GetSpaceMembersData>) => createQueryKey('getSpaceMembers', options);

/**
 * Get Space Members
 *
 * List a space's user + team members and the caller's effective role.
 */
export const getSpaceMembersOptions = (options: Options<GetSpaceMembersData>) => queryOptions<GetSpaceMembersResponse, GetSpaceMembersError, GetSpaceMembersResponse, ReturnType<typeof getSpaceMembersQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getSpaceMembers({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getSpaceMembersQueryKey(options)
});

/**
 * Add Space Team Member
 *
 * Add (or update) a team's role on a space. Requires space admin.
 *
 * Granting a role to the special "Everyone" team makes the space available
 * org-wide at that role. Not allowed on personal spaces.
 */
export const addSpaceTeamMemberMutation = (options?: Partial<Options<AddSpaceTeamMemberData>>): UseMutationOptions<AddSpaceTeamMemberResponse, AddSpaceTeamMemberError, Options<AddSpaceTeamMemberData>> => {
    const mutationOptions: UseMutationOptions<AddSpaceTeamMemberResponse, AddSpaceTeamMemberError, Options<AddSpaceTeamMemberData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await addSpaceTeamMember({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Remove Space Team Member
 *
 * Remove a team member. Requires space admin (cannot remove the last admin).
 */
export const removeSpaceTeamMemberMutation = (options?: Partial<Options<RemoveSpaceTeamMemberData>>): UseMutationOptions<RemoveSpaceTeamMemberResponse, RemoveSpaceTeamMemberError, Options<RemoveSpaceTeamMemberData>> => {
    const mutationOptions: UseMutationOptions<RemoveSpaceTeamMemberResponse, RemoveSpaceTeamMemberError, Options<RemoveSpaceTeamMemberData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await removeSpaceTeamMember({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Update Space Team Member
 *
 * Change a team member's role. Requires space admin. 404 if not a member.
 */
export const updateSpaceTeamMemberMutation = (options?: Partial<Options<UpdateSpaceTeamMemberData>>): UseMutationOptions<UpdateSpaceTeamMemberResponse, UpdateSpaceTeamMemberError, Options<UpdateSpaceTeamMemberData>> => {
    const mutationOptions: UseMutationOptions<UpdateSpaceTeamMemberResponse, UpdateSpaceTeamMemberError, Options<UpdateSpaceTeamMemberData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await updateSpaceTeamMember({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Add Space User Member
 *
 * Add (or update) a user's role on a space. Requires space admin.
 */
export const addSpaceUserMemberMutation = (options?: Partial<Options<AddSpaceUserMemberData>>): UseMutationOptions<AddSpaceUserMemberResponse, AddSpaceUserMemberError, Options<AddSpaceUserMemberData>> => {
    const mutationOptions: UseMutationOptions<AddSpaceUserMemberResponse, AddSpaceUserMemberError, Options<AddSpaceUserMemberData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await addSpaceUserMember({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Remove Space User Member
 *
 * Remove a user member. Requires space admin (cannot remove the last admin).
 */
export const removeSpaceUserMemberMutation = (options?: Partial<Options<RemoveSpaceUserMemberData>>): UseMutationOptions<RemoveSpaceUserMemberResponse, RemoveSpaceUserMemberError, Options<RemoveSpaceUserMemberData>> => {
    const mutationOptions: UseMutationOptions<RemoveSpaceUserMemberResponse, RemoveSpaceUserMemberError, Options<RemoveSpaceUserMemberData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await removeSpaceUserMember({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Update Space User Member
 *
 * Change a user member's role. Requires space admin.
 */
export const updateSpaceUserMemberMutation = (options?: Partial<Options<UpdateSpaceUserMemberData>>): UseMutationOptions<UpdateSpaceUserMemberResponse, UpdateSpaceUserMemberError, Options<UpdateSpaceUserMemberData>> => {
    const mutationOptions: UseMutationOptions<UpdateSpaceUserMemberResponse, UpdateSpaceUserMemberError, Options<UpdateSpaceUserMemberData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await updateSpaceUserMember({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const listQuickActionsQueryKey = (options: Options<ListQuickActionsData>) => createQueryKey('listQuickActions', options);

/**
 * List Quick Actions
 *
 * List a space's quick actions (viewer+).
 */
export const listQuickActionsOptions = (options: Options<ListQuickActionsData>) => queryOptions<ListQuickActionsResponse, ListQuickActionsError, ListQuickActionsResponse, ReturnType<typeof listQuickActionsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await listQuickActions({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listQuickActionsQueryKey(options)
});

/**
 * Create Quick Action
 *
 * Create a quick action on a space (editor+).
 */
export const spacesCreateQuickActionMutation = (options?: Partial<Options<SpacesCreateQuickActionData>>): UseMutationOptions<SpacesCreateQuickActionResponse, SpacesCreateQuickActionError, Options<SpacesCreateQuickActionData>> => {
    const mutationOptions: UseMutationOptions<SpacesCreateQuickActionResponse, SpacesCreateQuickActionError, Options<SpacesCreateQuickActionData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await spacesCreateQuickAction({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Delete Quick Action
 *
 * Delete a quick action (editor+).
 */
export const spacesDeleteQuickActionMutation = (options?: Partial<Options<SpacesDeleteQuickActionData>>): UseMutationOptions<SpacesDeleteQuickActionResponse, SpacesDeleteQuickActionError, Options<SpacesDeleteQuickActionData>> => {
    const mutationOptions: UseMutationOptions<SpacesDeleteQuickActionResponse, SpacesDeleteQuickActionError, Options<SpacesDeleteQuickActionData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await spacesDeleteQuickAction({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Update Quick Action
 *
 * Update a quick action (editor+).
 */
export const spacesUpdateQuickActionMutation = (options?: Partial<Options<SpacesUpdateQuickActionData>>): UseMutationOptions<SpacesUpdateQuickActionResponse, SpacesUpdateQuickActionError, Options<SpacesUpdateQuickActionData>> => {
    const mutationOptions: UseMutationOptions<SpacesUpdateQuickActionResponse, SpacesUpdateQuickActionError, Options<SpacesUpdateQuickActionData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await spacesUpdateQuickAction({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const listSpaceResourcesQueryKey = (options: Options<ListSpaceResourcesData>) => createQueryKey('listSpaceResources', options);

/**
 * List Space Resources
 *
 * List a space's resources (optionally filtered to pinned / by type).
 */
export const listSpaceResourcesOptions = (options: Options<ListSpaceResourcesData>) => queryOptions<ListSpaceResourcesResponse, ListSpaceResourcesError, ListSpaceResourcesResponse, ReturnType<typeof listSpaceResourcesQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await listSpaceResources({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listSpaceResourcesQueryKey(options)
});

/**
 * Add Space Resource
 *
 * Attach a resource to a space (editor+).
 */
export const addSpaceResourceMutation = (options?: Partial<Options<AddSpaceResourceData>>): UseMutationOptions<AddSpaceResourceResponse, AddSpaceResourceError, Options<AddSpaceResourceData>> => {
    const mutationOptions: UseMutationOptions<AddSpaceResourceResponse, AddSpaceResourceError, Options<AddSpaceResourceData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await addSpaceResource({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Reorder Space Resources
 *
 * Bulk-reorder a space's resources (editor+).
 */
export const reorderSpaceResourcesMutation = (options?: Partial<Options<ReorderSpaceResourcesData>>): UseMutationOptions<ReorderSpaceResourcesResponse, ReorderSpaceResourcesError, Options<ReorderSpaceResourcesData>> => {
    const mutationOptions: UseMutationOptions<ReorderSpaceResourcesResponse, ReorderSpaceResourcesError, Options<ReorderSpaceResourcesData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await reorderSpaceResources({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Remove Space Resource
 *
 * Remove a resource from a space (editor+).
 */
export const removeSpaceResourceMutation = (options?: Partial<Options<RemoveSpaceResourceData>>): UseMutationOptions<RemoveSpaceResourceResponse, RemoveSpaceResourceError, Options<RemoveSpaceResourceData>> => {
    const mutationOptions: UseMutationOptions<RemoveSpaceResourceResponse, RemoveSpaceResourceError, Options<RemoveSpaceResourceData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await removeSpaceResource({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Update Space Resource
 *
 * Update a resource's pin state / order (editor+).
 */
export const updateSpaceResourceMutation = (options?: Partial<Options<UpdateSpaceResourceData>>): UseMutationOptions<UpdateSpaceResourceResponse, UpdateSpaceResourceError, Options<UpdateSpaceResourceData>> => {
    const mutationOptions: UseMutationOptions<UpdateSpaceResourceResponse, UpdateSpaceResourceError, Options<UpdateSpaceResourceData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await updateSpaceResource({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Remove Space Access
 *
 * Take the space's access away (target admins or a space admin). The item stays shared.
 */
export const removeSpaceAccessMutation = (options?: Partial<Options<RemoveSpaceAccessData>>): UseMutationOptions<RemoveSpaceAccessResponse, RemoveSpaceAccessError, Options<RemoveSpaceAccessData>> => {
    const mutationOptions: UseMutationOptions<RemoveSpaceAccessResponse, RemoveSpaceAccessError, Options<RemoveSpaceAccessData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await removeSpaceAccess({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Give Space Access
 *
 * Give every space member access to the item's agent, data source or app.
 *
 * Needs admin on the target and editor on the space. Shares the item too.
 */
export const giveSpaceAccessMutation = (options?: Partial<Options<GiveSpaceAccessData>>): UseMutationOptions<GiveSpaceAccessResponse, GiveSpaceAccessError, Options<GiveSpaceAccessData>> => {
    const mutationOptions: UseMutationOptions<GiveSpaceAccessResponse, GiveSpaceAccessError, Options<GiveSpaceAccessData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await giveSpaceAccess({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const spaceAccessImpactQueryKey = (options: Options<SpaceAccessImpactData>) => createQueryKey('spaceAccessImpact', options);

/**
 * Space Access Impact
 *
 * Which members can't use the item's target without the space's access, and why (advisory, editor+).
 */
export const spaceAccessImpactOptions = (options: Options<SpaceAccessImpactData>) => queryOptions<SpaceAccessImpactResponse2, SpaceAccessImpactError, SpaceAccessImpactResponse2, ReturnType<typeof spaceAccessImpactQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await spaceAccessImpact({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: spaceAccessImpactQueryKey(options)
});

export const listSpaceSharedChatsQueryKey = (options: Options<ListSpaceSharedChatsData>) => createQueryKey('listSpaceSharedChats', options);

/**
 * List Space Shared Chats
 *
 * Chats their owners shared with everyone in the space, newest first (viewer+).
 */
export const listSpaceSharedChatsOptions = (options: Options<ListSpaceSharedChatsData>) => queryOptions<ListSpaceSharedChatsResponse, ListSpaceSharedChatsError, ListSpaceSharedChatsResponse, ReturnType<typeof listSpaceSharedChatsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await listSpaceSharedChats({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listSpaceSharedChatsQueryKey(options)
});

export const listTeamsQueryKey = (options?: Options<ListTeamsData>) => createQueryKey('listTeams', options);

/**
 * List Teams
 *
 * List teams the user belongs to.
 *
 * Platform admins see all teams.
 */
export const listTeamsOptions = (options?: Options<ListTeamsData>) => queryOptions<ListTeamsResponse, ListTeamsError, ListTeamsResponse, ReturnType<typeof listTeamsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await listTeams({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listTeamsQueryKey(options)
});

export const listTeamsInfiniteQueryKey = (options?: Options<ListTeamsData>): QueryKey<Options<ListTeamsData>> => createQueryKey('listTeams', options, true);

/**
 * List Teams
 *
 * List teams the user belongs to.
 *
 * Platform admins see all teams.
 */
export const listTeamsInfiniteOptions = (options?: Options<ListTeamsData>) => {
    const opts = infiniteQueryOptions<ListTeamsResponse, ListTeamsError, InfiniteData<ListTeamsResponse>, QueryKey<Options<ListTeamsData>>, number | Pick<QueryKey<Options<ListTeamsData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<ListTeamsData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                query: {
                    page: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await listTeams({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: listTeamsInfiniteQueryKey(options)
    });
    return opts as Omit<typeof opts, 'initialData'>;
};

export const listToolsQueryKey = (options?: Options<ListToolsData>) => createQueryKey('listTools', options);

/**
 * List Tools
 *
 * List tools accessible to the user.
 *
 * Returns platform-wide tools and tools from user's teams.
 */
export const listToolsOptions = (options?: Options<ListToolsData>) => queryOptions<ListToolsResponse, ListToolsError, ListToolsResponse, ReturnType<typeof listToolsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await listTools({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listToolsQueryKey(options)
});

export const listToolsInfiniteQueryKey = (options?: Options<ListToolsData>): QueryKey<Options<ListToolsData>> => createQueryKey('listTools', options, true);

/**
 * List Tools
 *
 * List tools accessible to the user.
 *
 * Returns platform-wide tools and tools from user's teams.
 */
export const listToolsInfiniteOptions = (options?: Options<ListToolsData>) => {
    const opts = infiniteQueryOptions<ListToolsResponse, ListToolsError, InfiniteData<ListToolsResponse>, QueryKey<Options<ListToolsData>>, number | Pick<QueryKey<Options<ListToolsData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<ListToolsData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                query: {
                    page: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await listTools({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: listToolsInfiniteQueryKey(options)
    });
    return opts as Omit<typeof opts, 'initialData'>;
};

export const getUsageByUserQueryKey = (options?: Options<GetUsageByUserData>) => createQueryKey('getUsageByUser', options);

/**
 * Get Usage By User
 *
 * Get per-user spend breakdown (admin only).
 */
export const getUsageByUserOptions = (options?: Options<GetUsageByUserData>) => queryOptions<GetUsageByUserResponse, GetUsageByUserError, GetUsageByUserResponse, ReturnType<typeof getUsageByUserQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getUsageByUser({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getUsageByUserQueryKey(options)
});

export const getUsageByUserInfiniteQueryKey = (options?: Options<GetUsageByUserData>): QueryKey<Options<GetUsageByUserData>> => createQueryKey('getUsageByUser', options, true);

/**
 * Get Usage By User
 *
 * Get per-user spend breakdown (admin only).
 */
export const getUsageByUserInfiniteOptions = (options?: Options<GetUsageByUserData>) => {
    const opts = infiniteQueryOptions<GetUsageByUserResponse, GetUsageByUserError, InfiniteData<GetUsageByUserResponse>, QueryKey<Options<GetUsageByUserData>>, number | Pick<QueryKey<Options<GetUsageByUserData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<GetUsageByUserData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                query: {
                    offset: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await getUsageByUser({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getUsageByUserInfiniteQueryKey(options)
    });
    return opts as Omit<typeof opts, 'initialData'>;
};

export const getMySpendQueryKey = (options?: Options<GetMySpendData>) => createQueryKey('getMySpend', options);

/**
 * Get My Spend
 *
 * Get the current user's AI spend for the current month and trend.
 */
export const getMySpendOptions = (options?: Options<GetMySpendData>) => queryOptions<GetMySpendResponse, GetMySpendError, GetMySpendResponse, ReturnType<typeof getMySpendQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getMySpend({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getMySpendQueryKey(options)
});

/**
 * Regenerate Webhook Secret
 *
 * Regenerate the HMAC secret for a webhook.  Returns the new secret (shown once).
 */
export const regenerateWebhookSecretMutation = (options?: Partial<Options<RegenerateWebhookSecretData>>): UseMutationOptions<RegenerateWebhookSecretResponse, RegenerateWebhookSecretError, Options<RegenerateWebhookSecretData>> => {
    const mutationOptions: UseMutationOptions<RegenerateWebhookSecretResponse, RegenerateWebhookSecretError, Options<RegenerateWebhookSecretData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await regenerateWebhookSecret({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};
